var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));

// src/index.ts
var index_exports = {};
__export(index_exports, {
  Accordion: () => Accordion,
  AccordionContent: () => AccordionContent,
  AccordionItem: () => AccordionItem,
  AccordionTrigger: () => AccordionTrigger,
  AgGridReact: () => AgGridReact,
  AlertDialog: () => AlertDialog,
  AlertDialogAction: () => AlertDialogAction,
  AlertDialogCancel: () => AlertDialogCancel,
  AlertDialogContent: () => AlertDialogContent,
  AlertDialogDescription: () => AlertDialogDescription,
  AlertDialogFooter: () => AlertDialogFooter,
  AlertDialogHeader: () => AlertDialogHeader,
  AlertDialogOverlay: () => AlertDialogOverlay,
  AlertDialogPortal: () => AlertDialogPortal,
  AlertDialogTitle: () => AlertDialogTitle,
  AlertDialogTrigger: () => AlertDialogTrigger,
  AutoComplete: () => AutoComplete,
  Avatar: () => Avatar,
  AvatarFallback: () => AvatarFallback,
  AvatarImage: () => AvatarImage,
  AverageLine: () => AverageLine,
  Badge: () => Badge,
  BrandLoader: () => BrandLoader,
  Breadcrumb: () => Breadcrumb,
  BreadcrumbEllipsis: () => BreadcrumbEllipsis,
  BreadcrumbItem: () => BreadcrumbItem,
  BreadcrumbLink: () => BreadcrumbLink,
  BreadcrumbList: () => BreadcrumbList,
  BreadcrumbPage: () => BreadcrumbPage,
  BreadcrumbSeparator: () => BreadcrumbSeparator,
  Button: () => Button,
  Calendar: () => Calendar,
  Callout: () => Callout,
  CalloutIcon: () => CalloutIcon,
  CalloutTitle: () => CalloutTitle,
  Card: () => Card,
  CardAction: () => CardAction,
  CardContent: () => CardContent,
  CardDescription: () => CardDescription,
  CardFooter: () => CardFooter,
  CardHeader: () => CardHeader,
  CardTitle: () => CardTitle,
  Chart: () => Chart,
  ChartCustomTooltip: () => ChartCustomTooltip,
  Checkbox: () => Checkbox,
  Collapsible: () => Collapsible,
  CollapsibleContent: () => CollapsibleContent,
  CollapsibleTrigger: () => CollapsibleTrigger,
  Combobox: () => Combobox,
  Command: () => Command,
  CommandDialog: () => CommandDialog,
  CommandEmpty: () => CommandEmpty,
  CommandGroup: () => CommandGroup,
  CommandInput: () => CommandInput,
  CommandItem: () => CommandItem,
  CommandList: () => CommandList,
  CommandSeparator: () => CommandSeparator,
  CommandShortcut: () => CommandShortcut,
  CopyToClipboard: () => CopyToClipboard,
  DATETIME_HINT: () => DATETIME_HINT,
  DATE_HINT: () => DATE_HINT,
  DatePicker: () => DatePicker,
  Dialog: () => Dialog,
  DialogClose: () => DialogClose,
  DialogContent: () => DialogContent,
  DialogDescription: () => DialogDescription,
  DialogFooter: () => DialogFooter,
  DialogHeader: () => DialogHeader,
  DialogOverlay: () => DialogOverlay,
  DialogPortal: () => DialogPortal,
  DialogTitle: () => DialogTitle,
  DialogTrigger: () => DialogTrigger,
  DropdownMenu: () => DropdownMenu,
  DropdownMenuCheckboxItem: () => DropdownMenuCheckboxItem,
  DropdownMenuContent: () => DropdownMenuContent,
  DropdownMenuGroup: () => DropdownMenuGroup,
  DropdownMenuItem: () => DropdownMenuItem,
  DropdownMenuLabel: () => DropdownMenuLabel,
  DropdownMenuPortal: () => DropdownMenuPortal,
  DropdownMenuRadioGroup: () => DropdownMenuRadioGroup,
  DropdownMenuRadioItem: () => DropdownMenuRadioItem,
  DropdownMenuSeparator: () => DropdownMenuSeparator,
  DropdownMenuShortcut: () => DropdownMenuShortcut,
  DropdownMenuSub: () => DropdownMenuSub,
  DropdownMenuSubContent: () => DropdownMenuSubContent,
  DropdownMenuSubTrigger: () => DropdownMenuSubTrigger,
  DropdownMenuTrigger: () => DropdownMenuTrigger,
  Dropzone: () => Dropzone,
  DropzoneContent: () => DropzoneContent,
  DropzoneEmptyState: () => DropzoneEmptyState,
  EmptyState: () => EmptyState,
  Form: () => Form,
  FormCheckboxGroupItem: () => FormCheckboxGroupItem,
  FormControl: () => FormControl,
  FormDescription: () => FormDescription,
  FormField: () => FormField,
  FormFieldReadOnly: () => FormFieldReadOnly,
  FormItem: () => FormItem,
  FormLabel: () => FormLabel,
  FormMessage: () => FormMessage,
  FormRadioGroupHorizontalItem: () => FormRadioGroupHorizontalItem,
  HoverCard: () => HoverCard,
  HoverCardContent: () => HoverCardContent,
  HoverCardTrigger: () => HoverCardTrigger,
  Icon: () => Icon,
  Input: () => Input,
  InputAddon: () => InputAddon,
  Label: () => Label2,
  LicenseManager: () => LicenseManager,
  Logo: () => Logo,
  ModeToggle: () => ModeToggle,
  MoneyCell: () => money_cell_default,
  MultiSelect: () => MultiSelect,
  MultiSelectBadge: () => MultiSelectBadge2,
  NavigationMenu: () => NavigationMenu,
  NavigationMenuContent: () => NavigationMenuContent,
  NavigationMenuIndicator: () => NavigationMenuIndicator,
  NavigationMenuItem: () => NavigationMenuItem,
  NavigationMenuLink: () => NavigationMenuLink,
  NavigationMenuList: () => NavigationMenuList,
  NavigationMenuTrigger: () => NavigationMenuTrigger,
  NavigationMenuViewport: () => NavigationMenuViewport,
  Pagination: () => Pagination,
  PaginationCompact: () => PaginationCompact,
  PaginationContent: () => PaginationContent,
  PaginationEllipsis: () => PaginationEllipsis,
  PaginationItem: () => PaginationItem,
  PaginationLink: () => PaginationLink,
  PaginationNext: () => PaginationNext,
  PaginationPrevious: () => PaginationPrevious,
  Popover: () => Popover,
  PopoverAnchor: () => PopoverAnchor,
  PopoverContent: () => PopoverContent,
  PopoverTrigger: () => PopoverTrigger,
  Progress: () => Progress,
  RadioGroup: () => RadioGroup2,
  RadioGroupItem: () => RadioGroupItem,
  Ratings: () => Ratings,
  ScrollArea: () => ScrollArea,
  ScrollBar: () => ScrollBar,
  Select: () => Select,
  SelectContent: () => SelectContent,
  SelectGroup: () => SelectGroup,
  SelectItem: () => SelectItem,
  SelectLabel: () => SelectLabel,
  SelectScrollDownButton: () => SelectScrollDownButton,
  SelectScrollUpButton: () => SelectScrollUpButton,
  SelectSeparator: () => SelectSeparator,
  SelectTrigger: () => SelectTrigger,
  SelectValue: () => SelectValue,
  Separator: () => Separator3,
  Sheet: () => Sheet,
  SheetClose: () => SheetClose,
  SheetContent: () => SheetContent,
  SheetDescription: () => SheetDescription,
  SheetFooter: () => SheetFooter,
  SheetHeader: () => SheetHeader,
  SheetOverlay: () => SheetOverlay,
  SheetPortal: () => SheetPortal,
  SheetTitle: () => SheetTitle,
  SheetTrigger: () => SheetTrigger,
  Skeleton: () => Skeleton,
  Sonner: () => Sonner,
  Stars: () => Stars,
  Status: () => Status,
  StatusIndicator: () => StatusIndicator,
  StatusLabel: () => StatusLabel,
  Switch: () => Switch,
  Table: () => Table,
  TableBody: () => TableBody,
  TableCaption: () => TableCaption,
  TableCell: () => TableCell,
  TableFooter: () => TableFooter,
  TableHead: () => TableHead,
  TableHeader: () => TableHeader,
  TableRow: () => TableRow,
  Tabs: () => Tabs,
  TabsContent: () => TabsContent,
  TabsList: () => TabsList,
  TabsTrigger: () => TabsTrigger,
  Textarea: () => Textarea,
  ThemeProvider: () => ThemeProvider,
  Toast: () => Toast,
  ToastAction: () => ToastAction,
  ToastClose: () => ToastClose,
  ToastDescription: () => ToastDescription,
  ToastProvider: () => ToastProvider,
  ToastTitle: () => ToastTitle,
  ToastViewport: () => ToastViewport,
  Toaster: () => Toaster2,
  Toggle: () => Toggle,
  ToggleGroup: () => ToggleGroup,
  ToggleGroupItem: () => ToggleGroupItem,
  Tooltip: () => Tooltip,
  TooltipContent: () => TooltipContent,
  TooltipProvider: () => TooltipProvider,
  TooltipTrigger: () => TooltipTrigger,
  agColIdSchema: () => agColIdSchema,
  agFilterModelSchema: () => agFilterModelSchema,
  agSortModelItemSchema: () => agSortModelItemSchema,
  badgeVariants: () => badgeVariants,
  buttonVariants: () => buttonVariants,
  cn: () => cn,
  cva: () => cva3,
  debug: () => debug,
  defaultInitials: () => defaultInitials,
  format: () => format,
  getRandomColor: () => getRandomColor,
  isDateFilterModel: () => isDateFilterModel,
  isGroupOptions: () => isRequiredGroupOptions,
  isIMultiFilterModel: () => isIMultiFilterModel,
  isNumberFilterModel: () => isNumberFilterModel,
  isOption: () => isRequiredOption,
  isSetFilterModel: () => isSetFilterModel,
  isTextFilterModel: () => isTextFilterModel,
  multiSelectValueAsString: () => multiSelectValueAsString,
  navigationMenuTriggerStyle: () => navigationMenuTriggerStyle,
  reducer: () => reducer,
  selectedOptionTypesAsString: () => selectedOptionTypesAsString,
  sonner: () => sonner,
  tabTriggerActiveClass: () => tabTriggerActiveClass,
  toast: () => toast,
  toggleVariants: () => toggleVariants,
  useFormField: () => useFormField,
  useMultiSelect: () => useMultiSelect,
  useSeasonalLogo: () => useSeasonalLogo,
  useTheme: () => useTheme,
  useToast: () => useToast
});
import "@uturn/design-tokens/base.css";

// src/components/index.ts
var components_exports = {};
__export(components_exports, {
  Accordion: () => Accordion,
  AccordionContent: () => AccordionContent,
  AccordionItem: () => AccordionItem,
  AccordionTrigger: () => AccordionTrigger,
  AgGridReact: () => AgGridReact,
  AlertDialog: () => AlertDialog,
  AlertDialogAction: () => AlertDialogAction,
  AlertDialogCancel: () => AlertDialogCancel,
  AlertDialogContent: () => AlertDialogContent,
  AlertDialogDescription: () => AlertDialogDescription,
  AlertDialogFooter: () => AlertDialogFooter,
  AlertDialogHeader: () => AlertDialogHeader,
  AlertDialogOverlay: () => AlertDialogOverlay,
  AlertDialogPortal: () => AlertDialogPortal,
  AlertDialogTitle: () => AlertDialogTitle,
  AlertDialogTrigger: () => AlertDialogTrigger,
  AutoComplete: () => AutoComplete,
  Avatar: () => Avatar,
  AvatarFallback: () => AvatarFallback,
  AvatarImage: () => AvatarImage,
  AverageLine: () => AverageLine,
  Badge: () => Badge,
  BrandLoader: () => BrandLoader,
  Breadcrumb: () => Breadcrumb,
  BreadcrumbEllipsis: () => BreadcrumbEllipsis,
  BreadcrumbItem: () => BreadcrumbItem,
  BreadcrumbLink: () => BreadcrumbLink,
  BreadcrumbList: () => BreadcrumbList,
  BreadcrumbPage: () => BreadcrumbPage,
  BreadcrumbSeparator: () => BreadcrumbSeparator,
  Button: () => Button,
  Calendar: () => Calendar,
  Callout: () => Callout,
  CalloutIcon: () => CalloutIcon,
  CalloutTitle: () => CalloutTitle,
  Card: () => Card,
  CardAction: () => CardAction,
  CardContent: () => CardContent,
  CardDescription: () => CardDescription,
  CardFooter: () => CardFooter,
  CardHeader: () => CardHeader,
  CardTitle: () => CardTitle,
  Chart: () => Chart,
  ChartCustomTooltip: () => ChartCustomTooltip,
  Checkbox: () => Checkbox,
  Collapsible: () => Collapsible,
  CollapsibleContent: () => CollapsibleContent,
  CollapsibleTrigger: () => CollapsibleTrigger,
  Combobox: () => Combobox,
  Command: () => Command,
  CommandDialog: () => CommandDialog,
  CommandEmpty: () => CommandEmpty,
  CommandGroup: () => CommandGroup,
  CommandInput: () => CommandInput,
  CommandItem: () => CommandItem,
  CommandList: () => CommandList,
  CommandSeparator: () => CommandSeparator,
  CommandShortcut: () => CommandShortcut,
  CopyToClipboard: () => CopyToClipboard,
  DATETIME_HINT: () => DATETIME_HINT,
  DATE_HINT: () => DATE_HINT,
  DatePicker: () => DatePicker,
  Dialog: () => Dialog,
  DialogClose: () => DialogClose,
  DialogContent: () => DialogContent,
  DialogDescription: () => DialogDescription,
  DialogFooter: () => DialogFooter,
  DialogHeader: () => DialogHeader,
  DialogOverlay: () => DialogOverlay,
  DialogPortal: () => DialogPortal,
  DialogTitle: () => DialogTitle,
  DialogTrigger: () => DialogTrigger,
  DropdownMenu: () => DropdownMenu,
  DropdownMenuCheckboxItem: () => DropdownMenuCheckboxItem,
  DropdownMenuContent: () => DropdownMenuContent,
  DropdownMenuGroup: () => DropdownMenuGroup,
  DropdownMenuItem: () => DropdownMenuItem,
  DropdownMenuLabel: () => DropdownMenuLabel,
  DropdownMenuPortal: () => DropdownMenuPortal,
  DropdownMenuRadioGroup: () => DropdownMenuRadioGroup,
  DropdownMenuRadioItem: () => DropdownMenuRadioItem,
  DropdownMenuSeparator: () => DropdownMenuSeparator,
  DropdownMenuShortcut: () => DropdownMenuShortcut,
  DropdownMenuSub: () => DropdownMenuSub,
  DropdownMenuSubContent: () => DropdownMenuSubContent,
  DropdownMenuSubTrigger: () => DropdownMenuSubTrigger,
  DropdownMenuTrigger: () => DropdownMenuTrigger,
  Dropzone: () => Dropzone,
  DropzoneContent: () => DropzoneContent,
  DropzoneEmptyState: () => DropzoneEmptyState,
  EmptyState: () => EmptyState,
  Form: () => Form,
  FormCheckboxGroupItem: () => FormCheckboxGroupItem,
  FormControl: () => FormControl,
  FormDescription: () => FormDescription,
  FormField: () => FormField,
  FormFieldReadOnly: () => FormFieldReadOnly,
  FormItem: () => FormItem,
  FormLabel: () => FormLabel,
  FormMessage: () => FormMessage,
  FormRadioGroupHorizontalItem: () => FormRadioGroupHorizontalItem,
  HoverCard: () => HoverCard,
  HoverCardContent: () => HoverCardContent,
  HoverCardTrigger: () => HoverCardTrigger,
  Icon: () => Icon,
  Input: () => Input,
  InputAddon: () => InputAddon,
  Label: () => Label2,
  LicenseManager: () => LicenseManager,
  Logo: () => Logo,
  ModeToggle: () => ModeToggle,
  MoneyCell: () => money_cell_default,
  MultiSelect: () => MultiSelect,
  MultiSelectBadge: () => MultiSelectBadge2,
  NavigationMenu: () => NavigationMenu,
  NavigationMenuContent: () => NavigationMenuContent,
  NavigationMenuIndicator: () => NavigationMenuIndicator,
  NavigationMenuItem: () => NavigationMenuItem,
  NavigationMenuLink: () => NavigationMenuLink,
  NavigationMenuList: () => NavigationMenuList,
  NavigationMenuTrigger: () => NavigationMenuTrigger,
  NavigationMenuViewport: () => NavigationMenuViewport,
  Pagination: () => Pagination,
  PaginationCompact: () => PaginationCompact,
  PaginationContent: () => PaginationContent,
  PaginationEllipsis: () => PaginationEllipsis,
  PaginationItem: () => PaginationItem,
  PaginationLink: () => PaginationLink,
  PaginationNext: () => PaginationNext,
  PaginationPrevious: () => PaginationPrevious,
  Popover: () => Popover,
  PopoverAnchor: () => PopoverAnchor,
  PopoverContent: () => PopoverContent,
  PopoverTrigger: () => PopoverTrigger,
  Progress: () => Progress,
  RadioGroup: () => RadioGroup2,
  RadioGroupItem: () => RadioGroupItem,
  Ratings: () => Ratings,
  ScrollArea: () => ScrollArea,
  ScrollBar: () => ScrollBar,
  Select: () => Select,
  SelectContent: () => SelectContent,
  SelectGroup: () => SelectGroup,
  SelectItem: () => SelectItem,
  SelectLabel: () => SelectLabel,
  SelectScrollDownButton: () => SelectScrollDownButton,
  SelectScrollUpButton: () => SelectScrollUpButton,
  SelectSeparator: () => SelectSeparator,
  SelectTrigger: () => SelectTrigger,
  SelectValue: () => SelectValue,
  Separator: () => Separator3,
  Sheet: () => Sheet,
  SheetClose: () => SheetClose,
  SheetContent: () => SheetContent,
  SheetDescription: () => SheetDescription,
  SheetFooter: () => SheetFooter,
  SheetHeader: () => SheetHeader,
  SheetOverlay: () => SheetOverlay,
  SheetPortal: () => SheetPortal,
  SheetTitle: () => SheetTitle,
  SheetTrigger: () => SheetTrigger,
  Skeleton: () => Skeleton,
  Sonner: () => Sonner,
  Stars: () => Stars,
  Status: () => Status,
  StatusIndicator: () => StatusIndicator,
  StatusLabel: () => StatusLabel,
  Switch: () => Switch,
  Table: () => Table,
  TableBody: () => TableBody,
  TableCaption: () => TableCaption,
  TableCell: () => TableCell,
  TableFooter: () => TableFooter,
  TableHead: () => TableHead,
  TableHeader: () => TableHeader,
  TableRow: () => TableRow,
  Tabs: () => Tabs,
  TabsContent: () => TabsContent,
  TabsList: () => TabsList,
  TabsTrigger: () => TabsTrigger,
  Textarea: () => Textarea,
  ThemeProvider: () => ThemeProvider,
  Toast: () => Toast,
  ToastAction: () => ToastAction,
  ToastClose: () => ToastClose,
  ToastDescription: () => ToastDescription,
  ToastProvider: () => ToastProvider,
  ToastTitle: () => ToastTitle,
  ToastViewport: () => ToastViewport,
  Toaster: () => Toaster2,
  Toggle: () => Toggle,
  ToggleGroup: () => ToggleGroup,
  ToggleGroupItem: () => ToggleGroupItem,
  Tooltip: () => Tooltip,
  TooltipContent: () => TooltipContent,
  TooltipProvider: () => TooltipProvider,
  TooltipTrigger: () => TooltipTrigger,
  agColIdSchema: () => agColIdSchema,
  agFilterModelSchema: () => agFilterModelSchema,
  agSortModelItemSchema: () => agSortModelItemSchema,
  badgeVariants: () => badgeVariants,
  buttonVariants: () => buttonVariants,
  cva: () => cva3,
  debug: () => debug,
  format: () => format,
  isDateFilterModel: () => isDateFilterModel,
  isGroupOptions: () => isRequiredGroupOptions,
  isIMultiFilterModel: () => isIMultiFilterModel,
  isNumberFilterModel: () => isNumberFilterModel,
  isOption: () => isRequiredOption,
  isSetFilterModel: () => isSetFilterModel,
  isTextFilterModel: () => isTextFilterModel,
  multiSelectValueAsString: () => multiSelectValueAsString,
  navigationMenuTriggerStyle: () => navigationMenuTriggerStyle,
  reducer: () => reducer,
  selectedOptionTypesAsString: () => selectedOptionTypesAsString,
  sonner: () => sonner,
  tabTriggerActiveClass: () => tabTriggerActiveClass,
  toast: () => toast,
  toggleVariants: () => toggleVariants,
  useFormField: () => useFormField,
  useMultiSelect: () => useMultiSelect,
  useTheme: () => useTheme,
  useToast: () => useToast
});

// src/components/accordion/accordion.tsx
import * as AccordionPrimitive from "@radix-ui/react-accordion";

// src/utils/index.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}
function defaultInitials(name, { maxInitials = 2 }) {
  return name.split(/\s/).map((part) => part.substring(0, 1).toUpperCase()).filter((v) => !!v).slice(0, maxInitials).join("").toUpperCase();
}
var colors = [
  "#A62A21",
  "#7e3794",
  "#0B51C1",
  "#3A6024",
  "#A81563",
  "#B3003C"
];
function _stringAsciiPRNG(value, m) {
  const charCodes = [...value].map((letter) => letter.charCodeAt(0));
  const len = charCodes.length;
  const a = len % (m - 1) + 1;
  const c = charCodes.reduce((current, next) => current + next) % m;
  let random = charCodes[0] % m;
  for (let i = 0; i < len; i++) random = (a * random + c) % m;
  return random;
}
function getRandomColor(value) {
  if (!value) {
    return "red-500";
  }
  const colorIndex = _stringAsciiPRNG(value, colors.length);
  return colors[colorIndex];
}

// src/components/accordion/accordion.tsx
import { ChevronDown } from "lucide-react";
import * as React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Accordion = AccordionPrimitive.Root;
var AccordionItem = React.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx(
    AccordionPrimitive.Item,
    __spreadValues({
      ref,
      className: cn("border-b", className)
    }, props)
  );
});
AccordionItem.displayName = "AccordionItem";
var AccordionTrigger = React.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsx(AccordionPrimitive.Header, { className: "flex", children: /* @__PURE__ */ jsxs(
    AccordionPrimitive.Trigger,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180",
        className
      )
    }, props), {
      children: [
        children,
        /* @__PURE__ */ jsx(ChevronDown, { className: "h-4 w-4 shrink-0 transition-transform duration-200" })
      ]
    })
  ) });
});
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;
var AccordionContent = React.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsx(
    AccordionPrimitive.Content,
    __spreadProps(__spreadValues({
      ref,
      className: "overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    }, props), {
      children: /* @__PURE__ */ jsx("div", { className: cn("pb-4 pt-0", className), children })
    })
  );
});
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

// src/components/alert-dialog/alert-dialog.tsx
import * as AlertDialogPrimitive from "@radix-ui/react-alert-dialog";

// src/components/button/button.tsx
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import * as React2 from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90 [.theme-uturn_&]:hover:bg-primary-hover",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-foreground bg-transparent hover:underline",
        input: "justify-between border border-input bg-background font-normal text-foreground [.theme-uturn_&]:border-foreground aria-[invalid=true]:border-destructive",
        secondary: "border border-neutral-300 bg-white text-secondary-foreground hover:bg-neutral-200 dark:border-neutral-700 dark:bg-neutral-800 dark:hover:bg-neutral-700",
        black: "bg-black text-primary hover:bg-black/80",
        ghost: "hover:bg-accent hover:text-accent-foreground [.theme-uturn_&]:hover:bg-primary [.theme-uturn_&]:hover:text-primary-foreground",
        link: "link rounded-none p-0"
      },
      size: {
        default: "h-12 px-4 py-2",
        xs: "h-8 px-2 py-2 text-sm",
        sm: "h-9 rounded-md px-3",
        lg: "h-14 rounded-md px-8 text-base",
        icon: "h-12 w-12"
      },
      customRadius: {
        true: "",
        false: ""
      }
    },
    compoundVariants: [
      {
        variant: ["default", "destructive", "outline", "secondary", "black"],
        size: ["default", "xs", "sm", "lg"],
        customRadius: false,
        class: "[.theme-uturn_&]:rounded-none [.theme-uturn_&]:rounded-tr-2xl"
      }
    ],
    defaultVariants: {
      variant: "default",
      size: "default",
      customRadius: false
    }
  }
);
var Button = React2.forwardRef(
  (_a, ref) => {
    var _b = _a, { className, variant, size, customRadius, asChild = false } = _b, props = __objRest(_b, ["className", "variant", "size", "customRadius", "asChild"]);
    const Comp = asChild ? Slot : "button";
    return /* @__PURE__ */ jsx2(
      Comp,
      __spreadValues({
        className: cn(buttonVariants({ variant, size, customRadius, className })),
        ref
      }, props)
    );
  }
);
Button.displayName = "Button";

// src/components/alert-dialog/alert-dialog.tsx
import * as React3 from "react";
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var AlertDialog = AlertDialogPrimitive.Root;
var AlertDialogTrigger = AlertDialogPrimitive.Trigger;
var AlertDialogPortal = AlertDialogPrimitive.Portal;
var AlertDialogOverlay = React3.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx3(
    AlertDialogPrimitive.Overlay,
    __spreadProps(__spreadValues({
      className: cn(
        "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        className
      )
    }, props), {
      ref
    })
  );
});
AlertDialogOverlay.displayName = AlertDialogPrimitive.Overlay.displayName;
var AlertDialogContent = React3.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsxs2(AlertDialogPortal, { children: [
    /* @__PURE__ */ jsx3(AlertDialogOverlay, {}),
    /* @__PURE__ */ jsx3(
      AlertDialogPrimitive.Content,
      __spreadValues({
        ref,
        className: cn(
          "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-card p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
          className
        )
      }, props)
    )
  ] });
});
AlertDialogContent.displayName = AlertDialogPrimitive.Content.displayName;
var AlertDialogHeader = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx3(
    "div",
    __spreadValues({
      className: cn(
        "flex flex-col space-y-2 text-center sm:text-left",
        className
      )
    }, props)
  );
};
AlertDialogHeader.displayName = "AlertDialogHeader";
var AlertDialogFooter = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx3(
    "div",
    __spreadValues({
      className: cn(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
        className
      )
    }, props)
  );
};
AlertDialogFooter.displayName = "AlertDialogFooter";
var AlertDialogTitle = React3.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx3(
    AlertDialogPrimitive.Title,
    __spreadValues({
      ref,
      className: cn("text-lg font-semibold", className)
    }, props)
  );
});
AlertDialogTitle.displayName = AlertDialogPrimitive.Title.displayName;
var AlertDialogDescription = React3.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx3(
    AlertDialogPrimitive.Description,
    __spreadValues({
      ref,
      className: cn("text-sm text-muted-foreground", className)
    }, props)
  );
});
AlertDialogDescription.displayName = AlertDialogPrimitive.Description.displayName;
var AlertDialogAction = React3.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx3(
    AlertDialogPrimitive.Action,
    __spreadValues({
      ref,
      className: cn(buttonVariants(), className)
    }, props)
  );
});
AlertDialogAction.displayName = AlertDialogPrimitive.Action.displayName;
var AlertDialogCancel = React3.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx3(
    AlertDialogPrimitive.Cancel,
    __spreadValues({
      ref,
      className: cn(
        buttonVariants({ variant: "outline" }),
        "mt-2 sm:mt-0",
        className
      )
    }, props)
  );
});
AlertDialogCancel.displayName = AlertDialogPrimitive.Cancel.displayName;

// src/components/avatar/avatar.tsx
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import * as React4 from "react";
import { jsx as jsx4 } from "react/jsx-runtime";
var Avatar = React4.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx4(
    AvatarPrimitive.Root,
    __spreadValues({
      ref,
      className: cn(
        "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
        className
      )
    }, props)
  );
});
Avatar.displayName = AvatarPrimitive.Root.displayName;
var AvatarImage = React4.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx4(
    AvatarPrimitive.Image,
    __spreadValues({
      ref,
      className: cn("aspect-square h-full w-full", className)
    }, props)
  );
});
AvatarImage.displayName = AvatarPrimitive.Image.displayName;
var AvatarFallback = React4.forwardRef((_a, ref) => {
  var _b = _a, { className, name, children } = _b, props = __objRest(_b, ["className", "name", "children"]);
  return /* @__PURE__ */ jsx4(
    AvatarPrimitive.Fallback,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "flex h-full w-full items-center justify-center rounded-full bg-muted",
        name && `bg-[${getRandomColor(name)}] text-white`,
        className
      )
    }, props), {
      children: name ? defaultInitials(name, { maxInitials: 2 }) : children
    })
  );
});
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

// src/components/badge/index.ts
import { cva as cva3 } from "class-variance-authority";

// src/components/badge/badge.tsx
import { cva as cva2 } from "class-variance-authority";
import { jsx as jsx5 } from "react/jsx-runtime";
var badgeVariants = cva2(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        // Brand status roles (brand book p.70): yellow = needs action,
        // Water = moving, greyscale = not started / done. Colors come from
        // the shared `status` tokens. ("Waiting on you" reuses the
        // `destructive` variant — same Container red.)
        action: "border-transparent bg-[hsl(var(--status-action))] text-primary-foreground",
        moving: "border-transparent bg-[hsl(var(--status-moving))] text-white",
        idle: "border-transparent bg-[hsl(var(--status-idle))] text-black",
        done: "border-transparent bg-[hsl(var(--status-done))] text-white"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function Badge(_a) {
  var _b = _a, { className, variant } = _b, props = __objRest(_b, ["className", "variant"]);
  return /* @__PURE__ */ jsx5("div", __spreadValues({ className: cn(badgeVariants({ variant }), className) }, props));
}

// src/components/brand-loader/brand-loader.tsx
import { jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
var loaderCss = `
.v7 .b{animation:2.4s infinite cubic-bezier(.76,0,.24,1)}
.v7 .r{animation-name:v7-r}
.v7 .l{animation-name:v7-l}
@keyframes v7-r{0%,12%{transform:translate(0,0)}25%,30%{transform:translate(0,-12px)}43%,48%{transform:translate(12px,-12px)}61%,66%{transform:translate(12px,0)}79%,100%{transform:translate(0,0)}}
@keyframes v7-l{0%,12%{transform:translate(0,0)}25%,30%{transform:translate(0,12px)}43%,48%{transform:translate(-12px,12px)}61%,66%{transform:translate(-12px,0)}79%,100%{transform:translate(0,0)}}
@media (prefers-reduced-motion: reduce){.v7 *{animation:none!important}}
`;
var BrandLoader = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsxs3(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 255.118 170.079",
      className: cn("v7", className),
      role: "img",
      "aria-label": "Loading",
      fill: "currentColor"
    }, props), {
      children: [
        /* @__PURE__ */ jsx6("style", { children: loaderCss }),
        /* @__PURE__ */ jsx6(
          "path",
          {
            className: "b r",
            d: "M164.976,42.504h-37.417v42.535h42.52v42.535h42.52v-37.431c0-31.668-15.966-47.64-47.622-47.64Z"
          }
        ),
        /* @__PURE__ */ jsx6(
          "path",
          {
            className: "b l",
            d: "M90.142,127.575h37.417v-42.535h-42.52v-42.535h-42.52v37.431c0,31.668,15.966,47.64,47.622,47.64Z"
          }
        )
      ]
    })
  );
};

// src/components/breadcrumbs/breadcrumbs.tsx
import { Slot as Slot2 } from "@radix-ui/react-slot";
import { ChevronRight, MoreHorizontal } from "lucide-react";
import { forwardRef as forwardRef5 } from "react";
import { jsx as jsx7, jsxs as jsxs4 } from "react/jsx-runtime";
var Breadcrumb = forwardRef5((_a, ref) => {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ jsx7("nav", __spreadValues({ ref, "aria-label": "breadcrumb" }, props));
});
Breadcrumb.displayName = "Breadcrumb";
var BreadcrumbList = forwardRef5((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx7(
    "ol",
    __spreadValues({
      ref,
      className: cn(
        "flex flex-wrap items-center gap-1.5 break-words text-sm text-muted-foreground sm:gap-2.5",
        className
      )
    }, props)
  );
});
BreadcrumbList.displayName = "BreadcrumbList";
var BreadcrumbItem = forwardRef5((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx7(
    "li",
    __spreadValues({
      ref,
      className: cn("inline-flex items-center gap-1.5", className)
    }, props)
  );
});
BreadcrumbItem.displayName = "BreadcrumbItem";
var BreadcrumbLink = forwardRef5((_a, ref) => {
  var _b = _a, { asChild, className } = _b, props = __objRest(_b, ["asChild", "className"]);
  const Comp = asChild ? Slot2 : "a";
  return /* @__PURE__ */ jsx7(
    Comp,
    __spreadValues({
      ref,
      className: cn("transition-colors hover:text-foreground", className)
    }, props)
  );
});
BreadcrumbLink.displayName = "BreadcrumbLink";
var BreadcrumbPage = forwardRef5((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx7(
    "span",
    __spreadValues({
      ref,
      role: "link",
      "aria-disabled": "true",
      "aria-current": "page",
      className: cn("font-normal text-foreground", className)
    }, props)
  );
});
BreadcrumbPage.displayName = "BreadcrumbPage";
var BreadcrumbSeparator = (_a) => {
  var _b = _a, {
    children,
    className
  } = _b, props = __objRest(_b, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ jsx7(
    "span",
    __spreadProps(__spreadValues({
      role: "presentation",
      "aria-hidden": "true",
      className: cn("[&>svg]:size-3.5", className)
    }, props), {
      children: children != null ? children : /* @__PURE__ */ jsx7(ChevronRight, {})
    })
  );
};
BreadcrumbSeparator.displayName = "BreadcrumbSeparator";
var BreadcrumbEllipsis = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsxs4(
    "span",
    __spreadProps(__spreadValues({
      role: "presentation",
      "aria-hidden": "true",
      className: cn("flex h-9 w-9 items-center justify-center", className)
    }, props), {
      children: [
        /* @__PURE__ */ jsx7(MoreHorizontal, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx7("span", { className: "sr-only", children: "More" })
      ]
    })
  );
};
BreadcrumbEllipsis.displayName = "BreadcrumbElipssis";

// src/components/calendar/index.ts
import { format } from "date-fns";

// src/components/calendar/calendar.tsx
import { ChevronLeft, ChevronRight as ChevronRight2 } from "lucide-react";
import { DayPicker } from "react-day-picker";
import { jsx as jsx8 } from "react/jsx-runtime";
function Calendar(_a) {
  var _b = _a, {
    className,
    classNames,
    showOutsideDays = true
  } = _b, props = __objRest(_b, [
    "className",
    "classNames",
    "showOutsideDays"
  ]);
  return /* @__PURE__ */ jsx8(
    DayPicker,
    __spreadValues({
      navLayout: "around",
      showOutsideDays,
      className: cn("p-3", className),
      classNames: __spreadValues({
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        caption: "flex justify-center pt-1 items-center",
        caption_label: "text-sm font-medium",
        month: "relative",
        month_caption: "text-center",
        month_grid: "mt-4",
        nav: "absolute right-3 top-1 flex items-center gap-1",
        nav_button: cn(
          buttonVariants({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100 border"
        ),
        button_next: cn(
          buttonVariants({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100 border [.theme-uturn_&]:rounded-none [.theme-uturn_&]:rounded-tr-md absolute right-2 top-0"
        ),
        button_previous: cn(
          buttonVariants({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100 border [.theme-uturn_&]:rounded-none [.theme-uturn_&]:rounded-tl-md absolute left-2 top-0"
        ),
        table: "w-full border-collapse space-y-1",
        weekdays: "flex",
        weekday: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
        weeks: "space-y-1",
        week: "flex w-full mt-2",
        row: "flex w-full mt-2",
        day: cn(
          "h-9 w-9 text-center text-sm p-0 relative",
          "[&:has([aria-selected].day-range-end)]:rounded-r-md",
          "[&:has([aria-selected].day-outside)]:bg-accent/50",
          "[&:has([aria-selected])]:bg-accent",
          "first:[&:has([aria-selected])]:rounded-l-md",
          "last:[&:has([aria-selected])]:rounded-r-md",
          "focus-within:relative focus-within:z-20",
          "[&[data-selected]>button]:bg-primary",
          "[&[data-selected]>button]:text-primary-foreground",
          "[&[data-selected]>button]:rounded-md",
          "[&[data-selected]>button]:font-semibold",
          "[&[data-selected]>button:hover]:bg-primary",
          "[&[data-selected]>button:hover]:text-primary-foreground"
        ),
        day_button: cn(
          buttonVariants({ variant: "ghost" }),
          "h-9 w-9 p-0 font-normal aria-selected:opacity-100"
        ),
        range_end: "day-range-end",
        today: cn(
          "[&>button]:border [&>button]:border-foreground",
          "[&>button]:rounded-md [&>button]:font-semibold"
        ),
        outside: "day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30",
        disabled: "text-muted-foreground opacity-50",
        range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
        hidden: "invisible"
      }, classNames),
      components: {
        Chevron: ({ orientation }) => orientation === "left" ? /* @__PURE__ */ jsx8(ChevronLeft, { className: "h-4 w-4" }) : /* @__PURE__ */ jsx8(ChevronRight2, { className: "h-4 w-4" })
      }
    }, props)
  );
}
Calendar.displayName = "Calendar";

// src/components/card/card.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
function Card(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx9(
    "div",
    __spreadValues({
      "data-slot": "card",
      className: cn(
        "bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm [.theme-uturn_&]:rounded-2xl",
        className
      )
    }, props)
  );
}
function CardHeader(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx9(
    "div",
    __spreadValues({
      "data-slot": "card-header",
      className: cn(
        "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6",
        className
      )
    }, props)
  );
}
function CardTitle(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx9(
    "div",
    __spreadValues({
      "data-slot": "card-title",
      className: cn("leading-none font-semibold", className)
    }, props)
  );
}
function CardDescription(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx9(
    "div",
    __spreadValues({
      "data-slot": "card-description",
      className: cn("text-muted-foreground text-sm", className)
    }, props)
  );
}
function CardAction(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx9(
    "div",
    __spreadValues({
      "data-slot": "card-action",
      className: cn(
        "col-start-2 row-span-2 row-start-1 self-start justify-self-end",
        className
      )
    }, props)
  );
}
function CardContent(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx9(
    "div",
    __spreadValues({
      "data-slot": "card-content",
      className: cn("px-6", className)
    }, props)
  );
}
function CardFooter(_a) {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx9(
    "div",
    __spreadValues({
      "data-slot": "card-footer",
      className: cn("flex items-center px-6 [.border-t]:pt-6", className)
    }, props)
  );
}

// src/components/checkbox/checkbox.tsx
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import * as React5 from "react";
import { jsx as jsx10 } from "react/jsx-runtime";
var Checkbox = React5.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx10(
    CheckboxPrimitive.Root,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive [.theme-uturn_&]:border-foreground [.theme-uturn_&]:data-[state=checked]:bg-foreground [.theme-uturn_&]:data-[state=checked]:text-primary [.dark.theme-uturn_&]:data-[state=checked]:text-primary-foreground [.theme-uturn_&]:aria-[invalid=true]:border-destructive",
        className
      )
    }, props), {
      children: /* @__PURE__ */ jsx10(
        CheckboxPrimitive.Indicator,
        {
          className: cn("flex items-center justify-center text-current"),
          children: /* @__PURE__ */ jsx10(Check, { className: "h-4 w-4" })
        }
      )
    })
  );
});
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

// src/components/collapsible/collapsible.tsx
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
var Collapsible = CollapsiblePrimitive.Root;
var { CollapsibleTrigger } = CollapsiblePrimitive;
var { CollapsibleContent } = CollapsiblePrimitive;

// src/components/dialog/dialog.tsx
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import * as React6 from "react";
import { jsx as jsx11, jsxs as jsxs5 } from "react/jsx-runtime";
var Dialog = DialogPrimitive.Root;
var DialogTrigger = DialogPrimitive.Trigger;
var DialogPortal = DialogPrimitive.Portal;
var DialogClose = DialogPrimitive.Close;
var DialogOverlay = React6.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx11(
    DialogPrimitive.Overlay,
    __spreadValues({
      ref,
      className: cn(
        "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        className
      )
    }, props)
  );
});
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;
var DialogContent = React6.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs5(DialogPortal, { children: [
    /* @__PURE__ */ jsx11(DialogOverlay, {}),
    /* @__PURE__ */ jsxs5(
      DialogPrimitive.Content,
      __spreadProps(__spreadValues({
        ref,
        className: cn(
          "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-card p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
          className
        )
      }, props), {
        children: [
          children,
          /* @__PURE__ */ jsxs5(DialogPrimitive.Close, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
            /* @__PURE__ */ jsx11(X, { className: "h-4 w-4" }),
            /* @__PURE__ */ jsx11("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      })
    )
  ] });
});
DialogContent.displayName = DialogPrimitive.Content.displayName;
var DialogHeader = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx11(
    "div",
    __spreadValues({
      className: cn(
        "flex flex-col space-y-1.5 text-center sm:text-left",
        className
      )
    }, props)
  );
};
DialogHeader.displayName = "DialogHeader";
var DialogFooter = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx11(
    "div",
    __spreadValues({
      className: cn(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
        className
      )
    }, props)
  );
};
DialogFooter.displayName = "DialogFooter";
var DialogTitle = React6.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx11(
    DialogPrimitive.Title,
    __spreadValues({
      ref,
      className: cn(
        "text-lg font-semibold leading-none tracking-tight",
        className
      )
    }, props)
  );
});
DialogTitle.displayName = DialogPrimitive.Title.displayName;
var DialogDescription = React6.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx11(
    DialogPrimitive.Description,
    __spreadValues({
      ref,
      className: cn("text-sm text-muted-foreground", className)
    }, props)
  );
});
DialogDescription.displayName = DialogPrimitive.Description.displayName;

// src/components/command/command.tsx
import { Command as CommandPrimitive } from "cmdk";
import { Search } from "lucide-react";
import * as React7 from "react";
import { useDebouncedCallback } from "use-debounce";
import { jsx as jsx12, jsxs as jsxs6 } from "react/jsx-runtime";
var Command = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx12(
    CommandPrimitive,
    __spreadValues({
      ref,
      className: cn(
        "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
        className
      )
    }, props)
  );
});
Command.displayName = CommandPrimitive.displayName;
var CommandDialog = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx12(Dialog, __spreadProps(__spreadValues({}, props), { children: /* @__PURE__ */ jsx12(DialogContent, { className: "overflow-hidden p-0 shadow-lg data-[state=closed]:slide-out-to-top-[8%] data-[state=open]:slide-in-from-top-[8%] top-[10%] -translate-y-[10%]", children: /* @__PURE__ */ jsx12(Command, { className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children }) }) }));
};
var CommandInput = React7.forwardRef(
  (_a, ref) => {
    var _b = _a, { className, onValueChange, onInputChange, debounceDelay } = _b, props = __objRest(_b, ["className", "onValueChange", "onInputChange", "debounceDelay"]);
    const debounce = useDebouncedCallback((targetValue) => {
      onInputChange == null ? void 0 : onInputChange(targetValue);
    }, debounceDelay || 0);
    const handleInput = (event) => {
      const value = event.currentTarget.value;
      onValueChange == null ? void 0 : onValueChange(value);
      debounce(value);
    };
    return /* @__PURE__ */ jsxs6("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
      /* @__PURE__ */ jsx12(Search, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
      /* @__PURE__ */ jsx12(
        CommandPrimitive.Input,
        __spreadProps(__spreadValues({
          ref,
          className: cn(
            "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none border-transparent focus:border-transparent focus:ring-0 placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
            className
          )
        }, props), {
          onInput: handleInput
        })
      )
    ] });
  }
);
CommandInput.displayName = CommandPrimitive.Input.displayName;
var CommandList = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx12(
    CommandPrimitive.List,
    __spreadValues({
      ref,
      className: cn("max-h-[300px] overflow-y-auto overflow-x-hidden", className)
    }, props)
  );
});
CommandList.displayName = CommandPrimitive.List.displayName;
var CommandEmpty = React7.forwardRef((props, ref) => /* @__PURE__ */ jsx12(
  CommandPrimitive.Empty,
  __spreadValues({
    ref,
    className: "py-6 text-center text-sm"
  }, props)
));
CommandEmpty.displayName = CommandPrimitive.Empty.displayName;
var CommandGroup = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx12(
    CommandPrimitive.Group,
    __spreadValues({
      ref,
      className: cn(
        "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
        className
      )
    }, props)
  );
});
CommandGroup.displayName = CommandPrimitive.Group.displayName;
var CommandSeparator = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx12(
    CommandPrimitive.Separator,
    __spreadValues({
      ref,
      className: cn("-mx-1 h-px bg-border", className)
    }, props)
  );
});
CommandSeparator.displayName = CommandPrimitive.Separator.displayName;
var CommandItem = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx12(
    CommandPrimitive.Item,
    __spreadValues({
      ref,
      className: cn(
        "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none aria-selected:bg-accent aria-selected:text-accent-foreground [.theme-uturn_&]:aria-selected:bg-primary [.theme-uturn_&]:aria-selected:text-primary-foreground aria-disabled:pointer-events-none aria-disabled:opacity-50",
        className
      )
    }, props)
  );
});
CommandItem.displayName = CommandPrimitive.Item.displayName;
var CommandShortcut = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx12(
    "span",
    __spreadValues({
      className: cn(
        "ml-auto text-xs tracking-widest text-muted-foreground",
        className
      )
    }, props)
  );
};
CommandShortcut.displayName = "CommandShortcut";

// src/components/dropdown-menu/dropdown-menu.tsx
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { Check as Check2, ChevronRight as ChevronRight3, Circle } from "lucide-react";
import * as React8 from "react";
import { jsx as jsx13, jsxs as jsxs7 } from "react/jsx-runtime";
var DropdownMenu = DropdownMenuPrimitive.Root;
var DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
var DropdownMenuGroup = DropdownMenuPrimitive.Group;
var DropdownMenuPortal = DropdownMenuPrimitive.Portal;
var DropdownMenuSub = DropdownMenuPrimitive.Sub;
var DropdownMenuRadioGroup = DropdownMenuPrimitive.RadioGroup;
var DropdownMenuSubTrigger = React8.forwardRef((_a, ref) => {
  var _b = _a, { className, inset, children } = _b, props = __objRest(_b, ["className", "inset", "children"]);
  return /* @__PURE__ */ jsxs7(
    DropdownMenuPrimitive.SubTrigger,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent [.theme-uturn_&]:focus:bg-primary [.theme-uturn_&]:focus:text-primary-foreground [.theme-uturn_&]:data-[state=open]:bg-primary [.theme-uturn_&]:data-[state=open]:text-primary-foreground",
        inset && "pl-8",
        className
      )
    }, props), {
      children: [
        children,
        /* @__PURE__ */ jsx13(ChevronRight3, { className: "ml-auto h-4 w-4" })
      ]
    })
  );
});
DropdownMenuSubTrigger.displayName = DropdownMenuPrimitive.SubTrigger.displayName;
var DropdownMenuSubContent = React8.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx13(
    DropdownMenuPrimitive.SubContent,
    __spreadValues({
      ref,
      className: cn(
        "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      )
    }, props)
  );
});
DropdownMenuSubContent.displayName = DropdownMenuPrimitive.SubContent.displayName;
var DropdownMenuContent = React8.forwardRef((_a, ref) => {
  var _b = _a, { className, sideOffset = 4 } = _b, props = __objRest(_b, ["className", "sideOffset"]);
  return /* @__PURE__ */ jsx13(DropdownMenuPrimitive.Portal, { children: /* @__PURE__ */ jsx13(
    DropdownMenuPrimitive.Content,
    __spreadValues({
      ref,
      sideOffset,
      className: cn(
        "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      )
    }, props)
  ) });
});
DropdownMenuContent.displayName = DropdownMenuPrimitive.Content.displayName;
var DropdownMenuItem = React8.forwardRef((_a, ref) => {
  var _b = _a, { className, inset } = _b, props = __objRest(_b, ["className", "inset"]);
  return /* @__PURE__ */ jsx13(
    DropdownMenuPrimitive.Item,
    __spreadValues({
      ref,
      className: cn(
        "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground [.theme-uturn_&]:focus:bg-primary [.theme-uturn_&]:focus:text-primary-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        inset && "pl-8",
        className
      )
    }, props)
  );
});
DropdownMenuItem.displayName = DropdownMenuPrimitive.Item.displayName;
var DropdownMenuCheckboxItem = React8.forwardRef((_a, ref) => {
  var _b = _a, { className, children, checked } = _b, props = __objRest(_b, ["className", "children", "checked"]);
  return /* @__PURE__ */ jsxs7(
    DropdownMenuPrimitive.CheckboxItem,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground [.theme-uturn_&]:focus:bg-primary [.theme-uturn_&]:focus:text-primary-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        className
      ),
      checked
    }, props), {
      children: [
        /* @__PURE__ */ jsx13("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ jsx13(DropdownMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx13(Check2, { className: "h-4 w-4" }) }) }),
        children
      ]
    })
  );
});
DropdownMenuCheckboxItem.displayName = DropdownMenuPrimitive.CheckboxItem.displayName;
var DropdownMenuRadioItem = React8.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs7(
    DropdownMenuPrimitive.RadioItem,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground [.theme-uturn_&]:focus:bg-primary [.theme-uturn_&]:focus:text-primary-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        className
      )
    }, props), {
      children: [
        /* @__PURE__ */ jsx13("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ jsx13(DropdownMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx13(Circle, { className: "h-2 w-2 fill-current" }) }) }),
        children
      ]
    })
  );
});
DropdownMenuRadioItem.displayName = DropdownMenuPrimitive.RadioItem.displayName;
var DropdownMenuLabel = React8.forwardRef((_a, ref) => {
  var _b = _a, { className, inset } = _b, props = __objRest(_b, ["className", "inset"]);
  return /* @__PURE__ */ jsx13(
    DropdownMenuPrimitive.Label,
    __spreadValues({
      ref,
      className: cn(
        "px-2 py-1.5 text-sm font-semibold",
        inset && "pl-8",
        className
      )
    }, props)
  );
});
DropdownMenuLabel.displayName = DropdownMenuPrimitive.Label.displayName;
var DropdownMenuSeparator = React8.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx13(
    DropdownMenuPrimitive.Separator,
    __spreadValues({
      ref,
      className: cn("-mx-1 my-1 h-px bg-muted", className)
    }, props)
  );
});
DropdownMenuSeparator.displayName = DropdownMenuPrimitive.Separator.displayName;
var DropdownMenuShortcut = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx13(
    "span",
    __spreadValues({
      className: cn("ml-auto text-xs tracking-widest opacity-60", className)
    }, props)
  );
};
DropdownMenuShortcut.displayName = "DropdownMenuShortcut";

// src/components/dropzone/dropzone.tsx
import { UploadIcon } from "lucide-react";
import { createContext, useContext } from "react";
import { useDropzone } from "react-dropzone";
import { jsx as jsx14, jsxs as jsxs8 } from "react/jsx-runtime";
var renderBytes = (bytes) => {
  const units = ["B", "KB", "MB", "GB", "TB", "PB"];
  let size = bytes;
  let unitIndex = 0;
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }
  return `${size.toFixed(2)}${units[unitIndex]}`;
};
var DropzoneContext = createContext(
  void 0
);
var Dropzone = (_a) => {
  var _b = _a, {
    accept,
    maxFiles = 1,
    maxSize,
    minSize,
    onDrop,
    onError,
    disabled,
    src,
    className,
    children
  } = _b, props = __objRest(_b, [
    "accept",
    "maxFiles",
    "maxSize",
    "minSize",
    "onDrop",
    "onError",
    "disabled",
    "src",
    "className",
    "children"
  ]);
  const { getRootProps, getInputProps, isDragActive } = useDropzone(__spreadValues({
    accept,
    maxFiles,
    maxSize,
    minSize,
    onError,
    disabled,
    onDrop: (acceptedFiles, fileRejections, event) => {
      var _a2, _b2;
      if (fileRejections.length > 0) {
        const message = (_b2 = (_a2 = fileRejections.at(0)) == null ? void 0 : _a2.errors.at(0)) == null ? void 0 : _b2.message;
        onError == null ? void 0 : onError(new Error(message));
        return;
      }
      onDrop == null ? void 0 : onDrop(acceptedFiles, fileRejections, event);
    }
  }, props));
  return /* @__PURE__ */ jsx14(
    DropzoneContext.Provider,
    {
      value: { src, accept, maxSize, minSize, maxFiles },
      children: /* @__PURE__ */ jsxs8(
        Button,
        __spreadProps(__spreadValues({
          className: cn(
            "relative h-auto w-full flex-col overflow-hidden p-8",
            isDragActive && "outline-none ring-1 ring-ring",
            className
          ),
          disabled,
          type: "button",
          variant: "outline"
        }, getRootProps()), {
          children: [
            /* @__PURE__ */ jsx14("input", __spreadProps(__spreadValues({}, getInputProps()), { disabled })),
            children
          ]
        })
      )
    },
    JSON.stringify(src)
  );
};
var useDropzoneContext = () => {
  const context = useContext(DropzoneContext);
  if (!context) {
    throw new Error("useDropzoneContext must be used within a Dropzone");
  }
  return context;
};
var maxLabelItems = 3;
var DropzoneContent = ({
  children,
  className
}) => {
  const { src } = useDropzoneContext();
  if (!src) {
    return null;
  }
  if (children) {
    return children;
  }
  return /* @__PURE__ */ jsxs8("div", { className: cn("flex flex-col items-center justify-center", className), children: [
    /* @__PURE__ */ jsx14("div", { className: "flex size-8 items-center justify-center rounded-md bg-muted text-muted-foreground", children: /* @__PURE__ */ jsx14(UploadIcon, { size: 16 }) }),
    /* @__PURE__ */ jsx14("p", { className: "my-2 w-full truncate font-medium text-sm", children: src.length > maxLabelItems ? `${new Intl.ListFormat("en").format(
      src.slice(0, maxLabelItems).map((file) => file.name)
    )} and ${src.length - maxLabelItems} more` : new Intl.ListFormat("en").format(src.map((file) => file.name)) }),
    /* @__PURE__ */ jsx14("p", { className: "w-full text-wrap text-muted-foreground text-xs", children: "Drag and drop or click to replace" })
  ] });
};
var DropzoneEmptyState = ({
  children,
  className
}) => {
  const { src, accept, maxSize, minSize, maxFiles } = useDropzoneContext();
  if (src) {
    return null;
  }
  if (children) {
    return children;
  }
  let caption = "";
  if (accept) {
    caption += "Accepts ";
    caption += new Intl.ListFormat("en").format(Object.keys(accept));
  }
  if (minSize && maxSize) {
    caption += ` between ${renderBytes(minSize)} and ${renderBytes(maxSize)}`;
  } else if (minSize) {
    caption += ` at least ${renderBytes(minSize)}`;
  } else if (maxSize) {
    caption += ` less than ${renderBytes(maxSize)}`;
  }
  return /* @__PURE__ */ jsxs8("div", { className: cn("flex flex-col items-center justify-center", className), children: [
    /* @__PURE__ */ jsx14("div", { className: "flex size-8 items-center justify-center rounded-md bg-muted text-muted-foreground", children: /* @__PURE__ */ jsx14(UploadIcon, { size: 16 }) }),
    /* @__PURE__ */ jsxs8("p", { className: "my-2 w-full truncate text-wrap font-medium text-sm", children: [
      "Upload ",
      maxFiles === 1 ? "a file" : "files"
    ] }),
    /* @__PURE__ */ jsx14("p", { className: "w-full truncate text-wrap text-muted-foreground text-xs", children: "Drag and drop or click to upload" }),
    caption && /* @__PURE__ */ jsxs8("p", { className: "text-wrap text-muted-foreground text-xs", children: [
      caption,
      "."
    ] })
  ] });
};

// src/components/form/form.tsx
import { Slot as Slot3 } from "@radix-ui/react-slot";

// src/components/label/label.tsx
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva as cva4 } from "class-variance-authority";
import * as React9 from "react";
import { jsx as jsx15 } from "react/jsx-runtime";
var labelVariants = cva4(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
);
var Label2 = React9.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx15(
    LabelPrimitive.Root,
    __spreadValues({
      ref,
      className: cn(labelVariants(), className)
    }, props)
  );
});
Label2.displayName = LabelPrimitive.Root.displayName;

// src/components/form/form.tsx
import * as React10 from "react";
import { Controller, FormProvider, useFormContext } from "react-hook-form";
import { jsx as jsx16 } from "react/jsx-runtime";
var Form = FormProvider;
var FormFieldContext = React10.createContext(
  {}
);
var FormField = (_a) => {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ jsx16(FormFieldContext.Provider, { value: { name: props.name }, children: /* @__PURE__ */ jsx16(Controller, __spreadValues({}, props)) });
};
var FormItemContext = React10.createContext(
  {}
);
var useFormField = () => {
  const fieldContext = React10.useContext(FormFieldContext);
  const itemContext = React10.useContext(FormItemContext);
  const { getFieldState, formState } = useFormContext();
  const fieldState = getFieldState(fieldContext.name, formState);
  if (!fieldContext) {
    throw new Error("useFormField should be used within <FormField>");
  }
  const { id } = itemContext;
  return __spreadValues({
    id,
    name: fieldContext.name,
    formItemId: `${id}-form-item`,
    formDescriptionId: `${id}-form-item-description`,
    formMessageId: `${id}-form-item-message`
  }, fieldState);
};
var FormItem = React10.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const id = React10.useId();
  return /* @__PURE__ */ jsx16(FormItemContext.Provider, { value: { id }, children: /* @__PURE__ */ jsx16("div", __spreadValues({ ref, className: cn("space-y-2", className) }, props)) });
});
FormItem.displayName = "FormItem";
var FormLabel = React10.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const { error, formItemId } = useFormField();
  return /* @__PURE__ */ jsx16(
    Label2,
    __spreadValues({
      ref,
      className: cn(error && "text-destructive", className),
      htmlFor: formItemId
    }, props)
  );
});
FormLabel.displayName = "FormLabel";
var FormControl = React10.forwardRef((_a, ref) => {
  var props = __objRest(_a, []);
  const { error, formItemId, formDescriptionId, formMessageId } = useFormField();
  return /* @__PURE__ */ jsx16(
    Slot3,
    __spreadValues({
      ref,
      id: formItemId,
      "aria-describedby": !error ? `${formDescriptionId}` : `${formDescriptionId} ${formMessageId}`,
      "aria-invalid": !!error
    }, props)
  );
});
FormControl.displayName = "FormControl";
var FormDescription = React10.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const { formDescriptionId } = useFormField();
  return /* @__PURE__ */ jsx16(
    "p",
    __spreadValues({
      ref,
      id: formDescriptionId,
      className: cn("text-sm text-muted-foreground", className)
    }, props)
  );
});
FormDescription.displayName = "FormDescription";
var FormMessage = React10.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  const { error, formMessageId } = useFormField();
  const body = error ? String(error == null ? void 0 : error.message) : children;
  if (!body) {
    return null;
  }
  return /* @__PURE__ */ jsx16(
    "p",
    __spreadProps(__spreadValues({
      ref,
      id: formMessageId,
      className: cn("text-sm font-medium text-destructive", className)
    }, props), {
      children: body
    })
  );
});
FormMessage.displayName = "FormMessage";

// src/components/hover-card/hover-card.tsx
import * as HoverCardPrimitive from "@radix-ui/react-hover-card";
import * as React11 from "react";
import { jsx as jsx17 } from "react/jsx-runtime";
var HoverCard = HoverCardPrimitive.Root;
var HoverCardTrigger = HoverCardPrimitive.Trigger;
var HoverCardContent = React11.forwardRef((_a, ref) => {
  var _b = _a, { className, align = "center", sideOffset = 4 } = _b, props = __objRest(_b, ["className", "align", "sideOffset"]);
  return /* @__PURE__ */ jsx17(
    HoverCardPrimitive.Content,
    __spreadValues({
      ref,
      align,
      sideOffset,
      className: cn(
        "z-50 w-64 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      )
    }, props)
  );
});
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;

// src/components/input/input.tsx
import { faEye, faEyeSlash, faLock } from "@fortawesome/pro-regular-svg-icons";
import * as React12 from "react";

// src/components/uturn-ui/icon/icon.tsx
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { jsx as jsx18 } from "react/jsx-runtime";
function Icon(props) {
  return /* @__PURE__ */ jsx18(FontAwesomeIcon, __spreadValues({}, props));
}

// src/components/uturn-ui/input-addon.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
function InputAddon({
  children,
  type = "trailing",
  className
}) {
  return /* @__PURE__ */ jsx19(
    "div",
    {
      className: cn(
        "pointer-events-none absolute right-0 flex items-center inset-y-0",
        type === "leading" ? "left-3" : "right-3",
        className
      ),
      children
    }
  );
}

// src/components/input/input.tsx
import { jsx as jsx20, jsxs as jsxs9 } from "react/jsx-runtime";
var Input = React12.forwardRef(
  (_a, ref) => {
    var _b = _a, { className, type } = _b, props = __objRest(_b, ["className", "type"]);
    const [showPassword, setShowPassword] = React12.useState(false);
    const determineType = () => {
      if (type === "password") {
        return showPassword ? "text" : "password";
      }
      return type;
    };
    const inputEl = /* @__PURE__ */ jsx20(
      "input",
      __spreadValues({
        type: determineType(),
        className: cn(
          "flex h-12 w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive [.theme-uturn_&]:border-foreground [.theme-uturn_&]:aria-[invalid=true]:border-destructive",
          className,
          type === "password" && "password pl-10"
        ),
        ref
      }, props)
    );
    if (type === "password") {
      return /* @__PURE__ */ jsxs9("div", { className: "relative", children: [
        /* @__PURE__ */ jsx20(InputAddon, { type: "leading", children: /* @__PURE__ */ jsx20(Icon, { icon: faLock, className: "text-muted-foreground" }) }),
        inputEl,
        /* @__PURE__ */ jsx20(InputAddon, { type: "trailing", className: "pointer-events-auto", children: /* @__PURE__ */ jsx20(
          "button",
          {
            type: "button",
            onClick: () => setShowPassword(!showPassword),
            children: /* @__PURE__ */ jsx20(
              Icon,
              {
                icon: showPassword ? faEyeSlash : faEye,
                className: "text-muted-foreground"
              }
            )
          }
        ) })
      ] });
    }
    return inputEl;
  }
);
Input.displayName = "Input";

// src/components/navigation-menu/navigation-menu.tsx
import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import { cva as cva5 } from "class-variance-authority";
import { ChevronDown as ChevronDown2 } from "lucide-react";
import * as React13 from "react";
import { jsx as jsx21, jsxs as jsxs10 } from "react/jsx-runtime";
var NavigationMenu = React13.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs10(
    NavigationMenuPrimitive.Root,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "relative z-10 flex max-w-max flex-1 items-center justify-center",
        className
      )
    }, props), {
      children: [
        children,
        /* @__PURE__ */ jsx21(NavigationMenuViewport, {})
      ]
    })
  );
});
NavigationMenu.displayName = NavigationMenuPrimitive.Root.displayName;
var NavigationMenuList = React13.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx21(
    NavigationMenuPrimitive.List,
    __spreadValues({
      ref,
      className: cn(
        "group flex flex-1 list-none items-center justify-center space-x-1",
        className
      )
    }, props)
  );
});
NavigationMenuList.displayName = NavigationMenuPrimitive.List.displayName;
var NavigationMenuItem = NavigationMenuPrimitive.Item;
var navigationMenuTriggerStyle = cva5(
  "group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50"
);
var NavigationMenuTrigger = React13.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs10(
    NavigationMenuPrimitive.Trigger,
    __spreadProps(__spreadValues({
      ref,
      className: cn(navigationMenuTriggerStyle(), "group", className)
    }, props), {
      children: [
        children,
        " ",
        /* @__PURE__ */ jsx21(
          ChevronDown2,
          {
            className: "relative top-[1px] ml-1 h-3 w-3 transition duration-200 group-data-[state=open]:rotate-180",
            "aria-hidden": "true"
          }
        )
      ]
    })
  );
});
NavigationMenuTrigger.displayName = NavigationMenuPrimitive.Trigger.displayName;
var NavigationMenuContent = React13.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx21(
    NavigationMenuPrimitive.Content,
    __spreadValues({
      ref,
      className: cn(
        "left-0 top-0 w-full data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52 md:absolute md:w-auto ",
        className
      )
    }, props)
  );
});
NavigationMenuContent.displayName = NavigationMenuPrimitive.Content.displayName;
var NavigationMenuLink = NavigationMenuPrimitive.Link;
var NavigationMenuViewport = React13.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx21("div", { className: cn("absolute left-0 top-full flex justify-center"), children: /* @__PURE__ */ jsx21(
    NavigationMenuPrimitive.Viewport,
    __spreadValues({
      className: cn(
        "origin-top-center relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90 md:w-[var(--radix-navigation-menu-viewport-width)]",
        className
      ),
      ref
    }, props)
  ) });
});
NavigationMenuViewport.displayName = NavigationMenuPrimitive.Viewport.displayName;
var NavigationMenuIndicator = React13.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx21(
    NavigationMenuPrimitive.Indicator,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden data-[state=visible]:animate-in data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:fade-in",
        className
      )
    }, props), {
      children: /* @__PURE__ */ jsx21("div", { className: "relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sm bg-border shadow-md" })
    })
  );
});
NavigationMenuIndicator.displayName = NavigationMenuPrimitive.Indicator.displayName;

// src/components/pagination/pagination.tsx
import { ChevronLeft as ChevronLeft2, ChevronRight as ChevronRight4, MoreHorizontal as MoreHorizontal2 } from "lucide-react";
import * as React14 from "react";
import { useTranslation } from "react-i18next";
import { jsx as jsx22, jsxs as jsxs11 } from "react/jsx-runtime";
var Pagination = (_a) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx22(
    "nav",
    __spreadValues({
      role: "navigation",
      "aria-label": "pagination",
      className: cn("mx-auto flex w-full justify-center py-4", className)
    }, props)
  );
};
Pagination.displayName = "Pagination";
var PaginationContent = React14.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx22(
    "ul",
    __spreadValues({
      ref,
      className: cn("flex flex-row items-center gap-1", className)
    }, props)
  );
});
PaginationContent.displayName = "PaginationContent";
var PaginationItem = React14.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx22("li", __spreadValues({ ref, className: cn("cursor-pointer", className) }, props));
});
PaginationItem.displayName = "PaginationItem";
var PaginationLink = (_a) => {
  var _b = _a, {
    className,
    isActive,
    size = "icon",
    LinkComponent = void 0
  } = _b, props = __objRest(_b, [
    "className",
    "isActive",
    "size",
    "LinkComponent"
  ]);
  if (LinkComponent) {
    return /* @__PURE__ */ jsx22(
      LinkComponent,
      __spreadProps(__spreadValues({
        className: cn(
          buttonVariants({
            variant: isActive ? "outline" : "ghost",
            size
          }),
          className
        )
      }, props), {
        children: props.children
      })
    );
  }
  return /* @__PURE__ */ jsx22(
    "a",
    __spreadProps(__spreadValues({
      "aria-current": isActive ? "page" : void 0,
      className: cn(
        buttonVariants({
          variant: isActive ? "outline" : "ghost",
          size
        }),
        className
      )
    }, props), {
      children: props.children
    })
  );
};
PaginationLink.displayName = "PaginationLink";
var PaginationPrevious = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs11(
    PaginationLink,
    __spreadProps(__spreadValues({
      "aria-label": t("general.pagination.previous-aria", "Go to previous page"),
      size: "default",
      className: cn("gap-1 pl-2.5", className)
    }, props), {
      children: [
        /* @__PURE__ */ jsx22(ChevronLeft2, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx22("span", { children: t("general.pagination.previous", "Previous") })
      ]
    })
  );
};
PaginationPrevious.displayName = "PaginationPrevious";
var PaginationNext = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs11(
    PaginationLink,
    __spreadProps(__spreadValues({
      "aria-label": t("general.pagination.next-aria", "Go to next page"),
      size: "default",
      className: cn("gap-1 pr-2.5", className)
    }, props), {
      children: [
        /* @__PURE__ */ jsx22("span", { children: t("general.pagination.next", "Next") }),
        /* @__PURE__ */ jsx22(ChevronRight4, { className: "h-4 w-4" })
      ]
    })
  );
};
PaginationNext.displayName = "PaginationNext";
var PaginationEllipsis = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsxs11(
    "span",
    __spreadProps(__spreadValues({
      "aria-hidden": true,
      className: cn("flex h-9 w-9 items-center justify-center", className)
    }, props), {
      children: [
        /* @__PURE__ */ jsx22(MoreHorizontal2, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx22("span", { className: "sr-only", children: "More pages" })
      ]
    })
  );
};
PaginationEllipsis.displayName = "PaginationEllipsis";

// src/components/popover/popover.tsx
import * as PopoverPrimitive from "@radix-ui/react-popover";
import * as React15 from "react";
import { jsx as jsx23 } from "react/jsx-runtime";
var Popover = PopoverPrimitive.Root;
var PopoverTrigger = PopoverPrimitive.Trigger;
var PopoverAnchor = PopoverPrimitive.Anchor;
var PopoverContent = React15.forwardRef((_a, ref) => {
  var _b = _a, { className, align = "center", sideOffset = 4 } = _b, props = __objRest(_b, ["className", "align", "sideOffset"]);
  return /* @__PURE__ */ jsx23(PopoverPrimitive.Portal, { children: /* @__PURE__ */ jsx23(
    PopoverPrimitive.Content,
    __spreadValues({
      ref,
      align,
      sideOffset,
      className: cn(
        "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      )
    }, props)
  ) });
});
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

// src/components/progress/progress.tsx
import * as ProgressPrimitive from "@radix-ui/react-progress";
import * as React16 from "react";
import { jsx as jsx24 } from "react/jsx-runtime";
var Progress = React16.forwardRef((_a, ref) => {
  var _b = _a, { className, value } = _b, props = __objRest(_b, ["className", "value"]);
  return /* @__PURE__ */ jsx24(
    ProgressPrimitive.Root,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "relative h-4 w-full overflow-hidden rounded-full bg-secondary",
        className
      )
    }, props), {
      children: /* @__PURE__ */ jsx24(
        ProgressPrimitive.Indicator,
        {
          className: "h-full w-full flex-1 bg-primary transition-all",
          style: { transform: `translateX(-${100 - (value || 0)}%)` }
        }
      )
    })
  );
});
Progress.displayName = ProgressPrimitive.Root.displayName;

// src/components/radio-group/radio-group.tsx
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { Circle as Circle2 } from "lucide-react";
import * as React17 from "react";
import { jsx as jsx25 } from "react/jsx-runtime";
var RadioGroup2 = React17.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx25(
    RadioGroupPrimitive.Root,
    __spreadProps(__spreadValues({
      className: cn("grid gap-2", className)
    }, props), {
      ref
    })
  );
});
RadioGroup2.displayName = RadioGroupPrimitive.Root.displayName;
var RadioGroupItem = React17.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx25(
    RadioGroupPrimitive.Item,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive [.theme-uturn_&]:border-input [.theme-uturn_&]:data-[state=checked]:border-foreground [.theme-uturn_&]:data-[state=checked]:text-foreground [.theme-uturn_&]:aria-[invalid=true]:border-destructive [.theme-uturn_&]:aria-[invalid=true]:data-[state=checked]:border-destructive",
        className
      )
    }, props), {
      children: /* @__PURE__ */ jsx25(RadioGroupPrimitive.Indicator, { className: "flex items-center justify-center", children: /* @__PURE__ */ jsx25(Circle2, { className: "h-2 w-2 fill-current text-current" }) })
    })
  );
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

// src/components/scroll-area/scroll-area.tsx
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import * as React18 from "react";
import { jsx as jsx26, jsxs as jsxs12 } from "react/jsx-runtime";
var ScrollBar = React18.forwardRef((_a, ref) => {
  var _b = _a, { className, orientation = "vertical" } = _b, props = __objRest(_b, ["className", "orientation"]);
  return /* @__PURE__ */ jsx26(
    ScrollAreaPrimitive.ScrollAreaScrollbar,
    __spreadProps(__spreadValues({
      ref,
      orientation,
      className: cn(
        "flex touch-none select-none transition-colors",
        orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
        orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
        className
      )
    }, props), {
      children: /* @__PURE__ */ jsx26(ScrollAreaPrimitive.ScrollAreaThumb, { className: "relative flex-1 rounded-full bg-border" })
    })
  );
});
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;
var ScrollArea = React18.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs12(
    ScrollAreaPrimitive.Root,
    __spreadProps(__spreadValues({
      ref,
      className: cn("relative overflow-hidden", className)
    }, props), {
      children: [
        /* @__PURE__ */ jsx26(ScrollAreaPrimitive.Viewport, { className: "h-full w-full rounded-[inherit]", children }),
        /* @__PURE__ */ jsx26(ScrollBar, {}),
        /* @__PURE__ */ jsx26(ScrollAreaPrimitive.Corner, {})
      ]
    })
  );
});
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;

// src/components/select/select.tsx
import * as SelectPrimitive from "@radix-ui/react-select";
import { Check as Check3, ChevronDown as ChevronDown3, ChevronUp } from "lucide-react";
import * as React19 from "react";
import { jsx as jsx27, jsxs as jsxs13 } from "react/jsx-runtime";
var Select = SelectPrimitive.Root;
var SelectGroup = SelectPrimitive.Group;
var SelectValue = SelectPrimitive.Value;
var SelectTrigger = React19.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs13(
    SelectPrimitive.Trigger,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "flex h-12 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 aria-[invalid=true]:border-destructive aria-[invalid=true]:focus:ring-destructive [.theme-uturn_&]:border-foreground [.theme-uturn_&]:aria-[invalid=true]:border-destructive",
        className
      )
    }, props), {
      children: [
        children,
        /* @__PURE__ */ jsx27(SelectPrimitive.Icon, { asChild: true, children: /* @__PURE__ */ jsx27(ChevronDown3, { className: "h-4 w-4 opacity-50" }) })
      ]
    })
  );
});
SelectTrigger.displayName = SelectPrimitive.Trigger.displayName;
var SelectScrollUpButton = React19.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx27(
    SelectPrimitive.ScrollUpButton,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "flex cursor-default items-center justify-center py-1",
        className
      )
    }, props), {
      children: /* @__PURE__ */ jsx27(ChevronUp, { className: "h-4 w-4" })
    })
  );
});
SelectScrollUpButton.displayName = SelectPrimitive.ScrollUpButton.displayName;
var SelectScrollDownButton = React19.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx27(
    SelectPrimitive.ScrollDownButton,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "flex cursor-default items-center justify-center py-1",
        className
      )
    }, props), {
      children: /* @__PURE__ */ jsx27(ChevronDown3, { className: "h-4 w-4" })
    })
  );
});
SelectScrollDownButton.displayName = SelectPrimitive.ScrollDownButton.displayName;
var SelectContent = React19.forwardRef((_a, ref) => {
  var _b = _a, { className, children, position = "popper" } = _b, props = __objRest(_b, ["className", "children", "position"]);
  return /* @__PURE__ */ jsx27(SelectPrimitive.Portal, { children: /* @__PURE__ */ jsxs13(
    SelectPrimitive.Content,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        className
      ),
      position
    }, props), {
      children: [
        /* @__PURE__ */ jsx27(SelectScrollUpButton, {}),
        /* @__PURE__ */ jsx27(
          SelectPrimitive.Viewport,
          {
            className: cn(
              "p-1",
              position === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
            ),
            children
          }
        ),
        /* @__PURE__ */ jsx27(SelectScrollDownButton, {})
      ]
    })
  ) });
});
SelectContent.displayName = SelectPrimitive.Content.displayName;
var SelectLabel = React19.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx27(
    SelectPrimitive.Label,
    __spreadValues({
      ref,
      className: cn("py-1.5 pl-8 pr-2 text-sm font-semibold", className)
    }, props)
  );
});
SelectLabel.displayName = SelectPrimitive.Label.displayName;
var SelectItem = React19.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs13(
    SelectPrimitive.Item,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground [.theme-uturn_&]:focus:bg-primary [.theme-uturn_&]:focus:text-primary-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        className
      )
    }, props), {
      children: [
        /* @__PURE__ */ jsx27("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ jsx27(SelectPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx27(Check3, { className: "h-4 w-4" }) }) }),
        /* @__PURE__ */ jsx27(SelectPrimitive.ItemText, { children })
      ]
    })
  );
});
SelectItem.displayName = SelectPrimitive.Item.displayName;
var SelectSeparator = React19.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx27(
    SelectPrimitive.Separator,
    __spreadValues({
      ref,
      className: cn("-mx-1 my-1 h-px bg-muted", className)
    }, props)
  );
});
SelectSeparator.displayName = SelectPrimitive.Separator.displayName;

// src/components/separator/separator.tsx
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import * as React20 from "react";
import { jsx as jsx28 } from "react/jsx-runtime";
var Separator3 = React20.forwardRef(
  (_a, ref) => {
    var _b = _a, { className, orientation = "horizontal", decorative = true } = _b, props = __objRest(_b, ["className", "orientation", "decorative"]);
    return /* @__PURE__ */ jsx28(
      SeparatorPrimitive.Root,
      __spreadValues({
        ref,
        decorative,
        orientation,
        className: cn(
          "shrink-0 bg-border",
          orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
          className
        )
      }, props)
    );
  }
);
Separator3.displayName = SeparatorPrimitive.Root.displayName;

// src/components/shadcn-ui/mode-toggle.tsx
import { faBrightness, faMoon } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation as useTranslation2 } from "react-i18next";

// src/components/shadcn-ui/theme-provider.tsx
import { createContext as createContext3, useContext as useContext3, useEffect, useState as useState2 } from "react";
import { jsx as jsx29 } from "react/jsx-runtime";
var initialState = {
  theme: {
    color: "uturn",
    mode: "system"
  },
  setMode: () => null,
  setColor: () => null
};
var ThemeProviderContext = createContext3(initialState);
function ThemeProvider(_a) {
  var _b = _a, {
    children,
    defaultMode = "system",
    defaultColor = "uturn",
    storageKey = "ui-theme"
  } = _b, props = __objRest(_b, [
    "children",
    "defaultMode",
    "defaultColor",
    "storageKey"
  ]);
  const [theme, setTheme] = useState2(() => {
    const localTheme = localStorage.getItem(storageKey);
    const defaultTheme = {
      mode: defaultMode,
      color: defaultColor
    };
    if (localTheme === null) {
      return defaultTheme;
    }
    try {
      return JSON.parse(localTheme);
    } catch (e) {
      localStorage.setItem(storageKey, JSON.stringify(defaultTheme));
      return defaultTheme;
    }
  });
  useEffect(() => {
    const root = window.document.body;
    root.classList.remove("light", "dark");
    if (theme.mode === "system") {
      const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
      root.classList.add(systemTheme);
      return;
    }
    root.classList.add(`theme-${theme.color}`, theme.mode);
  }, [theme]);
  const value = {
    theme,
    setMode: (newMode) => {
      const newTheme = __spreadProps(__spreadValues({}, theme), {
        mode: newMode
      });
      localStorage.setItem(storageKey, JSON.stringify(newTheme));
      setTheme(newTheme);
    },
    setColor: (newColor) => {
      const newTheme = __spreadProps(__spreadValues({}, theme), {
        color: newColor
      });
      const root = window.document.body;
      root.classList.remove(`theme-${theme.color}`);
      localStorage.setItem(storageKey, JSON.stringify(newTheme));
      setTheme(newTheme);
    }
  };
  return /* @__PURE__ */ jsx29(ThemeProviderContext.Provider, __spreadProps(__spreadValues({}, props), { value, children }));
}
var useTheme = () => {
  const context = useContext3(ThemeProviderContext);
  if (context === void 0)
    throw new Error("useTheme must be used within a ThemeProvider");
  return context;
};

// src/components/shadcn-ui/mode-toggle.tsx
import { jsx as jsx30, jsxs as jsxs14 } from "react/jsx-runtime";
function ModeToggle() {
  const { setMode } = useTheme();
  const { t } = useTranslation2();
  return /* @__PURE__ */ jsxs14(DropdownMenu, { children: [
    /* @__PURE__ */ jsx30(DropdownMenuTrigger, { asChild: true, children: /* @__PURE__ */ jsxs14(
      Button,
      {
        variant: "outline",
        size: "icon",
        className: "flex items-center justify-center",
        children: [
          /* @__PURE__ */ jsx30("div", { className: "rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0", children: /* @__PURE__ */ jsx30(Icon, { icon: faBrightness, size: "lg", fixedWidth: true }) }),
          /* @__PURE__ */ jsx30("div", { className: "rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100 absolute", children: /* @__PURE__ */ jsx30(Icon, { icon: faMoon, size: "lg", fixedWidth: true }) }),
          /* @__PURE__ */ jsx30("span", { className: "sr-only", children: t("general.themes.toggle", "Toggle theme") })
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs14(DropdownMenuContent, { align: "end", children: [
      /* @__PURE__ */ jsx30(DropdownMenuItem, { onClick: () => setMode("light"), children: t("general.themes.light", "Light mode") }),
      /* @__PURE__ */ jsx30(DropdownMenuItem, { onClick: () => setMode("dark"), children: t("general.themes.dark", "Dark mode") }),
      /* @__PURE__ */ jsx30(DropdownMenuItem, { onClick: () => setMode("system"), children: t("general.themes.system", "Follow system") })
    ] })
  ] });
}

// src/components/sheet/sheet.tsx
import * as SheetPrimitive from "@radix-ui/react-dialog";
import { cva as cva6 } from "class-variance-authority";
import { X as X2 } from "lucide-react";
import * as React21 from "react";
import { jsx as jsx31, jsxs as jsxs15 } from "react/jsx-runtime";
var Sheet = SheetPrimitive.Root;
var SheetTrigger = SheetPrimitive.Trigger;
var SheetClose = SheetPrimitive.Close;
var SheetPortal = SheetPrimitive.Portal;
var SheetOverlay = React21.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx31(
    SheetPrimitive.Overlay,
    __spreadProps(__spreadValues({
      className: cn(
        "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        className
      )
    }, props), {
      ref
    })
  );
});
SheetOverlay.displayName = SheetPrimitive.Overlay.displayName;
var sheetVariants = cva6(
  "fixed z-50 gap-4 bg-card p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-md",
        right: "inset-y-0 right-0 h-full w-3/4  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-md"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
);
var SheetContent = React21.forwardRef((_a, ref) => {
  var _b = _a, { side = "right", className, children } = _b, props = __objRest(_b, ["side", "className", "children"]);
  return /* @__PURE__ */ jsxs15(SheetPortal, { children: [
    /* @__PURE__ */ jsx31(SheetOverlay, {}),
    /* @__PURE__ */ jsxs15(
      SheetPrimitive.Content,
      __spreadProps(__spreadValues({
        ref,
        className: cn(sheetVariants({ side }), className)
      }, props), {
        children: [
          children,
          /* @__PURE__ */ jsxs15(SheetPrimitive.Close, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary", children: [
            /* @__PURE__ */ jsx31(X2, { className: "h-4 w-4" }),
            /* @__PURE__ */ jsx31("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      })
    )
  ] });
});
SheetContent.displayName = SheetPrimitive.Content.displayName;
var SheetHeader = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx31(
    "div",
    __spreadValues({
      className: cn(
        "flex flex-col space-y-2 text-center sm:text-left",
        className
      )
    }, props)
  );
};
SheetHeader.displayName = "SheetHeader";
var SheetFooter = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx31(
    "div",
    __spreadValues({
      className: cn(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
        className
      )
    }, props)
  );
};
SheetFooter.displayName = "SheetFooter";
var SheetTitle = React21.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx31(
    SheetPrimitive.Title,
    __spreadValues({
      ref,
      className: cn("text-lg font-semibold text-foreground", className)
    }, props)
  );
});
SheetTitle.displayName = SheetPrimitive.Title.displayName;
var SheetDescription = React21.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx31(
    SheetPrimitive.Description,
    __spreadValues({
      ref,
      className: cn("text-sm text-muted-foreground", className)
    }, props)
  );
});
SheetDescription.displayName = SheetPrimitive.Description.displayName;

// src/components/skeleton/skeleton.tsx
import { jsx as jsx32 } from "react/jsx-runtime";
function Skeleton(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx32(
    "div",
    __spreadValues({
      className: cn("animate-pulse rounded-md bg-muted", className)
    }, props)
  );
}

// src/components/sonner/sonner.tsx
import { useTheme as useTheme2 } from "next-themes";
import { toast as sonner, Toaster } from "sonner";
import { jsx as jsx33 } from "react/jsx-runtime";
var Sonner = (_a) => {
  var props = __objRest(_a, []);
  const { theme = "system" } = useTheme2();
  return /* @__PURE__ */ jsx33(
    Toaster,
    __spreadValues({
      theme,
      className: "toaster group",
      toastOptions: {
        classNames: {
          toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
        }
      }
    }, props)
  );
};

// src/components/status/status.tsx
import { Fragment, jsx as jsx34, jsxs as jsxs16 } from "react/jsx-runtime";
var Status = (_a) => {
  var _b = _a, { className, status } = _b, props = __objRest(_b, ["className", "status"]);
  return /* @__PURE__ */ jsx34(
    Badge,
    __spreadValues({
      className: cn("flex items-center gap-2", "group", status, className),
      variant: "secondary"
    }, props)
  );
};
var StatusIndicator = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsxs16("span", __spreadProps(__spreadValues({ className: "relative flex h-2 w-2" }, props), { children: [
    /* @__PURE__ */ jsx34(
      "span",
      {
        className: cn(
          "absolute inline-flex h-full w-full animate-ping rounded-full opacity-75",
          "group-[.online]:bg-emerald-500",
          "group-[.offline]:bg-red-500",
          "group-[.maintenance]:bg-blue-500",
          "group-[.degraded]:bg-amber-500"
        )
      }
    ),
    /* @__PURE__ */ jsx34(
      "span",
      {
        className: cn(
          "relative inline-flex h-2 w-2 rounded-full",
          "group-[.online]:bg-emerald-500",
          "group-[.offline]:bg-red-500",
          "group-[.maintenance]:bg-blue-500",
          "group-[.degraded]:bg-amber-500"
        )
      }
    )
  ] }));
};
var StatusLabel = (_a) => {
  var _b = _a, {
    className,
    children
  } = _b, props = __objRest(_b, [
    "className",
    "children"
  ]);
  return /* @__PURE__ */ jsx34("span", __spreadProps(__spreadValues({ className: cn("text-muted-foreground", className) }, props), { children: children != null ? children : /* @__PURE__ */ jsxs16(Fragment, { children: [
    /* @__PURE__ */ jsx34("span", { className: "hidden group-[.online]:block", children: "Online" }),
    /* @__PURE__ */ jsx34("span", { className: "hidden group-[.offline]:block", children: "Offline" }),
    /* @__PURE__ */ jsx34("span", { className: "hidden group-[.maintenance]:block", children: "Maintenance" }),
    /* @__PURE__ */ jsx34("span", { className: "hidden group-[.degraded]:block", children: "Degraded" })
  ] }) }));
};

// src/components/switch/switch.tsx
import * as SwitchPrimitives from "@radix-ui/react-switch";
import * as React22 from "react";
import { jsx as jsx35 } from "react/jsx-runtime";
var Switch = React22.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx35(
    SwitchPrimitives.Root,
    __spreadProps(__spreadValues({
      className: cn(
        "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive",
        className
      )
    }, props), {
      ref,
      children: /* @__PURE__ */ jsx35(
        SwitchPrimitives.Thumb,
        {
          className: cn(
            "pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0 [.theme-uturn_&]:bg-foreground"
          )
        }
      )
    })
  );
});
Switch.displayName = SwitchPrimitives.Root.displayName;

// src/components/table/table.tsx
import * as React23 from "react";
import { jsx as jsx36 } from "react/jsx-runtime";
var Table = React23.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx36("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ jsx36(
    "table",
    __spreadValues({
      ref,
      className: cn(
        "w-full caption-bottom text-sm bg-card rounded-md",
        className
      )
    }, props)
  ) });
});
Table.displayName = "Table";
var TableHeader = React23.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx36("thead", __spreadValues({ ref, className: cn("[&_tr]:border-b", className) }, props));
});
TableHeader.displayName = "TableHeader";
var TableBody = React23.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx36(
    "tbody",
    __spreadValues({
      ref,
      className: cn("[&_tr:last-child]:border-0", className)
    }, props)
  );
});
TableBody.displayName = "TableBody";
var TableFooter = React23.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx36(
    "tfoot",
    __spreadValues({
      ref,
      className: cn(
        "border-t bg-muted/50 font-medium [&>tr]:last:border-b-0",
        className
      )
    }, props)
  );
});
TableFooter.displayName = "TableFooter";
var TableRow = React23.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx36(
    "tr",
    __spreadValues({
      ref,
      className: cn(
        "border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted",
        className
      )
    }, props)
  );
});
TableRow.displayName = "TableRow";
var TableHead = React23.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx36(
    "th",
    __spreadValues({
      ref,
      className: cn(
        "h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0",
        className
      )
    }, props)
  );
});
TableHead.displayName = "TableHead";
var TableCell = React23.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx36(
    "td",
    __spreadValues({
      ref,
      className: cn("p-4 align-middle [&:has([role=checkbox])]:pr-0", className)
    }, props)
  );
});
TableCell.displayName = "TableCell";
var TableCaption = React23.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx36(
    "caption",
    __spreadValues({
      ref,
      className: cn("mt-4 text-sm text-muted-foreground", className)
    }, props)
  );
});
TableCaption.displayName = "TableCaption";

// src/components/tabs/tabs.tsx
import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cva as cva7 } from "class-variance-authority";
import * as React24 from "react";
import { jsx as jsx37 } from "react/jsx-runtime";
var TabsVariantContext = React24.createContext("secondary");
var TAB_ACTIVE = {
  secondary: {
    trigger: "data-[state=active]:border data-[state=active]:border-border data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:shadow-sm data-[state=active]:hover:bg-card/80",
    active: "border border-border bg-card text-foreground shadow-sm hover:bg-card/80"
  },
  // UTURN: black pill + lime text (light), lime pill + black text (dark).
  primary: {
    trigger: "data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:hover:bg-primary/90 [.theme-uturn_&]:data-[state=active]:bg-foreground [.theme-uturn_&]:data-[state=active]:text-primary [.theme-uturn_&]:data-[state=active]:hover:bg-foreground/90 [.theme-uturn_&]:data-[state=active]:hover:text-primary [.dark.theme-uturn_&]:data-[state=active]:bg-primary [.dark.theme-uturn_&]:data-[state=active]:text-primary-foreground [.dark.theme-uturn_&]:data-[state=active]:hover:bg-primary/90 [.dark.theme-uturn_&]:data-[state=active]:hover:text-primary-foreground",
    active: "bg-primary text-primary-foreground hover:bg-primary/90 [.theme-uturn_&]:bg-foreground [.theme-uturn_&]:text-primary [.theme-uturn_&]:hover:bg-foreground/90 [.theme-uturn_&]:hover:text-primary [.dark.theme-uturn_&]:bg-primary [.dark.theme-uturn_&]:text-primary-foreground [.dark.theme-uturn_&]:hover:bg-primary/90 [.dark.theme-uturn_&]:hover:text-primary-foreground"
  }
};
function tabTriggerActiveClass(variant) {
  return TAB_ACTIVE[variant].active;
}
var Tabs = React24.forwardRef((_a, ref) => {
  var _b = _a, { variant = "secondary" } = _b, props = __objRest(_b, ["variant"]);
  return /* @__PURE__ */ jsx37(TabsVariantContext.Provider, { value: variant, children: /* @__PURE__ */ jsx37(TabsPrimitive.Root, __spreadValues({ ref }, props)) });
});
Tabs.displayName = "Tabs";
var TabsList = React24.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx37(
    TabsPrimitive.List,
    __spreadValues({
      ref,
      className: cn(
        "inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground",
        className
      )
    }, props)
  );
});
TabsList.displayName = TabsPrimitive.List.displayName;
var tabsTriggerVariants = cva7(
  "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        secondary: TAB_ACTIVE.secondary.trigger,
        primary: TAB_ACTIVE.primary.trigger
      }
    },
    defaultVariants: {
      variant: "secondary"
    }
  }
);
var TabsTrigger = React24.forwardRef((_a, ref) => {
  var _b = _a, { className, variant } = _b, props = __objRest(_b, ["className", "variant"]);
  const contextVariant = React24.useContext(TabsVariantContext);
  return /* @__PURE__ */ jsx37(
    TabsPrimitive.Trigger,
    __spreadValues({
      ref,
      className: cn(
        tabsTriggerVariants({ variant: variant != null ? variant : contextVariant }),
        className
      )
    }, props)
  );
});
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
var TabsContent = React24.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx37(
    TabsPrimitive.Content,
    __spreadValues({
      ref,
      className: cn(
        "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        className
      )
    }, props)
  );
});
TabsContent.displayName = TabsPrimitive.Content.displayName;

// src/components/textarea/textarea.tsx
import * as React25 from "react";
import { jsx as jsx38 } from "react/jsx-runtime";
var Textarea = React25.forwardRef(
  (_a, ref) => {
    var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
    return /* @__PURE__ */ jsx38(
      "textarea",
      __spreadValues({
        className: cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive",
          className
        ),
        ref
      }, props)
    );
  }
);
Textarea.displayName = "Textarea";

// src/components/toast/toast.tsx
import * as ToastPrimitives from "@radix-ui/react-toast";
import { cva as cva8 } from "class-variance-authority";
import { X as X3 } from "lucide-react";
import * as React26 from "react";
import { jsx as jsx39 } from "react/jsx-runtime";
var ToastProvider = ToastPrimitives.Provider;
var ToastViewport = React26.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx39(
    ToastPrimitives.Viewport,
    __spreadValues({
      ref,
      className: cn(
        "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
        className
      )
    }, props)
  );
});
ToastViewport.displayName = ToastPrimitives.Viewport.displayName;
var toastVariants = cva8(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-card text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
var Toast = React26.forwardRef((_a, ref) => {
  var _b = _a, { className, variant } = _b, props = __objRest(_b, ["className", "variant"]);
  return /* @__PURE__ */ jsx39(
    ToastPrimitives.Root,
    __spreadValues({
      ref,
      className: cn(toastVariants({ variant }), className)
    }, props)
  );
});
Toast.displayName = ToastPrimitives.Root.displayName;
var ToastAction = React26.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx39(
    ToastPrimitives.Action,
    __spreadValues({
      ref,
      className: cn(
        "inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive",
        className
      )
    }, props)
  );
});
ToastAction.displayName = ToastPrimitives.Action.displayName;
var ToastClose = React26.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx39(
    ToastPrimitives.Close,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
        className
      ),
      "toast-close": ""
    }, props), {
      children: /* @__PURE__ */ jsx39(X3, { className: "h-4 w-4" })
    })
  );
});
ToastClose.displayName = ToastPrimitives.Close.displayName;
var ToastTitle = React26.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx39(
    ToastPrimitives.Title,
    __spreadValues({
      ref,
      className: cn("text-sm font-semibold", className)
    }, props)
  );
});
ToastTitle.displayName = ToastPrimitives.Title.displayName;
var ToastDescription = React26.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx39(
    ToastPrimitives.Description,
    __spreadValues({
      ref,
      className: cn("text-sm opacity-90", className)
    }, props)
  );
});
ToastDescription.displayName = ToastPrimitives.Description.displayName;

// src/components/toast/toaster.tsx
import { jsx as jsx40, jsxs as jsxs17 } from "react/jsx-runtime";
function Toaster2() {
  const { toasts } = useToast();
  return /* @__PURE__ */ jsxs17(ToastProvider, { children: [
    toasts.map((_a) => {
      var _b = _a, { id, title, description, action } = _b, props = __objRest(_b, ["id", "title", "description", "action"]);
      return /* @__PURE__ */ jsxs17(Toast, __spreadProps(__spreadValues({}, props), { children: [
        /* @__PURE__ */ jsxs17("div", { className: "grid gap-1", children: [
          title && /* @__PURE__ */ jsx40(ToastTitle, { children: title }),
          description && /* @__PURE__ */ jsx40(ToastDescription, { children: description })
        ] }),
        action,
        /* @__PURE__ */ jsx40(ToastClose, {})
      ] }), id);
    }),
    /* @__PURE__ */ jsx40(ToastViewport, {})
  ] });
}

// src/components/toast/use-toast.ts
import * as React27 from "react";
var TOAST_LIMIT = 1;
var TOAST_REMOVE_DELAY = 1e6;
var count = 0;
function genId() {
  count = (count + 1) % Number.MAX_SAFE_INTEGER;
  return count.toString();
}
var toastTimeouts = /* @__PURE__ */ new Map();
var addToRemoveQueue = (toastId) => {
  if (toastTimeouts.has(toastId)) {
    return;
  }
  const timeout = setTimeout(() => {
    toastTimeouts.delete(toastId);
    dispatch({
      type: "REMOVE_TOAST",
      toastId
    });
  }, TOAST_REMOVE_DELAY);
  toastTimeouts.set(toastId, timeout);
};
var reducer = (state, action) => {
  switch (action.type) {
    case "ADD_TOAST":
      return __spreadProps(__spreadValues({}, state), {
        toasts: [action.toast, ...state.toasts].slice(0, TOAST_LIMIT)
      });
    case "UPDATE_TOAST":
      return __spreadProps(__spreadValues({}, state), {
        toasts: state.toasts.map(
          (t) => t.id === action.toast.id ? __spreadValues(__spreadValues({}, t), action.toast) : t
        )
      });
    case "DISMISS_TOAST": {
      const { toastId } = action;
      if (toastId) {
        addToRemoveQueue(toastId);
      } else {
        state.toasts.forEach((toast2) => {
          addToRemoveQueue(toast2.id);
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        toasts: state.toasts.map(
          (t) => t.id === toastId || toastId === void 0 ? __spreadProps(__spreadValues({}, t), {
            open: false
          }) : t
        )
      });
    }
    case "REMOVE_TOAST":
      if (action.toastId === void 0) {
        return __spreadProps(__spreadValues({}, state), {
          toasts: []
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        toasts: state.toasts.filter((t) => t.id !== action.toastId)
      });
    default:
      return state;
  }
};
var listeners = [];
var memoryState = { toasts: [] };
function dispatch(action) {
  memoryState = reducer(memoryState, action);
  listeners.forEach((listener) => {
    listener(memoryState);
  });
}
function toast(_a) {
  var props = __objRest(_a, []);
  const id = genId();
  const update = (props2) => dispatch({
    type: "UPDATE_TOAST",
    toast: __spreadProps(__spreadValues({}, props2), { id })
  });
  const dismiss = () => dispatch({ type: "DISMISS_TOAST", toastId: id });
  dispatch({
    type: "ADD_TOAST",
    toast: __spreadProps(__spreadValues({}, props), {
      id,
      open: true,
      onOpenChange: (open) => {
        if (!open) dismiss();
      }
    })
  });
  return {
    id,
    dismiss,
    update
  };
}
function useToast() {
  const [state, setState] = React27.useState(memoryState);
  React27.useEffect(() => {
    listeners.push(setState);
    return () => {
      const index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);
  return __spreadProps(__spreadValues({}, state), {
    toast,
    dismiss: (toastId) => dispatch({ type: "DISMISS_TOAST", toastId })
  });
}

// src/components/toggle/toggle.tsx
import * as TogglePrimitive from "@radix-ui/react-toggle";
import { cva as cva9 } from "class-variance-authority";
import * as React28 from "react";
import { jsx as jsx41 } from "react/jsx-runtime";
var toggleVariants = cva9(
  "inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors hover:bg-muted hover:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 gap-2",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-input bg-transparent hover:bg-accent hover:text-accent-foreground"
      },
      size: {
        default: "h-10 px-3 min-w-10",
        sm: "h-9 px-2.5 min-w-9",
        lg: "h-11 px-5 min-w-11"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
var Toggle = React28.forwardRef((_a, ref) => {
  var _b = _a, { className, variant, size } = _b, props = __objRest(_b, ["className", "variant", "size"]);
  return /* @__PURE__ */ jsx41(
    TogglePrimitive.Root,
    __spreadValues({
      ref,
      className: cn(toggleVariants({ variant, size, className }))
    }, props)
  );
});
Toggle.displayName = TogglePrimitive.Root.displayName;

// src/components/toggle/toggle-group.tsx
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";
import * as React29 from "react";
import { jsx as jsx42 } from "react/jsx-runtime";
var ToggleGroupContext = React29.createContext({
  size: "default",
  variant: "default"
});
var ToggleGroup = React29.forwardRef((_a, ref) => {
  var _b = _a, { className, variant, size, children } = _b, props = __objRest(_b, ["className", "variant", "size", "children"]);
  return /* @__PURE__ */ jsx42(
    ToggleGroupPrimitive.Root,
    __spreadProps(__spreadValues({
      ref,
      className: cn("flex items-center justify-center gap-1", className)
    }, props), {
      children: /* @__PURE__ */ jsx42(ToggleGroupContext.Provider, { value: { variant, size }, children })
    })
  );
});
ToggleGroup.displayName = ToggleGroupPrimitive.Root.displayName;
var ToggleGroupItem = React29.forwardRef((_a, ref) => {
  var _b = _a, { className, children, variant, size } = _b, props = __objRest(_b, ["className", "children", "variant", "size"]);
  const context = React29.useContext(ToggleGroupContext);
  return /* @__PURE__ */ jsx42(
    ToggleGroupPrimitive.Item,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        toggleVariants({
          variant: context.variant || variant,
          size: context.size || size
        }),
        className
      )
    }, props), {
      children
    })
  );
});
ToggleGroupItem.displayName = ToggleGroupPrimitive.Item.displayName;

// src/components/tooltip/tooltip.tsx
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import * as React30 from "react";
import { jsx as jsx43 } from "react/jsx-runtime";
var TooltipProvider = TooltipPrimitive.Provider;
var Tooltip = TooltipPrimitive.Root;
var TooltipTrigger = TooltipPrimitive.Trigger;
var TooltipContent = React30.forwardRef((_a, ref) => {
  var _b = _a, { className, sideOffset = 4 } = _b, props = __objRest(_b, ["className", "sideOffset"]);
  return /* @__PURE__ */ jsx43(
    TooltipPrimitive.Content,
    __spreadValues({
      ref,
      sideOffset,
      className: cn(
        "z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      )
    }, props)
  );
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

// src/components/uturn-ui/index.ts
var uturn_ui_exports = {};
__export(uturn_ui_exports, {
  AgGridReact: () => AgGridReact,
  AutoComplete: () => AutoComplete,
  AverageLine: () => AverageLine,
  Callout: () => Callout,
  CalloutIcon: () => CalloutIcon,
  CalloutTitle: () => CalloutTitle,
  Chart: () => Chart,
  ChartCustomTooltip: () => ChartCustomTooltip,
  Combobox: () => Combobox,
  CopyToClipboard: () => CopyToClipboard,
  DATETIME_HINT: () => DATETIME_HINT,
  DATE_HINT: () => DATE_HINT,
  DatePicker: () => DatePicker,
  EmptyState: () => EmptyState,
  FormCheckboxGroupItem: () => FormCheckboxGroupItem,
  FormFieldReadOnly: () => FormFieldReadOnly,
  FormRadioGroupHorizontalItem: () => FormRadioGroupHorizontalItem,
  Icon: () => Icon,
  InputAddon: () => InputAddon,
  LicenseManager: () => LicenseManager,
  Logo: () => Logo,
  MoneyCell: () => money_cell_default,
  MultiSelect: () => MultiSelect,
  MultiSelectBadge: () => MultiSelectBadge2,
  PaginationCompact: () => PaginationCompact,
  Ratings: () => Ratings,
  Stars: () => Stars,
  agColIdSchema: () => agColIdSchema,
  agFilterModelSchema: () => agFilterModelSchema,
  agSortModelItemSchema: () => agSortModelItemSchema,
  debug: () => debug,
  isDateFilterModel: () => isDateFilterModel,
  isGroupOptions: () => isRequiredGroupOptions,
  isIMultiFilterModel: () => isIMultiFilterModel,
  isNumberFilterModel: () => isNumberFilterModel,
  isOption: () => isRequiredOption,
  isSetFilterModel: () => isSetFilterModel,
  isTextFilterModel: () => isTextFilterModel,
  multiSelectValueAsString: () => multiSelectValueAsString,
  selectedOptionTypesAsString: () => selectedOptionTypesAsString,
  useMultiSelect: () => useMultiSelect
});

// src/components/uturn-ui/ag-grid/index.tsx
var ag_grid_exports = {};
__export(ag_grid_exports, {
  AgGridReact: () => AgGridReact,
  LicenseManager: () => LicenseManager,
  MoneyCell: () => money_cell_default,
  agColIdSchema: () => agColIdSchema,
  agFilterModelSchema: () => agFilterModelSchema,
  agSortModelItemSchema: () => agSortModelItemSchema,
  isDateFilterModel: () => isDateFilterModel,
  isIMultiFilterModel: () => isIMultiFilterModel,
  isNumberFilterModel: () => isNumberFilterModel,
  isSetFilterModel: () => isSetFilterModel,
  isTextFilterModel: () => isTextFilterModel
});
__reExport(ag_grid_exports, ag_grid_community_star);
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { ModuleRegistry, provideGlobalGridOptions } from "ag-grid-community";
import { AllEnterpriseModule } from "ag-grid-enterprise";
import * as ag_grid_community_star from "ag-grid-community";
import { LicenseManager } from "ag-grid-enterprise";
import {
  AgGridReact
} from "ag-grid-react";

// src/components/uturn-ui/ag-grid/money-cell.tsx
import { CurrencyUtils } from "@uturn/utilities/browser";
import { Fragment as Fragment2, jsx as jsx44 } from "react/jsx-runtime";
var MoneyCell = (props) => {
  var _a, _b;
  if (typeof props.value !== "object") {
    return /* @__PURE__ */ jsx44(Fragment2, { children: props.value });
  }
  if (!Object.keys(props.value).includes("amount") || !Object.keys(props.value).includes("currency")) {
    return /* @__PURE__ */ jsx44(Fragment2, { children: JSON.stringify(props.value) });
  }
  return /* @__PURE__ */ jsx44(Fragment2, { children: CurrencyUtils.formatPriceString(
    (_a = props.value) == null ? void 0 : _a.amount,
    (_b = props.value) == null ? void 0 : _b.currency,
    window.navigator.language
  ) });
};
var money_cell_default = MoneyCell;

// src/components/uturn-ui/ag-grid/typeguards.ts
import { isPlainObject as isObject } from "@uturn/utilities/browser";
var isTextFilterModel = (model) => {
  if (isObject(model) && "filterType" in model && !("colId" in model)) {
    return model.filterType === "text";
  }
  return false;
};
var isNumberFilterModel = (model) => {
  if (isObject(model) && "filterType" in model && !("colId" in model)) {
    return model.filterType === "number";
  }
  return false;
};
var isDateFilterModel = (model) => {
  if (isObject(model) && "filterType" in model && !("colId" in model)) {
    return model.filterType === "date";
  }
  return false;
};
var isSetFilterModel = (model) => {
  if (isObject(model) && "filterType" in model && !("colId" in model)) {
    return model.filterType === "set";
  }
  return false;
};
var isIMultiFilterModel = (model) => {
  if (isObject(model) && "filterType" in model && !("colId" in model)) {
    return model.filterType === "multi";
  }
  return false;
};

// src/components/uturn-ui/ag-grid/zod/col-id.ts
import { z } from "zod";
var agColIdSchema = z.string();

// src/components/uturn-ui/ag-grid/zod/filter-model.ts
import { z as z9 } from "zod";

// src/components/uturn-ui/ag-grid/zod/filter-model/advanced.ts
import z2 from "zod";
var agTextAdvancedFilterModelTypeSchema = z2.enum([
  "equals",
  "notEqual",
  "contains",
  "notContains",
  "startsWith",
  "endsWith",
  "blank",
  "notBlank"
]);
var agScalarAdvancedFilterModelTypeSchema = z2.enum([
  "equals",
  "notEqual",
  "lessThan",
  "lessThanOrEqual",
  "greaterThan",
  "greaterThanOrEqual",
  "blank",
  "notBlank"
]);
var agBooleanAdvancedFilterModelTypeSchema = z2.enum([
  "true",
  "false"
]);
var agTextAdvancedFilterModelSchema = z2.object({
  filterType: z2.literal("text"),
  colId: agColIdSchema,
  type: agTextAdvancedFilterModelTypeSchema,
  filter: z2.string().optional()
});
var agNumberAdvancedFilterModelSchema = z2.object({
  filterType: z2.literal("number"),
  colId: agColIdSchema,
  type: agScalarAdvancedFilterModelTypeSchema,
  filter: z2.number().optional()
});
var agBooleanAdvancedFilterModelSchema = z2.object({
  filterType: z2.literal("boolean"),
  colId: agColIdSchema,
  type: agBooleanAdvancedFilterModelTypeSchema,
  filter: z2.number().optional()
});
var agDateAdvancedFilterModelSchema = z2.object({
  filterType: z2.literal("date"),
  colId: agColIdSchema,
  type: agScalarAdvancedFilterModelTypeSchema,
  filter: z2.string().optional()
});
var agDateStringAdvancedFilterModelSchema = z2.object({
  filterType: z2.literal("dateString"),
  colId: agColIdSchema,
  type: agScalarAdvancedFilterModelTypeSchema,
  filter: z2.string().optional()
});
var agObjectAdvancedFilterModelSchema = z2.object({
  filterType: z2.literal("object"),
  colId: agColIdSchema,
  type: agTextAdvancedFilterModelTypeSchema,
  filter: z2.string().optional()
});
var agColumnAdvancedFilterModelSchema = agTextAdvancedFilterModelSchema.or(agNumberAdvancedFilterModelSchema).or(agBooleanAdvancedFilterModelSchema).or(agDateAdvancedFilterModelSchema).or(agDateStringAdvancedFilterModelSchema).or(
  agObjectAdvancedFilterModelSchema
);
var agJoinAdvancedFilterModelSchema = z2.object({
  filterType: z2.literal("join"),
  type: z2.enum(["AND", "OR"]),
  conditions: z2.array(
    agColumnAdvancedFilterModelSchema.or(
      z2.lazy(() => agJoinAdvancedFilterModelSchema)
    )
  )
});
var agAdvancedFilterModelSchema = agJoinAdvancedFilterModelSchema.or(
  agColumnAdvancedFilterModelSchema
);

// src/components/uturn-ui/ag-grid/zod/filter-model/date.ts
import z3 from "zod";
var agDateFilterModelSchema = z3.object({
  filterType: z3.literal("date").optional(),
  dateFrom: z3.string().nullable(),
  dateTo: z3.string().nullable()
});

// src/components/uturn-ui/ag-grid/zod/filter-model/multi.ts
import z4 from "zod";
var agIMultiFilterModelSchema = z4.object({
  filterType: z4.literal("multi").optional(),
  filterModels: z4.array(z4.any()).nullable()
});

// src/components/uturn-ui/ag-grid/zod/filter-model/number.ts
import z5 from "zod";
var agNumberFilterModelSchema = z5.object({
  filterType: z5.literal("number").optional(),
  filter: z5.number().nullable().optional(),
  filterTo: z5.number().nullable().optional()
});

// src/components/uturn-ui/ag-grid/zod/filter-model/set.ts
import z6 from "zod";
var agSetFilterModelSchema = z6.object({
  filterType: z6.literal("set").optional(),
  values: z6.array(z6.string().nullable())
});

// src/components/uturn-ui/ag-grid/zod/filter-model/simple.ts
import z7 from "zod";
var agISimpleFilterModelTypeSchema = z7.enum([
  "equals",
  "contains",
  "endsWith",
  "startsWith",
  "empty",
  "notEqual",
  "lessThan",
  "lessThanOrEqual",
  "greaterThan",
  "greaterThanOrEqual",
  "inRange",
  "notContains",
  "blank",
  "notBlank"
]);
var agISimpleFilterModelSchema = z7.object({
  type: agISimpleFilterModelTypeSchema.nullable().optional()
});

// src/components/uturn-ui/ag-grid/zod/filter-model/text.ts
import z8 from "zod";
var agTextFilterModelSchema = z8.object({
  filterType: z8.literal("text").optional(),
  filter: z8.string().nullable().optional(),
  filterTo: z8.string().nullable().optional()
});

// src/components/uturn-ui/ag-grid/zod/filter-model.ts
var agFilterModelSchema = z9.record(
  agColIdSchema,
  agISimpleFilterModelSchema.and(
    agNumberFilterModelSchema.or(agTextFilterModelSchema).or(agDateFilterModelSchema).or(agSetFilterModelSchema).or(agIMultiFilterModelSchema).or(agAdvancedFilterModelSchema)
  )
);

// src/components/uturn-ui/ag-grid/zod/sort-model.ts
import { z as z10 } from "zod";
var agSortModelItemSchema = z10.object({
  colId: agColIdSchema,
  sort: z10.enum(["asc", "desc"])
});

// src/components/uturn-ui/ag-grid/index.tsx
ModuleRegistry.registerModules([AllEnterpriseModule]);
provideGlobalGridOptions({ theme: "legacy" });

// src/components/uturn-ui/index.ts
__reExport(uturn_ui_exports, ag_grid_exports);

// src/components/uturn-ui/auto-complete.tsx
import { Command as CommandPrimitive2 } from "cmdk";
import {
  useCallback,
  useEffect as useEffect3,
  useRef,
  useState as useState4
} from "react";
import { useDebouncedCallback as useDebouncedCallback2 } from "use-debounce";
import { jsx as jsx45, jsxs as jsxs18 } from "react/jsx-runtime";
function AutoComplete({
  options,
  placeholder,
  emptyMessage,
  value,
  onValueChange,
  onInputChange,
  setSelected,
  disabled,
  forceUniqueLabelsEnabled,
  debouncerDelay,
  refCallback,
  "aria-invalid": ariaInvalid
}) {
  const inputRef = useRef(null);
  const [isOpen, setOpen] = useState4(false);
  const [inputValue, setInputValue] = useState4(value != null ? value : "");
  const handleKeyDown = useCallback(
    (event) => {
      const input = inputRef.current;
      if (!input) {
        return;
      }
      if (!isOpen) {
        setOpen(true);
      }
      if (event.key === "Enter" && input.value !== "") {
        const indexOfOption = options.findIndex(
          (option) => option.label === input.value
        );
        if (indexOfOption !== -1) {
          setSelected == null ? void 0 : setSelected(indexOfOption);
        }
      }
      if (event.key === "Escape") {
        input.blur();
      }
    },
    [isOpen, options, onValueChange, onInputChange]
  );
  const handleBlur = useCallback(() => {
    setOpen(false);
  }, []);
  const handleSelectOption = useCallback(
    (selectedOption, index) => {
      setInputValue(selectedOption.label);
      setSelected == null ? void 0 : setSelected(index);
      setTimeout(() => {
        var _a;
        (_a = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a.blur();
      }, 0);
    },
    [onValueChange, onInputChange]
  );
  useEffect3(() => {
    if (value !== void 0) {
      setInputValue(value);
    }
  }, [value]);
  useEffect3(() => {
    onValueChange == null ? void 0 : onValueChange(inputValue);
  }, [inputValue]);
  const debouncer = useDebouncedCallback2((targetValue) => {
    onInputChange == null ? void 0 : onInputChange(targetValue);
  }, debouncerDelay || 0);
  const handleChange = (e) => {
    const targetValue = e.target.value || "";
    setInputValue(targetValue);
    if (isOpen) {
      debouncer(targetValue);
    }
  };
  return /* @__PURE__ */ jsxs18(CommandPrimitive2, { onKeyDown: handleKeyDown, children: [
    /* @__PURE__ */ jsx45("div", { children: /* @__PURE__ */ jsx45(
      Input,
      {
        ref: (el) => {
          if (refCallback && el) {
            refCallback(el);
            inputRef.current = el;
          }
        },
        value: inputValue,
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: () => {
          setOpen(true);
        },
        placeholder,
        disabled,
        "aria-invalid": ariaInvalid
      }
    ) }),
    /* @__PURE__ */ jsx45("div", { className: "relative mt-1", children: isOpen && inputValue.length > 2 ? /* @__PURE__ */ jsx45("div", { className: "rounded-x bg-background animate-in fade-in-0 zoom-in-95 absolute top-0 z-10 w-full outline-none", children: /* @__PURE__ */ jsxs18(CommandList, { className: "ring-accent rounded-lg ring-1", children: [
      options.length > 0 ? /* @__PURE__ */ jsx45(CommandGroup, { children: options.map((option, index) => {
        return /* @__PURE__ */ jsx45(
          CommandItem,
          {
            value: (forceUniqueLabelsEnabled != null ? forceUniqueLabelsEnabled : false) === true ? `${option.label}-${index}` : option.label,
            onMouseDown: (event) => {
              event.preventDefault();
              event.stopPropagation();
            },
            onSelect: () => handleSelectOption(option, index),
            className: cn("flex items-center gap-2 w-full"),
            children: option.label
          },
          `${option.value}-${index}`
        );
      }) }) : null,
      options.length === 0 ? /* @__PURE__ */ jsx45(CommandPrimitive2.Empty, { className: "select-none rounded-sm px-2 py-3 text-center text-sm", children: emptyMessage }) : null
    ] }) }) : null })
  ] });
}

// src/components/uturn-ui/callout.tsx
import { cva as cva10 } from "class-variance-authority";
import { X as X4 } from "lucide-react";
import * as React31 from "react";
import { jsx as jsx46, jsxs as jsxs19 } from "react/jsx-runtime";
var calloutVariants = cva10(
  "relative w-full rounded-lg border p-4 flex items-center gap-4",
  {
    variants: {
      variant: {
        default: "text-secondary-foreground bg-secondary",
        destructive: "border-destructive/50 text-destructive bg-red-50 dark:bg-red-500 dark:text-destructive-foreground dark:border-destructive",
        warning: "bg-yellow-50 text-warning border-warning/50 dark:bg-yellow-800 dark:border-warning"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
var Callout = React31.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      className,
      variant,
      children,
      defaultOpen = true,
      onDismiss,
      dismissible = false,
      dismissAriaLabel = "Dismiss"
    } = _b, props = __objRest(_b, [
      "className",
      "variant",
      "children",
      "defaultOpen",
      "onDismiss",
      "dismissible",
      "dismissAriaLabel"
    ]);
    const [open, setOpen] = React31.useState(defaultOpen);
    const close = () => {
      setOpen(false);
    };
    if (!open) {
      return null;
    }
    return /* @__PURE__ */ jsxs19(
      "div",
      __spreadProps(__spreadValues({
        ref,
        "data-state": open ? "open" : "closed",
        className: cn(calloutVariants({ variant }), className)
      }, props), {
        children: [
          children,
          dismissible && /* @__PURE__ */ jsxs19(
            "button",
            {
              type: "button",
              onClick: (e) => {
                onDismiss == null ? void 0 : onDismiss(e);
                close();
              },
              "aria-label": dismissAriaLabel,
              className: cn(
                "absolute right-2 top-2 rounded-sm opacity-70 ring-offset-background",
                "transition-opacity hover:opacity-100 focus:outline-none",
                "focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none"
              ),
              children: [
                /* @__PURE__ */ jsx46(X4, { className: "h-4 w-4" }),
                /* @__PURE__ */ jsx46("span", { className: "sr-only", children: dismissAriaLabel })
              ]
            }
          )
        ]
      })
    );
  }
);
Callout.displayName = "Callout";
var CalloutIcon = React31.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx46("span", __spreadProps(__spreadValues({}, props), { className: cn("", className), ref, children: props.children }));
});
CalloutIcon.displayName = "CalloutIcon";
var CalloutTitle = React31.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx46("p", __spreadProps(__spreadValues({ ref, className: cn("tracking-tight text-sm", className) }, props), { children: props.children }));
});
CalloutTitle.displayName = "CalloutTitle";

// src/components/uturn-ui/chart/average-line.tsx
import { jsx as jsx47, jsxs as jsxs20 } from "react/jsx-runtime";
function AverageLine({ min, max, average }) {
  return /* @__PURE__ */ jsxs20("div", { className: "relative ml-7 mr-10 mt-14 flex size-auto content-center", children: [
    /* @__PURE__ */ jsx47("div", { className: "bg-muted-foreground/20 h-0.5 w-full flex-1" }),
    /* @__PURE__ */ jsxs20("div", { className: "absolute top-0 flex flex-col", children: [
      /* @__PURE__ */ jsx47("div", { className: "bg-muted-foreground/20 size-2 -translate-x-px -translate-y-2/4 rounded-full" }),
      /* @__PURE__ */ jsxs20("div", { className: "-mt-12 flex -translate-x-1/2 flex-col justify-center", children: [
        /* @__PURE__ */ jsx47("div", { className: "text-muted-foreground text-xs", children: "Lowest" }),
        /* @__PURE__ */ jsxs20("div", { className: "text-xs font-bold", children: [
          "\u20AC ",
          min
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs20("div", { className: "absolute left-1/2 top-0 flex flex-col", children: [
      /* @__PURE__ */ jsx47("div", { className: "bg-primary size-3 -translate-x-1/2 -translate-y-2/4 rounded-full" }),
      /* @__PURE__ */ jsxs20("div", { className: "text-primary -mt-12 -translate-x-1/2 text-xl font-bold", children: [
        "\u20AC ",
        average
      ] })
    ] }),
    /* @__PURE__ */ jsxs20("div", { className: "absolute right-0 top-0 flex translate-x-full flex-col", children: [
      /* @__PURE__ */ jsx47("div", { className: "bg-muted-foreground/20 size-2 -translate-y-2/4 rounded-full" }),
      /* @__PURE__ */ jsxs20("div", { className: "-mt-12 flex -translate-x-1/2 flex-col items-end justify-center", children: [
        /* @__PURE__ */ jsx47("div", { className: "text-muted-foreground text-xs", children: "Highest" }),
        /* @__PURE__ */ jsxs20("div", { className: "text-xs font-bold", children: [
          "\u20AC ",
          max
        ] })
      ] })
    ] })
  ] });
}

// src/components/uturn-ui/chart/chart.tsx
import {
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip as Tooltip2,
  XAxis,
  YAxis
} from "recharts";

// src/components/uturn-ui/chart/chart-custom-tooltip.tsx
import { jsx as jsx48, jsxs as jsxs21 } from "react/jsx-runtime";
function ChartCustomTooltip({
  active,
  payload,
  customLabel
}) {
  if (active && payload && payload.length) {
    const { payload: data } = payload[0];
    return /* @__PURE__ */ jsxs21("div", { className: "bg-opacity-78 bg-secondary rounded px-3 py-2", children: [
      /* @__PURE__ */ jsx48("div", { className: "text-secondary-foreground text-lg font-semibold", children: data.name }),
      /* @__PURE__ */ jsx48("div", { className: "text-secondary-foreground text-sm", children: `${customLabel != null ? customLabel : ""} ${data.x}` })
    ] });
  }
  return null;
}

// src/components/uturn-ui/chart/chart.tsx
import { jsx as jsx49, jsxs as jsxs22 } from "react/jsx-runtime";
function Chart({
  data,
  ticks = [],
  tickFormatter,
  tooltipYdescription,
  tooltipVisible = true
}) {
  const style = {
    tick: {
      fill: "rgb(148, 174, 184)",
      fontSize: 12
    },
    stroke: {
      color: "rgb(148, 174, 184)",
      width: 1.5,
      opacity: 0.8
    },
    cursor: {
      className: "stroke-success-500 stroke-[0.4] [stroke-dasharray:5]"
    },
    line: {
      stroke: "rgb(23, 191, 234)",
      strokeWidth: 3,
      dot: {
        r: tooltipVisible ? 5 : 1,
        strokeWidth: 1
      }
    }
  };
  const yDomain = ticks.length > 0 ? [ticks[0], ticks[ticks.length - 1]] : ["auto", "auto"];
  return /* @__PURE__ */ jsx49(ResponsiveContainer, { width: "100%", height: 400, children: /* @__PURE__ */ jsxs22(
    LineChart,
    {
      data,
      margin: {
        right: 10
      },
      children: [
        /* @__PURE__ */ jsx49(
          XAxis,
          {
            dataKey: "name",
            angle: 0,
            textAnchor: "middle",
            tickLine: false,
            tick: style.tick,
            className: "stroke-secondary-100"
          }
        ),
        /* @__PURE__ */ jsx49(
          YAxis,
          {
            allowDataOverflow: true,
            domain: yDomain,
            ticks,
            tickFormatter,
            tick: style.tick,
            className: "stroke-secondary-100"
          }
        ),
        ticks.length > 3 && /* @__PURE__ */ jsx49(
          ReferenceLine,
          {
            y: ticks[3],
            stroke: style.stroke.color,
            strokeWidth: style.stroke.width,
            strokeOpacity: style.stroke.opacity
          }
        ),
        /* @__PURE__ */ jsx49(
          Tooltip2,
          {
            cursor: style.cursor,
            content: tooltipVisible ? /* @__PURE__ */ jsx49(ChartCustomTooltip, { customLabel: tooltipYdescription }) : (() => null)
          }
        ),
        /* @__PURE__ */ jsx49(
          Line,
          {
            type: "natural",
            dataKey: "x",
            stroke: style.line.stroke,
            strokeWidth: style.line.strokeWidth,
            dot: style.line.dot
          }
        )
      ]
    }
  ) });
}

// src/components/uturn-ui/copy-to-clipboard/index.tsx
import { faCopy } from "@fortawesome/pro-regular-svg-icons";
import { AnimatePresence, motion } from "framer-motion";
import { useState as useState6 } from "react";
import { jsx as jsx50, jsxs as jsxs23 } from "react/jsx-runtime";
var CopyToClipboard = ({
  value,
  successMessage,
  className
}) => {
  const [openTooltip, setOpenTooltip] = useState6(false);
  return /* @__PURE__ */ jsxs23(
    Button,
    {
      variant: "link",
      size: "icon",
      onClick: (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(value);
        setOpenTooltip(true);
        setTimeout(() => setOpenTooltip(false), 1e3);
      },
      className: cn("relative size-6", className),
      children: [
        /* @__PURE__ */ jsx50(Icon, { className: "text-muted-foreground", icon: faCopy }),
        /* @__PURE__ */ jsx50(AnimatePresence, { children: openTooltip && /* @__PURE__ */ jsx50("div", { className: "bg-popover text-popover-foreground absolute -top-10 z-50 overflow-hidden rounded-md border px-3 py-1.5 text-sm shadow-md", children: /* @__PURE__ */ jsx50(
          motion.div,
          {
            initial: { opacity: 0, y: 10 },
            animate: { opacity: 1, y: 0 },
            exit: { opacity: 0, y: 10 },
            children: successMessage
          }
        ) }) })
      ]
    }
  );
};

// src/components/uturn-ui/date-picker/index.tsx
import { faCalendar, faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { forwardRef as forwardRef32, useCallback as useCallback2, useMemo, useRef as useRef2, useState as useState7 } from "react";
import { useTranslation as useTranslation3 } from "react-i18next";

// src/components/uturn-ui/date-picker/utils.ts
import { format as format2, isValid, parse } from "date-fns";
var REFERENCE_DATE = new Date(2026, 0, 2, 3, 4, 5);
var browserLocale = typeof window !== "undefined" ? window.navigator.language : "en-GB";
function buildLocaleDatePattern(locale) {
  const parts = new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(REFERENCE_DATE);
  const fnsPattern = parts.map((part) => {
    switch (part.type) {
      case "day":
        return "dd";
      case "month":
        return "MM";
      case "year":
        return "yyyy";
      default:
        return part.value;
    }
  }).join("");
  return { fnsPattern, hint: fnsPattern.toUpperCase() };
}
var { fnsPattern: DATE_FORMAT, hint: DATE_HINT } = buildLocaleDatePattern(browserLocale);
var DATETIME_FORMAT = `${DATE_FORMAT}, HH:mm`;
var DATETIME_HINT = `${DATE_HINT}, HH:MM`;
function formatDate(date) {
  if (!date) {
    return void 0;
  }
  const parsed = new Date(date);
  return isValid(parsed) ? format2(parsed, DATE_FORMAT) : void 0;
}
function formatDatetime(date) {
  if (!date) {
    return void 0;
  }
  const parsed = new Date(date);
  return isValid(parsed) ? format2(parsed, DATETIME_FORMAT) : void 0;
}
var DATE_SEPARATORS = ["/", "-", "."];
function withSeparatorVariants(pattern) {
  return DATE_SEPARATORS.map(
    (separator) => pattern.replace(/[/.-]/g, separator)
  );
}
function parseDateInput(text, type) {
  const trimmed = text.trim();
  if (!trimmed) {
    return void 0;
  }
  const dateFormats = withSeparatorVariants(DATE_FORMAT);
  const datetimeFormats = [
    ...[DATETIME_FORMAT, `${DATE_FORMAT} HH:mm`].flatMap(withSeparatorVariants),
    // A date with no time is valid for datetime fields (time is optional).
    ...dateFormats
  ];
  const formats = [
    ...new Set(type === "datetime" ? datetimeFormats : dateFormats)
  ];
  for (const formatPattern of formats) {
    const parsed = parse(trimmed, formatPattern, /* @__PURE__ */ new Date());
    if (isValid(parsed)) {
      return parsed;
    }
  }
  return void 0;
}

// src/components/uturn-ui/date-picker/index.tsx
import { jsx as jsx51, jsxs as jsxs24 } from "react/jsx-runtime";
var DatePicker = forwardRef32(
  (_a, ref) => {
    var _b = _a, {
      placeholderText,
      value,
      type,
      defaultOpen = false,
      onSelect,
      onCloseHandler,
      onOpenChange: onOpenChangeProp,
      name,
      id,
      "aria-invalid": ariaInvalid,
      popoverContentClassName,
      modal = false,
      defaultMonth,
      autoFocus,
      fromDate,
      disabled,
      showHint = true
    } = _b, props = __objRest(_b, [
      "placeholderText",
      "value",
      "type",
      "defaultOpen",
      "onSelect",
      "onCloseHandler",
      "onOpenChange",
      "name",
      "id",
      "aria-invalid",
      "popoverContentClassName",
      "modal",
      "defaultMonth",
      "autoFocus",
      "fromDate",
      "disabled",
      "showHint"
    ]);
    const { t } = useTranslation3();
    const placeholder = placeholderText != null ? placeholderText : t("component.date-picker.pick-a-date", "Pick a date");
    const [open, setOpen] = useState7(defaultOpen);
    const anchorRef = useRef2(null);
    const [month, setMonth] = useState7(
      () => {
        var _a2, _b2;
        return (_b2 = (_a2 = value != null ? value : defaultMonth) != null ? _a2 : fromDate) != null ? _b2 : /* @__PURE__ */ new Date();
      }
    );
    const timeIntervals = Array.from({ length: 24 * 12 }, (_, i) => {
      const hour = Math.floor(i / 12);
      const minute = i % 12 * 5;
      return {
        hour,
        minute
      };
    });
    const isSelectedInterval = useCallback2(
      (interval) => {
        if (!value) {
          return false;
        }
        return value.getHours() === interval.hour && value.getMinutes() === interval.minute;
      },
      [value]
    );
    const isTimeIntervalDisabled = useCallback2(
      (interval) => {
        if (!fromDate || !value) {
          return false;
        }
        const isSameDay = value.getFullYear() === fromDate.getFullYear() && value.getMonth() === fromDate.getMonth() && value.getDate() === fromDate.getDate();
        if (!isSameDay) {
          return false;
        }
        const fromMinutes = fromDate.getHours() * 60 + fromDate.getMinutes();
        const intervalMinutes = interval.hour * 60 + interval.minute;
        return intervalMinutes < fromMinutes;
      },
      [fromDate, value]
    );
    const formattedValue = useMemo(() => {
      return type === "date" ? formatDate(value) : formatDatetime(value);
    }, [type, value]);
    const [inputText, setInputText] = useState7(formattedValue != null ? formattedValue : "");
    const [prevFormattedValue, setPrevFormattedValue] = useState7(formattedValue);
    if (prevFormattedValue !== formattedValue) {
      setPrevFormattedValue(formattedValue);
      setInputText(formattedValue != null ? formattedValue : "");
    }
    const isDateDisabled = useCallback2(
      (date) => {
        var _a2;
        if (fromDate) {
          const from = new Date(fromDate);
          from.setHours(0, 0, 0, 0);
          const d = new Date(date);
          d.setHours(0, 0, 0, 0);
          if (d < from) {
            return true;
          }
        }
        return (_a2 = disabled == null ? void 0 : disabled(date)) != null ? _a2 : false;
      },
      [fromDate, disabled]
    );
    const formatValue = useCallback2(
      (date) => {
        var _a2;
        return (_a2 = type === "date" ? formatDate(date) : formatDatetime(date)) != null ? _a2 : "";
      },
      [type]
    );
    const commitInput = useCallback2(
      (rawText) => {
        const parsed = parseDateInput(rawText, type);
        if (parsed) {
          onSelect(parsed);
          setInputText(formatValue(parsed));
        }
        return parsed;
      },
      [type, onSelect, formatValue]
    );
    const commitTypedInput = useCallback2(() => {
      if (!inputText) {
        onSelect(void 0);
        return;
      }
      if (!commitInput(inputText)) {
        setInputText(formattedValue != null ? formattedValue : "");
      }
    }, [inputText, onSelect, commitInput, formattedValue]);
    const attachWheelGuard = useCallback2((node) => {
      if (!node) {
        return;
      }
      const stopWheelPropagation = (event) => event.stopPropagation();
      node.addEventListener("wheel", stopWheelPropagation, { passive: true });
      return () => node.removeEventListener("wheel", stopWheelPropagation);
    }, []);
    const changeOpen = useCallback2(
      (isOpen) => {
        var _a2, _b2;
        if (isOpen) {
          setMonth((_b2 = (_a2 = value != null ? value : defaultMonth) != null ? _a2 : fromDate) != null ? _b2 : /* @__PURE__ */ new Date());
        }
        setOpen(isOpen);
        onOpenChangeProp == null ? void 0 : onOpenChangeProp(isOpen);
      },
      [value, defaultMonth, fromDate, onOpenChangeProp]
    );
    return /* @__PURE__ */ jsxs24(
      Popover,
      {
        defaultOpen,
        open,
        onOpenChange: (isOpen) => {
          if (!isOpen) {
            commitTypedInput();
          }
          changeOpen(isOpen);
        },
        modal,
        children: [
          /* @__PURE__ */ jsx51(PopoverAnchor, { asChild: true, children: /* @__PURE__ */ jsxs24("div", { ref: anchorRef, className: "w-full relative", children: [
            /* @__PURE__ */ jsx51(
              Input,
              {
                autoComplete: "off",
                autoFocus,
                ref,
                name,
                id: id || name,
                "data-empty": !inputText,
                className: "data-[empty=true]:text-muted-foreground flex w-full justify-start bg-transparent text-left font-normal pr-9",
                value: inputText,
                placeholder,
                "aria-invalid": ariaInvalid,
                onFocus: () => changeOpen(true),
                onClick: () => changeOpen(true),
                onChange: (e) => setInputText(e.target.value),
                onKeyDownCapture: (e) => {
                  if (e.key !== "Enter") {
                    return;
                  }
                  e.preventDefault();
                  e.stopPropagation();
                  if (!inputText) {
                    onSelect(void 0);
                    changeOpen(false);
                    return;
                  }
                  if (commitInput(inputText)) {
                    changeOpen(false);
                  }
                },
                onBlur: commitTypedInput,
                onPaste: (e) => {
                  e.preventDefault();
                  commitInput(e.clipboardData.getData("Text"));
                }
              }
            ),
            /* @__PURE__ */ jsx51(InputAddon, { type: "trailing", className: "pointer-events-auto", children: /* @__PURE__ */ jsx51(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsx51(
              Button,
              {
                type: "button",
                variant: "ghost",
                size: "icon",
                className: "size-7",
                children: /* @__PURE__ */ jsx51(Icon, { icon: faCalendar, className: "size-4" })
              }
            ) }) })
          ] }) }),
          showHint && /* @__PURE__ */ jsxs24("div", { className: "text-muted-foreground mt-1 flex items-center gap-1 text-xs", children: [
            /* @__PURE__ */ jsxs24("span", { children: [
              t("date-picker.hint-format-label", "Format:"),
              " ",
              type === "datetime" ? DATETIME_HINT : DATE_HINT,
              type === "datetime" ? ` ${t("date-picker.hint-format-optional", "(HH:MM is optional)")}` : ""
            ] }),
            /* @__PURE__ */ jsx51(TooltipProvider, { children: /* @__PURE__ */ jsxs24(Tooltip, { children: [
              /* @__PURE__ */ jsx51(TooltipTrigger, { asChild: true, children: /* @__PURE__ */ jsx51(
                Button,
                {
                  type: "button",
                  variant: "ghost",
                  size: "icon",
                  className: "size-4 text-muted-foreground",
                  children: /* @__PURE__ */ jsx51(Icon, { icon: faCircleInfo, className: "size-3.5" })
                }
              ) }),
              /* @__PURE__ */ jsx51(TooltipContent, { children: t(
                "date-picker.hint-format.info",
                "This format matches your browser settings."
              ) })
            ] }) })
          ] }),
          /* @__PURE__ */ jsx51(
            PopoverContent,
            {
              align: "end",
              className: cn("w-auto p-0", popoverContentClassName),
              onOpenAutoFocus: (e) => e.preventDefault(),
              onInteractOutside: (event) => {
                var _a2;
                if (event.target instanceof Node && ((_a2 = anchorRef.current) == null ? void 0 : _a2.contains(event.target))) {
                  event.preventDefault();
                }
              },
              children: /* @__PURE__ */ jsxs24("div", { className: "flex", children: [
                /* @__PURE__ */ jsx51("div", { onMouseDown: (event) => event.preventDefault(), children: /* @__PURE__ */ jsx51(
                  Calendar,
                  __spreadProps(__spreadValues({}, props), {
                    mode: "single",
                    month,
                    onMonthChange: setMonth,
                    disabled: isDateDisabled,
                    onSelect: (date) => {
                      var _a2, _b2;
                      if ((value == null ? void 0 : value.getHours()) !== 0 || (value == null ? void 0 : value.getMinutes()) !== 0) {
                        date == null ? void 0 : date.setHours(
                          (_a2 = value == null ? void 0 : value.getHours()) != null ? _a2 : 0,
                          (_b2 = value == null ? void 0 : value.getMinutes()) != null ? _b2 : 0,
                          0,
                          0
                        );
                      }
                      onSelect(date);
                      setInputText(formatValue(date));
                      if (type === "date") {
                        changeOpen(false);
                      }
                    }
                  })
                ) }),
                type === "datetime" && /* @__PURE__ */ jsx51("div", { className: "flex flex-col divide-y sm:h-[300px] sm:flex-row sm:divide-x sm:divide-y-0", children: /* @__PURE__ */ jsxs24(ScrollArea, { className: "w-64 sm:w-auto", children: [
                  /* @__PURE__ */ jsxs24(
                    "div",
                    {
                      ref: attachWheelGuard,
                      className: "flex gap-0.5 p-3 sm:flex-col",
                      onMouseDown: (event) => event.preventDefault(),
                      children: [
                        /* @__PURE__ */ jsx51("p", { className: "text-muted-foreground mb-3 pt-1 text-center text-sm", children: t("date-picker.time", "Time") }),
                        timeIntervals.map((time) => /* @__PURE__ */ jsx51(
                          Button,
                          {
                            "data-time-key": `${time.hour}:${time.minute}`,
                            size: "icon",
                            disabled: !value || isTimeIntervalDisabled(time),
                            variant: isSelectedInterval(time) ? "default" : "ghost",
                            className: "aspect-auto h-auto shrink-0 p-1 sm:w-full",
                            onClick: () => {
                              if (!value) {
                                return;
                              }
                              const newDate = new Date(value);
                              newDate.setHours(time.hour, time.minute, 0, 0);
                              onSelect(newDate);
                              setInputText(formatValue(newDate));
                              if (onCloseHandler) {
                                onCloseHandler();
                              }
                              changeOpen(false);
                            },
                            children: `${time.hour}:${String(time.minute).padStart(2, "0")}`
                          },
                          `${time.hour}:${time.minute}`
                        ))
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsx51(ScrollBar, { orientation: "horizontal", className: "sm:hidden" })
                ] }) })
              ] })
            }
          )
        ]
      }
    );
  }
);

// src/components/uturn-ui/empty-state.tsx
import { jsx as jsx52 } from "react/jsx-runtime";
function EmptyState(_a) {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx52("div", __spreadProps(__spreadValues({ className: "flex justify-center items-center mt-12" }, props), { children: /* @__PURE__ */ jsx52("div", { className: "flex flex-col text-center space-y-5 w-[18rem] md:w-[40rem]", children }) }));
}

// src/components/uturn-ui/form-checkbox-group-item/index.tsx
import { twMerge as twMerge2 } from "tailwind-merge";
import { jsx as jsx53, jsxs as jsxs25 } from "react/jsx-runtime";
function FormCheckboxGroupItem(props) {
  const { id, value, label, hidden = false, checked, onCheckedChange } = props;
  if (hidden) {
    return null;
  }
  if (props.variant === "card") {
    const { icon, description: description2 } = props;
    return /* @__PURE__ */ jsx53(FormItem, { children: /* @__PURE__ */ jsx53(FormControl, { children: /* @__PURE__ */ jsxs25(
      FormLabel,
      {
        htmlFor: id,
        className: twMerge2(
          "flex flex-col items-center h-full p-6 cursor-pointer rounded-md border border-muted bg-popover [.theme-uturn_&]:border-foreground [.theme-uturn_&]:hover:border-primary [.theme-uturn_&]:peer-data-[state=checked]:border-primary [.theme-uturn_&]:peer-data-[state=checked]:border-2 [.theme-uturn_&]:[&:has([data-state=checked])]:border-primary [.theme-uturn_&]:[&:has([data-state=checked])]:border-2",
          "hover:bg-accent hover:text-accent-foreground",
          "peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary",
          "peer-data-[state=checked]:text-primary [&:has([data-state=checked])]:text-primary",
          "[.theme-uturn_&]:peer-data-[state=checked]:text-foreground [.theme-uturn_&]:[&:has([data-state=checked])]:text-foreground"
        ),
        children: [
          /* @__PURE__ */ jsxs25("div", { className: "flex flex-1 flex-col items-center gap-6", children: [
            /* @__PURE__ */ jsx53(Icon, { size: "2xl", icon }),
            /* @__PURE__ */ jsxs25("div", { className: "flex-1 space-y-2 text-center", children: [
              /* @__PURE__ */ jsx53("h3", { className: "text-lg font-semibold", children: label }),
              /* @__PURE__ */ jsx53("p", { className: "text-muted-foreground text-sm", children: description2 })
            ] })
          ] }),
          /* @__PURE__ */ jsx53(
            Checkbox,
            {
              className: "mt-4 border-border data-[state=checked]:border-primary",
              id,
              value: typeof value === "boolean" ? id : String(value),
              checked,
              onCheckedChange
            }
          )
        ]
      }
    ) }) });
  }
  const { description, labelPosition = "center" } = props;
  return /* @__PURE__ */ jsx53(FormItem, { className: "w-full", children: /* @__PURE__ */ jsx53(FormControl, { children: /* @__PURE__ */ jsxs25(
    FormLabel,
    {
      htmlFor: id,
      className: twMerge2(
        "cursor-pointer w-full px-4 flex gap-2 rounded-md border border-muted bg-popover [.theme-uturn_&]:border-foreground [.theme-uturn_&]:hover:border-primary [.theme-uturn_&]:peer-data-[state=checked]:border-primary [.theme-uturn_&]:peer-data-[state=checked]:border-2 [.theme-uturn_&]:[&:has([data-state=checked])]:border-primary [.theme-uturn_&]:[&:has([data-state=checked])]:border-2",
        description ? "py-3 items-start" : "h-12 items-center",
        labelPosition === "center" ? "justify-center" : "justify-start",
        "hover:bg-accent hover:text-accent-foreground",
        "peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary",
        "peer-data-[state=checked]:text-primary [&:has([data-state=checked])]:text-primary",
        "[.theme-uturn_&]:peer-data-[state=checked]:text-foreground [.theme-uturn_&]:[&:has([data-state=checked])]:text-foreground"
      ),
      children: [
        /* @__PURE__ */ jsx53(
          Checkbox,
          {
            className: "border-border data-[state=checked]:border-primary",
            id,
            value: typeof value === "boolean" ? id : String(value),
            checked,
            onCheckedChange
          }
        ),
        description ? /* @__PURE__ */ jsxs25("div", { className: "grid gap-1.5 leading-none", children: [
          /* @__PURE__ */ jsx53("span", { className: "font-medium", children: label }),
          /* @__PURE__ */ jsx53("p", { className: "text-muted-foreground text-sm font-normal", children: description })
        ] }) : label
      ]
    }
  ) }) });
}

// src/components/uturn-ui/form-field-read-only.tsx
import { twJoin } from "tailwind-merge";
import { jsx as jsx54 } from "react/jsx-runtime";
function FormFieldReadOnly(_a) {
  var _b = _a, {
    value,
    className
  } = _b, props = __objRest(_b, [
    "value",
    "className"
  ]);
  return /* @__PURE__ */ jsx54(
    "p",
    __spreadProps(__spreadValues({
      className: twJoin("text-sm text-muted-foreground", className)
    }, props), {
      children: value === "" || !value ? "-" : value
    })
  );
}

// src/components/uturn-ui/form-radio-group-horizontal-item/index.tsx
import { twMerge as twMerge3 } from "tailwind-merge";
import { jsx as jsx55, jsxs as jsxs26 } from "react/jsx-runtime";
function FormRadioGroupHorizontalItem({
  id,
  value,
  icon,
  label,
  description,
  hidden = false,
  variant = "default",
  labelPosition = "center"
}) {
  if (hidden) {
    return null;
  }
  if (variant === "card") {
    if (!icon || !description) {
      return null;
    }
    return /* @__PURE__ */ jsx55(FormItem, { children: /* @__PURE__ */ jsx55(FormControl, { children: /* @__PURE__ */ jsxs26(
      FormLabel,
      {
        htmlFor: id,
        className: twMerge3(
          "flex flex-col items-center h-full p-6 cursor-pointer rounded-md border border-muted bg-popover [.theme-uturn_&]:border-foreground [.theme-uturn_&]:hover:border-primary [.theme-uturn_&]:peer-data-[state=checked]:border-primary [.theme-uturn_&]:peer-data-[state=checked]:border-2 [.theme-uturn_&]:[&:has([data-state=checked])]:border-primary [.theme-uturn_&]:[&:has([data-state=checked])]:border-2",
          "hover:bg-accent hover:text-accent-foreground",
          "peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary",
          "peer-data-[state=checked]:text-primary [&:has([data-state=checked])]:text-primary",
          "[.theme-uturn_&]:peer-data-[state=checked]:text-foreground [.theme-uturn_&]:[&:has([data-state=checked])]:text-foreground"
        ),
        children: [
          /* @__PURE__ */ jsxs26("div", { className: "flex flex-1 flex-col items-center gap-6", children: [
            /* @__PURE__ */ jsx55(Icon, { size: "2xl", icon }),
            /* @__PURE__ */ jsxs26("div", { className: "flex-1 space-y-2 text-center", children: [
              /* @__PURE__ */ jsx55("h3", { className: "text-lg font-semibold", children: label }),
              /* @__PURE__ */ jsx55("p", { className: "text-muted-foreground text-sm", children: description })
            ] })
          ] }),
          /* @__PURE__ */ jsx55(
            RadioGroupItem,
            {
              className: twMerge3(
                "peer border-default mt-4",
                "peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary",
                "peer-data-[state=checked]:border-4 [&:has([data-state=checked])]:border-4",
                "peer-data-[state=checked]:bg-primary [&:has([data-state=checked])]:bg-primary",
                "peer-data-[state=checked]:text-white [&:has([data-state=checked])]:text-white",
                "[.theme-uturn_&]:peer-data-[state=checked]:bg-transparent [.theme-uturn_&]:[&:has([data-state=checked])]:bg-transparent",
                "[.theme-uturn_&]:peer-data-[state=checked]:border [.theme-uturn_&]:[&:has([data-state=checked])]:border"
              ),
              id,
              value: typeof value === "boolean" ? id : String(value)
            }
          )
        ]
      }
    ) }) });
  }
  return /* @__PURE__ */ jsx55(FormItem, { className: "w-full", children: /* @__PURE__ */ jsx55(FormControl, { children: /* @__PURE__ */ jsxs26(
    FormLabel,
    {
      htmlFor: id,
      className: twMerge3(
        "cursor-pointer w-full px-4 flex gap-2 rounded-md border border-muted bg-popover [.theme-uturn_&]:border-foreground [.theme-uturn_&]:hover:border-primary [.theme-uturn_&]:peer-data-[state=checked]:border-primary [.theme-uturn_&]:peer-data-[state=checked]:border-2 [.theme-uturn_&]:[&:has([data-state=checked])]:border-primary [.theme-uturn_&]:[&:has([data-state=checked])]:border-2",
        description ? "py-3 items-start" : "h-12 items-center",
        labelPosition === "center" ? "justify-center" : "justify-start",
        "hover:bg-accent hover:text-accent-foreground",
        "peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary",
        "peer-data-[state=checked]:text-primary [&:has([data-state=checked])]:text-primary",
        "[.theme-uturn_&]:peer-data-[state=checked]:text-foreground [.theme-uturn_&]:[&:has([data-state=checked])]:text-foreground"
      ),
      children: [
        /* @__PURE__ */ jsx55(
          RadioGroupItem,
          {
            className: twMerge3(
              "peer border-default",
              "peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary",
              "peer-data-[state=checked]:bg-primary [&:has([data-state=checked])]:bg-primary",
              "peer-data-[state=checked]:text-white [&:has([data-state=checked])]:text-white",
              "[.theme-uturn_&]:peer-data-[state=checked]:bg-transparent [.theme-uturn_&]:[&:has([data-state=checked])]:bg-transparent",
              "[.theme-uturn_&]:peer-data-[state=checked]:border [.theme-uturn_&]:[&:has([data-state=checked])]:border"
            ),
            id,
            value: typeof value === "boolean" ? id : String(value)
          }
        ),
        description ? /* @__PURE__ */ jsxs26("div", { className: "grid gap-1.5 leading-none", children: [
          /* @__PURE__ */ jsx55("span", { className: "font-medium", children: label }),
          /* @__PURE__ */ jsx55("p", { className: "text-muted-foreground text-sm font-normal", children: description })
        ] }) : label
      ]
    }
  ) }) });
}

// src/components/uturn-ui/logo.tsx
import { useId as useId2 } from "react";
import { jsx as jsx56, jsxs as jsxs27 } from "react/jsx-runtime";
function Logo(_a) {
  var _b = _a, { className, variant } = _b, props = __objRest(_b, ["className", "variant"]);
  const fillId = useId2();
  if (variant === "easter") {
    return /* @__PURE__ */ jsxs27(
      "svg",
      {
        width: "186",
        height: "61",
        viewBox: "0 0 210 65",
        className: cn("fill-foreground", className),
        children: [
          /* @__PURE__ */ jsxs27("g", { transform: "translate(103, 5) scale(0.055)", children: [
            /* @__PURE__ */ jsx56("path", { d: "M151.3 127.64c67.85 114.72 111.18 306.61 61.76 426.79-2.05 5-5.45 10.1-10.42 8-21.44-9.1 74.13-226.12-92.79-467.84C82.81 55.43 58 30.34 45.2 15.21 3.44 185.59 19.3 342.53 77.68 481c2.59 6.14 29.45 67.2 33.52 74.84 4.68 8.82-7.91 16.09-13.33 7.79C3.85 419.56-30.28 218.82 30.35 29.18c7.85-24.54 10.5-32.3 16.29-28.1C83 27.47 127.05 86.64 151.3 127.64m470.55 180.17C466.9 203.49 494.55 89.64 422.06 80c-26.44-3.53-52.09 9.67-69.37 29-44.79 50.19-120.29 254-69.19 438.45 2.25 8.13 13.94 4.63 12.47-3.44-10.44-57.32-15.82-103.85-12.17-167.72 5.9-102.53 38.62-195 66.5-239.82 28.94-46.49 69.39-50.1 90.48-33.32C473.26 129 474.94 222 597.62 314.79 508.53 355.65 437 336.4 399.87 294.22c-25.27-28.67-26-54.78-29.69-62.46-8.74-18.13-24.92 57.79 42.9 101.07 20.59 13.15 34.27 15.54 34.27 16.43-20.48 118.29-81.68 188.11-87.82 200.26-2.58 5.08 3.3 9 7.49 5.79 10.16-7.87 77.11-85.38 95.74-201.73 53.79 12.17 109.87-2.85 159.09-28.68 6.97-3.66 5.83-13.17 0-17.09" }),
            /* @__PURE__ */ jsx56(
              "path",
              {
                fill: "#ff7bac",
                d: "M156.4 317.8c18.79 105 14.09 193.74-10.48 198.13s-59.71-77.19-78.5-182.21S53.33 140 77.9 135.59s59.72 77.18 78.5 182.21m256.68 15c-63.83-40.73-49.27-100.33-49.35-100.36-47.68 113.11-64.64 275.13-27.21 284.39 26.16 6.47 67.41-69.35 92.12-169.33 2.06-8.34 3.53-2.5-15.56-14.67Z"
              }
            )
          ] }),
          /* @__PURE__ */ jsxs27("g", { transform: "translate(156, 30) scale(0.018) rotate(15, 1061, 1061)", children: [
            /* @__PURE__ */ jsx56(
              "path",
              {
                fill: "#6DC2BB",
                d: "M1744.478 1203.337c-.017-1.573-.017-3.145-.042-4.719a1026 1026 0 0 0-.591-22.296c-.065-1.745-.151-3.492-.225-5.237a1053 1053 0 0 0-.927-18.253c-.112-1.894-.216-3.788-.339-5.682-.483-7.457-1.03-14.915-1.668-22.373-.107-1.249-.235-2.499-.346-3.748-.57-6.417-1.201-12.835-1.884-19.252-.215-2.021-.431-4.042-.658-6.063-.843-7.533-1.734-15.065-2.728-22.593v-.049a1128 1128 0 0 0-2.456-17.822c-.063-.435-.117-.871-.181-1.306q-.939-6.327-1.952-12.652a900 900 0 0 0-1.106-7.061q-1.27-7.75-2.636-15.489a1337 1337 0 0 0-7.635-39.265c-.446-2.094-.896-4.138-1.346-6.237-.808-3.765-1.72-7.51-2.561-11.27-1.3-5.806-2.574-11.615-3.954-17.405-1.336-5.602-2.776-11.179-4.185-16.765-1.197-4.743-2.346-9.498-3.594-14.228-1.763-6.673-3.642-13.314-5.505-19.959-1.033-3.684-2.008-7.386-3.071-11.061a1394 1394 0 0 0-9.307-30.841c-2.098-6.637-4.192-13.275-6.388-19.859-14.719-44.554-31.532-88.358-50.139-130.964-10.278-23.695-21.156-47.043-32.529-69.99-.201-.455-.446-.856-.646-1.301-17.164-34.525-35.474-68.052-54.581-100.43-3.047-5.088-6.041-10.131-9.083-15.12a1124 1124 0 0 0-22.795-35.969c-18.163-27.584-38.267-55.476-60.221-82.566-77.929-96.536-178.457-183.299-293.953-212.38-17.409-4.446-35.171-7.538-53.28-9.084-2.548-.2-5.092-.401-7.636-.548a279 279 0 0 0-25.094-.348c-4.891.147-9.778.451-14.62.847-78.13 6.585-150.717 45.849-215.873 101.878-94.991 81.769-174.167 199.159-231.59 302.729-7.284 13.227-14.269 26.194-20.858 38.82-7.979 15.365-15.463 30.182-22.399 44.397-1.497 3.096-2.993 6.188-4.441 9.235-1.893 3.987-3.84 8.028-5.635 12.024-4.642 9.925-9.177 19.9-13.57 30.03-23.049 52.184-43.404 107.014-60.417 163.391-13.373 44.303-24.648 89.556-33.428 135.351a768 768 0 0 0-2.842 15.369 1068 1068 0 0 0-4.192 24.845 1249 1249 0 0 0-7.983 59.12c-.098.749-.147 1.546-.245 2.294-4.295 39.559-6.54 79.225-6.589 118.691 0 11.075.152 22.154.552 33.224a938 938 0 0 0 2.789 48.994 964 964 0 0 0 4.789 44.95 852 852 0 0 0 10.776 63.709c6.188 29.536 13.921 58.675 23.352 87.261 16.363 49.739 37.866 97.833 65.104 143.584 1.349 2.246 2.695 4.539 4.142 6.781 48.045 78.232 111.804 140.493 184.943 186.743 127.672 80.771 283.779 112.801 434.148 96.091l3.693-.45c13.417-1.551 26.836-3.493 40.16-5.89 71.589-12.62 141.138-36.467 204.749-71.687 72.886-40.312 137.998-95.392 189.634-165.342 40.606-54.977 72.191-113.349 95.686-173.966 14.919-38.414 26.595-77.733 35.273-117.693a848 848 0 0 0 10.875-60.314c2.949-20.608 5.243-41.408 6.691-62.261.298-3.399.547-6.838.743-10.233.596-9.41 1.015-18.843 1.333-28.286.101-2.997.142-6 .215-9 .159-6.527.273-13.059.303-19.598.006-1.527.07-3.049.07-4.577-.001-3.623-.057-7.25-.096-10.876"
              }
            ),
            /* @__PURE__ */ jsx56(
              "path",
              {
                fill: "#2CB3A2",
                d: "M1744.478 1203.337c-.017-1.573-.017-3.145-.042-4.719a1026 1026 0 0 0-.591-22.296c-.065-1.745-.151-3.492-.225-5.237a1053 1053 0 0 0-.927-18.253c-.112-1.894-.216-3.788-.339-5.682-.483-7.457-1.03-14.915-1.668-22.373-.107-1.249-.235-2.499-.346-3.748-.57-6.417-1.201-12.835-1.884-19.252-.215-2.021-.431-4.042-.658-6.063-.843-7.533-1.734-15.065-2.728-22.593v-.049a1128 1128 0 0 0-2.456-17.822c-.063-.435-.117-.871-.181-1.306q-.939-6.327-1.952-12.652a900 900 0 0 0-1.106-7.061q-1.27-7.75-2.636-15.489a1337 1337 0 0 0-7.635-39.265c-.446-2.094-.896-4.138-1.346-6.237-.808-3.765-1.72-7.51-2.561-11.27-1.3-5.806-2.574-11.615-3.954-17.405-1.336-5.602-2.776-11.179-4.185-16.765-1.197-4.743-2.346-9.498-3.594-14.228-1.763-6.673-3.642-13.314-5.505-19.959-1.033-3.684-2.008-7.386-3.071-11.061a1394 1394 0 0 0-9.307-30.841c-2.098-6.637-4.192-13.275-6.388-19.859-14.719-44.554-31.532-88.358-50.139-130.964-10.278-23.695-21.156-47.043-32.529-69.99-.201-.455-.446-.856-.646-1.301-17.164-34.525-35.474-68.052-54.581-100.43-3.047-5.088-6.041-10.131-9.083-15.12a1124 1124 0 0 0-22.795-35.969c-18.163-27.584-38.267-55.476-60.221-82.566-77.929-96.536-178.457-183.299-293.953-212.38-17.409-4.446-35.171-7.538-53.28-9.084-2.548-.2-5.092-.401-7.636-.548 30.333 49.69 74.984 96.483 95.788 125.525 101.314 141.082 175.987 300.407 224.534 467.229l.03.099c23.613 81.159 41.037 164.067 52.345 247.551q.004.023.006.047a1842.766 1842.766 0 0 1 8.704 76.297v.01c8.096 86.968 10.077 174.31 6.654 261.524l-.001.018c-6.79 172.915-34.835 345.359-78.64 513.684 72.886-40.312 137.998-95.392 189.634-165.342 40.606-54.977 72.191-113.349 95.686-173.966 14.919-38.414 26.595-77.733 35.273-117.693a848 848 0 0 0 10.875-60.314c2.949-20.608 5.243-41.408 6.691-62.261.298-3.399.547-6.838.743-10.233.596-9.41 1.015-18.843 1.333-28.286.101-2.997.142-6 .215-9 .159-6.527.273-13.059.303-19.598.006-1.527.07-3.049.07-4.577 0-3.624-.056-7.251-.095-10.877"
              }
            ),
            /* @__PURE__ */ jsx56(
              "path",
              {
                fill: "#F7B455",
                d: "M1744.478 1203.337c-.017-1.573-.017-3.145-.042-4.719a1026 1026 0 0 0-.591-22.296c-.065-1.745-.151-3.492-.225-5.237a1053 1053 0 0 0-.927-18.253c-.112-1.894-.216-3.788-.339-5.682-.483-7.457-1.03-14.915-1.668-22.373-.107-1.249-.235-2.499-.346-3.748-.57-6.417-1.201-12.835-1.884-19.252-.215-2.021-.431-4.042-.658-6.063-.843-7.533-1.734-15.065-2.728-22.593v-.049a1128 1128 0 0 0-2.456-17.822c-.063-.435-.117-.871-.181-1.306q-.939-6.327-1.952-12.652a900 900 0 0 0-1.106-7.061q-1.27-7.75-2.636-15.489a1337 1337 0 0 0-7.635-39.265c-.446-2.094-.896-4.138-1.346-6.237-.808-3.765-1.72-7.51-2.561-11.27-1.3-5.806-2.574-11.615-3.954-17.405-1.336-5.602-2.776-11.179-4.185-16.765-1.197-4.743-2.346-9.498-3.594-14.228-1.763-6.673-3.642-13.314-5.505-19.959-1.033-3.684-2.008-7.386-3.071-11.061a1394 1394 0 0 0-9.307-30.841c-2.098-6.637-4.192-13.275-6.388-19.859-14.719-44.554-31.532-88.358-50.139-130.964-62.809 26.943-128.665 47.297-195.372 61.566a1205 1205 0 0 1-19.001 3.899l-.03-.099c-162.916 32.067-331.06 30.61-496.587 16.104-127.368-11.173-256.234-30.779-377.816-69.246-23.049 52.184-43.404 107.014-60.417 163.391-13.373 44.303-24.648 89.556-33.428 135.351a768 768 0 0 0-2.842 15.369 1068 1068 0 0 0-4.192 24.845 1249 1249 0 0 0-7.983 59.12c-.098.749-.147 1.546-.245 2.294-4.295 39.559-6.54 79.225-6.589 118.691 0 11.075.152 22.154.552 33.224a938 938 0 0 0 2.789 48.994c270.057 83.569 577.033 95.49 853.875 66.952a2319 2319 0 0 0 200.623-29.562l-.001.018c87.69-16.868 174.399-38.837 259.519-65.893.298-3.399.547-6.838.743-10.233.596-9.41 1.015-18.843 1.333-28.286.101-2.997.142-6 .215-9 .159-6.527.273-13.059.303-19.598.006-1.527.07-3.049.07-4.577 0-3.622-.056-7.249-.095-10.875"
              }
            ),
            /* @__PURE__ */ jsx56(
              "path",
              {
                fill: "#FFF",
                d: "M1188.176 460.006c38.523 0 38.587-59.868 0-59.868-38.522 0-38.588 59.868 0 59.868M1021.795 665.233c2.712 2.923 5.924 4.984 9.635 6.192q5.349 2.813 11.532 2.577l7.958-1.067q7.607-2.133 13.208-7.703c5.376-5.856 8.767-13.052 8.767-21.164v-7.644q.233-6.183-2.577-11.532-1.812-5.569-6.19-9.632-4.067-4.38-9.632-6.192c-3.569-1.871-7.413-2.733-11.535-2.577-2.653.356-5.303.716-7.956 1.072-5.072 1.423-9.474 3.986-13.211 7.698-5.376 5.856-8.767 13.057-8.767 21.164v7.644q-.234 6.183 2.58 11.532 1.81 5.569 6.188 9.632M935.964 415.879q3.98-.532 7.958-1.072 7.606-2.128 13.208-7.698c5.376-5.856 8.767-13.052 8.767-21.165V378.3q.233-6.183-2.577-11.532-1.812-5.569-6.19-9.632-4.068-4.378-9.632-6.192c-3.569-1.871-7.413-2.734-11.535-2.577q-3.98.536-7.956 1.072c-5.072 1.423-9.476 3.986-13.21 7.698-5.377 5.856-8.768 13.057-8.768 21.164v7.644q-.234 6.183 2.58 11.532 1.81 5.569 6.188 9.632c2.711 2.924 5.924 4.984 9.634 6.192 3.567 1.872 7.411 2.734 11.533 2.578M752.539 549.17c-38.524 0-38.587 59.868 0 59.868 38.521 0 38.585-59.868 0-59.868M1333.388 1680.302c-38.521 0-38.587 59.868 0 59.868 38.524 0 38.587-59.868 0-59.868M1209.342 1536.214c-5.856-5.379-13.055-8.77-21.166-8.77h-7.642q-6.182-.232-11.535 2.582c-3.71 1.203-6.921 3.269-9.632 6.187-2.918 2.709-4.982 5.924-6.19 9.632q-2.81 5.349-2.577 11.532.533 3.98 1.07 7.961c1.422 5.072 3.988 9.471 7.698 13.208 5.857 5.374 13.055 8.765 21.167 8.765h7.642q6.182.235 11.532-2.577 5.568-1.81 9.634-6.188 4.378-4.071 6.19-9.632 2.81-5.355 2.577-11.537c-.356-2.651-.711-5.306-1.07-7.956-1.423-5.071-3.988-9.47-7.698-13.207M987.703 1612.642l-7.644-7.644q-4.067-4.38-9.632-6.188-5.353-2.812-11.535-2.577-6.182-.235-11.532 2.577c-3.71 1.203-6.923 3.269-9.634 6.188-5.235 5.705-9.123 13.193-8.768 21.169q.537 3.974 1.07 7.956c1.422 5.072 3.988 9.471 7.698 13.208l7.644 7.644q4.067 4.376 9.632 6.187 5.353 2.813 11.535 2.577c4.119.156 7.966-.701 11.532-2.577q5.566-1.811 9.634-6.187c5.235-5.705 9.123-13.193 8.768-21.169-.358-2.65-.714-5.306-1.07-7.956q-2.134-7.607-7.698-13.208M1071.774 1742.567c-2.548-2.548-5.096-5.091-7.644-7.639-2.711-2.924-5.922-4.984-9.632-6.192-3.569-1.871-7.413-2.734-11.535-2.577-4.122-.156-7.966.707-11.532 2.577-3.71 1.208-6.923 3.269-9.635 6.192-5.235 5.705-9.123 13.193-8.767 21.164l1.07 7.956q2.133 7.608 7.698 13.213 3.822 3.815 7.645 7.64 4.067 4.379 9.632 6.192c3.569 1.871 7.413 2.733 11.535 2.577 4.119.156 7.966-.706 11.533-2.577q5.566-1.813 9.634-6.192c5.235-5.706 9.123-13.194 8.767-21.165q-.536-3.98-1.069-7.961-2.138-7.602-7.7-13.208M751.901 1557.378v-7.64q.233-6.182-2.577-11.532-1.812-5.567-6.19-9.637-4.067-4.377-9.635-6.188-5.35-2.812-11.532-2.577l-7.958 1.067q-7.606 2.135-13.208 7.698c-5.376 5.856-8.767 13.057-8.767 21.169v7.64q-.233 6.182 2.577 11.537 1.812 5.56 6.19 9.632 4.066 4.377 9.635 6.188 5.349 2.812 11.532 2.577l7.959-1.067q7.605-2.135 13.208-7.698c5.375-5.856 8.766-13.057 8.766-21.169M796.634 1696.711a11007 11007 0 0 0-7.644-7.639c-2.712-2.924-5.923-4.985-9.632-6.192q-5.353-2.813-11.535-2.577-6.183-.235-11.532 2.577c-3.71 1.208-6.923 3.269-9.635 6.192-5.235 5.7-9.123 13.193-8.767 21.164.358 2.65.714 5.305 1.069 7.956q2.134 7.609 7.698 13.208l7.644 7.645q4.068 4.378 9.632 6.192c3.569 1.871 7.413 2.733 11.535 2.577 4.119.156 7.966-.706 11.532-2.577q5.566-1.813 9.635-6.192c5.235-5.706 9.123-13.194 8.767-21.165q-.537-3.98-1.069-7.961-2.136-7.602-7.698-13.208"
              }
            ),
            /* @__PURE__ */ jsx56(
              "path",
              {
                fill: "#FFFDF1",
                d: "M1729.376 1034.229q-1.27-7.75-2.636-15.489a1337 1337 0 0 0-7.635-39.265c-.446-2.094-.896-4.138-1.346-6.237-3.542 2.397-6.985 4.892-10.277 7.537-40.222 32.125-74.714 88.67-125.815 88.67-10.954 0-22.681-2.602-35.379-8.599-27.743-13.109-52.756-31.853-79.261-46.944q.004.023.006.047c-22.933-13.06-46.966-23.422-74.856-24.995-64.911-3.693-102.875 47.845-149.723 82.717-67 49.841-126.771-18.211-181.548-54.126-31.135-20.359-68.301-37.171-106.319-34.779-37.768 2.347-67.95 22.506-93.842 48.745-20.257 20.555-47.146 59.668-80.326 56.577-31.38-2.945-50.438-46.5-69.446-67.055-23.299-25.147-56.474-45.301-91.948-39.862-29.037 4.442-49.338 24.15-64.257 48.295-13.721 22.252-23.499 59.717-56.474 49.787-21.356-6.384-39.715-17.663-58.924-27.188a1249 1249 0 0 0-7.983 59.12c-.098.749-.147 1.546-.245 2.294 22.399 11.921 43.8 25.544 70.043 28.337 28.587 3.092 55.329-8.183 73.937-29.834 15.961-18.661 22.951-44.103 39.314-62.012 22.399-24.399 51.485 10.625 65.157 28.538 19.107 24.992 38.218 50.634 68.151 63.161 31.282 13.017 65.504 6.932 93.846-10.531 27.736-17.106 46.843-42.655 70.342-64.506 29.036-27.09 60.866-27.74 95.543-9.881 62.657 32.231 111.202 96.84 187.982 95.294 62.666-1.301 97.935-49.44 143.936-83.515 48.496-35.923 90.901-7.332 135.054 20.903.429.274.862.54 1.292.813v.01c35.633 22.594 73.361 40.196 111.826 40.196 23.092 0 46.449-6.344 69.779-21.761 28.137-18.608 48.99-44.552 73.14-67.402q-.541-3.53-1.108-7.06"
              }
            ),
            /* @__PURE__ */ jsx56(
              "path",
              {
                fill: "#BAA050",
                d: "M1744.478 1203.337c-.017-1.573-.017-3.145-.042-4.719a1026 1026 0 0 0-.591-22.296c-.065-1.745-.151-3.492-.225-5.237a1053 1053 0 0 0-.927-18.253c-.112-1.894-.216-3.788-.339-5.682-.483-7.457-1.03-14.915-1.668-22.373-.107-1.249-.235-2.499-.346-3.748-.57-6.417-1.201-12.835-1.884-19.252-.215-2.021-.431-4.042-.658-6.063-.843-7.533-1.734-15.065-2.728-22.593v-.049a1128 1128 0 0 0-2.456-17.822c-.063-.435-.117-.871-.181-1.306q-.939-6.327-1.952-12.652a900 900 0 0 0-1.106-7.061q-1.27-7.75-2.636-15.489a1337 1337 0 0 0-7.635-39.265c-.446-2.094-.896-4.138-1.346-6.237-.808-3.765-1.72-7.51-2.561-11.27-1.3-5.806-2.574-11.615-3.954-17.405-1.336-5.602-2.776-11.179-4.185-16.765-1.197-4.743-2.346-9.498-3.594-14.228-1.763-6.673-3.642-13.314-5.505-19.959-1.033-3.684-2.008-7.386-3.071-11.061a1394 1394 0 0 0-9.307-30.841c-2.098-6.637-4.192-13.275-6.388-19.859-14.719-44.554-31.532-88.358-50.139-130.964-62.809 26.943-128.665 47.297-195.372 61.566a1205 1205 0 0 1-19.001 3.899c23.613 81.159 41.037 164.067 52.345 247.551q.004.023.006.047a1842.766 1842.766 0 0 1 8.704 76.297v.01c8.096 86.968 10.077 174.31 6.654 261.524l-.001.018c87.69-16.868 174.399-38.837 259.519-65.893.298-3.399.547-6.838.743-10.233.596-9.41 1.015-18.843 1.333-28.286.101-2.997.142-6 .215-9 .159-6.527.273-13.059.303-19.598.006-1.527.07-3.049.07-4.577.001-3.623-.055-7.25-.094-10.876"
              }
            ),
            /* @__PURE__ */ jsx56(
              "path",
              {
                fill: "#B8DEDA",
                d: "m1411.577 592.63 7.645 7.644q4.063 4.377 9.631 6.188 4.94 2.595 10.586 2.593.473 0 .948-.018.476.018.947.018 5.645.002 10.586-2.593 5.568-1.81 9.632-6.188c5.239-5.706 9.128-13.195 8.772-21.169l-1.074-7.956c-1.422-5.069-3.987-9.475-7.698-13.208a7865 7865 0 0 1-7.64-7.645c-2.713-2.918-5.925-4.985-9.636-6.188q-4.935-2.595-10.581-2.593-.471 0-.948.018a25 25 0 0 0-.949-.018c-3.767 0-7.291.862-10.589 2.593-3.707 1.203-6.919 3.27-9.632 6.188-5.234 5.707-9.123 13.195-8.767 21.169l1.069 7.956c1.422 5.074 3.987 9.471 7.698 13.209M1559.214 1523.457c-.903-2.631-2.144-5.13-3.725-7.399-4.742-6.808-12.537-11.544-23.39-11.544h-4.731c-8.427 0-15.012 2.865-19.757 7.341a27.5 27.5 0 0 0-5.084 6.544 30.7 30.7 0 0 0-2.261 5.057c-1.206 3.508-1.811 7.25-1.813 10.992 0 1.871.148 3.742.449 5.583 2.101 12.892 11.584 24.351 28.467 24.351h4.731q1.806 0 3.499-.172a30 30 0 0 0 6.322-1.308c9.785-3.179 15.812-11.109 18.076-20.134a34.4 34.4 0 0 0 1.021-8.32c0-3.74-.6-7.483-1.804-10.991"
              }
            ),
            /* @__PURE__ */ jsx56(
              "path",
              {
                fill: "#B9DDCE",
                d: "M1707.482 980.776c-40.222 32.125-74.714 88.67-125.815 88.67-10.954 0-22.681-2.602-35.379-8.599-27.743-13.109-52.756-31.853-79.261-46.944q.004.023.006.047a1842.766 1842.766 0 0 1 8.704 76.297v.01c35.633 22.594 73.361 40.196 111.826 40.196 23.092 0 46.449-6.344 69.779-21.761 28.137-18.608 48.99-44.552 73.14-67.402a900 900 0 0 0-1.106-7.061q-1.27-7.75-2.636-15.489a1337 1337 0 0 0-7.635-39.265c-.446-2.094-.896-4.138-1.346-6.237-3.541 2.397-6.985 4.892-10.277 7.538"
              }
            ),
            /* @__PURE__ */ jsx56(
              "path",
              {
                fill: "#FFE58A",
                d: "M1260.782 945.32c38.524 0 38.587-59.868 0-59.868-38.521 0-38.587 59.868 0 59.868M1345.9 1244.706c2.66 4.502 6.241 8.078 10.738 10.743q3.576 1.508 7.152 3.016 7.955 2.142 15.915 0 1.858-.315 3.715-.624 5.843-1.393 10.18-5.359 4.89-3.165 7.711-8.399c2.187-3.435 3.371-7.147 3.552-11.128q1.337-5.972-.534-11.936-1.509-3.58-3.018-7.152-3.991-6.747-10.738-10.738a6091 6091 0 0 0-7.152-3.016q-7.955-2.14-15.915 0-1.858.308-3.715.624-5.843 1.39-10.18 5.36c-3.259 2.109-5.829 4.911-7.71 8.395-2.188 3.439-3.372 7.147-3.552 11.132q-1.338 5.965.533 11.937zM1026.775 1240.029c2.708-4.672 4.07-9.705 4.088-15.108v-3.825c.156-4.117-.704-7.966-2.58-11.532-1.206-3.708-3.269-6.923-6.187-9.632q-4.067-4.38-9.635-6.188c-3.566-1.876-7.41-2.733-11.532-2.582q-3.98.54-7.958 1.072c-5.069 1.423-9.474 3.986-13.208 7.698-1.561 2.017-3.12 4.039-4.682 6.056-2.707 4.672-4.069 9.705-4.086 15.108v3.825q-.233 6.183 2.577 11.532 1.813 5.569 6.19 9.632 4.067 4.378 9.632 6.192c3.569 1.871 7.413 2.733 11.535 2.577 2.653-.356 5.306-.716 7.956-1.072 5.072-1.422 9.477-3.985 13.211-7.698zM816.865 861.886v-2.363c0-38.524-59.868-38.587-59.868 0v2.363c0 38.524 59.868 38.587 59.868 0M666.705 1226.679l-6.058-4.677q-7.001-4.064-15.109-4.088l-7.956 1.067q-7.608 2.135-13.208 7.698c-1.274 1.277-2.548 2.548-3.823 3.825q-4.377 4.064-6.19 9.632-2.81 5.349-2.577 11.532-.233 6.183 2.577 11.532 1.813 5.568 6.19 9.637l6.059 4.677q7.002 4.064 15.108 4.087l7.956-1.067q7.609-2.135 13.211-7.698c1.274-1.277 2.548-2.548 3.82-3.825q4.381-4.063 6.19-9.632 2.813-5.349 2.577-11.532.235-6.183-2.577-11.532-1.809-5.565-6.19-9.636"
              }
            )
          ] }),
          /* @__PURE__ */ jsxs27("g", { transform: "translate(0, 26)", children: [
            /* @__PURE__ */ jsx56(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.7602 25.4871C21.9922 24.374 22.1095 23.2237 22.1095 22.0677V5.2207H30.5173V22.0677C30.5173 24.3337 30.2175 26.4791 29.6261 28.444C29.0316 30.419 28.1008 32.1732 26.8616 33.6567C25.6185 35.1446 24.0161 36.3302 22.0982 37.1808C20.1866 38.0295 17.8855 38.4598 15.2583 38.4598C12.5358 38.4598 10.177 38.0055 8.24724 37.1101C6.31369 36.2128 4.71943 34.9956 3.509 33.492C2.3017 31.9934 1.40423 30.2322 0.842284 28.2578C0.282851 26.2973 0 24.2144 0 22.0677V5.2207H8.4078V22.0677C8.4078 23.2875 8.53323 24.4592 8.77971 25.5502C9.02242 26.6311 9.42318 27.6079 9.9707 28.4535C10.5094 29.2876 11.215 29.9584 12.0686 30.4468C12.9171 30.9333 13.9908 31.1794 15.2583 31.1794C16.5252 31.1794 17.6058 30.9257 18.4713 30.4247C19.3406 29.9212 20.0555 29.2428 20.5943 28.4087C21.1399 27.565 21.5319 26.5825 21.7602 25.4871ZM44.7238 12.4097H34.4276V5.2207H63.3801V12.4097H53.1315V38.1866H44.7238V12.4097ZM122.033 16.4664C122.033 17.6918 121.721 18.7058 121.106 19.48C120.499 20.2429 119.803 20.6139 118.978 20.6139H112.175V12.4097H118.74C119.545 12.4097 120.278 12.7656 120.983 13.4975C121.68 14.2232 122.033 15.222 122.033 16.4664ZM127.284 24.4138C127.982 23.743 128.584 22.9764 129.071 22.1353C129.556 21.2954 129.934 20.3886 130.193 19.4415C130.452 18.4919 130.584 17.4911 130.584 16.4664C130.584 15.0971 130.296 13.7221 129.728 12.38C129.162 11.0467 128.367 9.8352 127.365 8.7789C126.361 7.72324 125.156 6.85751 123.785 6.20695C122.405 5.55261 120.884 5.2207 119.262 5.2207H103.766V38.1866H112.175V27.7574H116.767L123.553 38.1866H133.076L125.213 25.961C125.971 25.5256 126.667 25.0063 127.284 24.4138ZM158.417 23.6547V5.2207H166.825V38.1866H160.103L145.048 20.2435V38.1866H136.639V5.2207H143.172L143.267 5.33428L158.417 23.6547Z"
              }
            ),
            /* @__PURE__ */ jsx56(
              "path",
              {
                d: "M85.9097 8.83303H89.4011V21.8268C89.4011 22.9863 89.2994 24.1459 89.0621 25.2713C88.8249 26.3627 88.452 27.3517 87.8757 28.2043C87.3334 29.0228 86.6215 29.7049 85.7741 30.2165C84.8928 30.6939 83.8081 30.9667 82.5539 30.9667C81.2658 30.9667 80.215 30.728 79.3675 30.2165C78.5201 29.739 77.8083 29.0569 77.2659 28.2384C76.7236 27.3858 76.3168 26.3968 76.0456 25.3054C75.8083 24.2141 75.6727 23.0545 75.6727 21.8268V5.01334H67.3001V21.8268C67.3001 23.9754 67.5713 26.0557 68.1476 27.9997C68.6899 29.9777 69.6051 31.7511 70.7915 33.2176C72.0118 34.7523 73.605 35.946 75.5371 36.8327C77.4693 37.7535 79.8421 38.1969 82.5539 38.1969C85.164 38.1969 87.469 37.7535 89.4011 36.935C91.2994 36.0824 92.8925 34.8887 94.1467 33.3882C95.4009 31.9217 96.3161 30.1823 96.9263 28.2043C97.5025 26.2262 97.8076 24.0777 97.8076 21.8268V8.83303H101.197L93.401 4.10984e-06L85.9097 8.83303Z",
                fill: `url(#${fillId})`
              }
            ),
            /* @__PURE__ */ jsx56("defs", { children: /* @__PURE__ */ jsxs27(
              "linearGradient",
              {
                id: fillId,
                x1: "67.3001",
                y1: "19.0983",
                x2: "101.197",
                y2: "19.0983",
                gradientUnits: "userSpaceOnUse",
                children: [
                  /* @__PURE__ */ jsx56("stop", { stopColor: "#00BFEC" }),
                  /* @__PURE__ */ jsx56("stop", { offset: "1", stopColor: "#00C587" })
                ]
              }
            ) })
          ] })
        ]
      }
    );
  }
  if (variant === "christmas") {
    return /* @__PURE__ */ jsxs27(
      "svg",
      {
        width: "186",
        height: "61",
        viewBox: "0 0 186 61",
        className: cn("fill-foreground", className),
        children: [
          /* @__PURE__ */ jsx56(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M21.7602 47.4871C21.9922 46.374 22.1095 45.2237 22.1095 44.0677V27.2207H30.5173V44.0677C30.5173 46.3337 30.2175 48.4791 29.6261 50.444C29.0316 52.419 28.1008 54.1732 26.8616 55.6567C25.6185 57.1446 24.0161 58.3302 22.0982 59.1808C20.1866 60.0295 17.8855 60.4598 15.2583 60.4598C12.5358 60.4598 10.177 60.0055 8.24724 59.1101C6.31369 58.2128 4.71943 56.9956 3.509 55.492C2.3017 53.9934 1.40423 52.2322 0.842284 50.2578C0.282851 48.2973 0 46.2144 0 44.0677V27.2207H8.4078V44.0677C8.4078 45.2875 8.53323 46.4592 8.77971 47.5502C9.02242 48.6311 9.42318 49.6079 9.9707 50.4535C10.5094 51.2876 11.215 51.9584 12.0686 52.4468C12.9171 52.9333 13.9908 53.1794 15.2583 53.1794C16.5252 53.1794 17.6058 52.9257 18.4713 52.4247C19.3406 51.9212 20.0555 51.2428 20.5943 50.4087C21.1399 49.565 21.5319 48.5825 21.7602 47.4871ZM44.7238 34.4097H34.4276V27.2207H63.3801V34.4097H53.1315V60.1866H44.7238V34.4097ZM122.033 38.4664C122.033 39.6918 121.721 40.7058 121.106 41.48C120.499 42.2429 119.803 42.6139 118.978 42.6139H112.175V34.4097H118.74C119.545 34.4097 120.278 34.7656 120.983 35.4975C121.68 36.2232 122.033 37.222 122.033 38.4664ZM127.284 46.4138C127.982 45.743 128.584 44.9764 129.071 44.1353C129.556 43.2954 129.934 42.3886 130.193 41.4415C130.452 40.4919 130.584 39.4911 130.584 38.4664C130.584 37.0971 130.296 35.7221 129.728 34.38C129.162 33.0467 128.367 31.8352 127.365 30.7789C126.361 29.7232 125.156 28.8575 123.785 28.2069C122.405 27.5526 120.884 27.2207 119.262 27.2207H103.766V60.1866H112.175V49.7574H116.767L123.553 60.1866H133.076L125.213 47.961C125.971 47.5256 126.667 47.0063 127.284 46.4138ZM158.417 45.6547V27.2207H166.825V60.1866H160.103L145.048 42.2435V60.1866H136.639V27.2207H143.172L143.267 27.3343L158.417 45.6547Z"
            }
          ),
          /* @__PURE__ */ jsx56(
            "path",
            {
              d: "M85.9097 30.833H89.4011V43.8268C89.4011 44.9863 89.2994 46.1459 89.0621 47.2713C88.8249 48.3627 88.452 49.3517 87.8757 50.2043C87.3334 51.0228 86.6215 51.7049 85.7741 52.2165C84.8928 52.6939 83.8081 52.9667 82.5539 52.9667C81.2658 52.9667 80.215 52.728 79.3675 52.2165C78.5201 51.739 77.8083 51.0569 77.2659 50.2384C76.7236 49.3858 76.3168 48.3968 76.0456 47.3054C75.8083 46.2141 75.6727 45.0545 75.6727 43.8268V27.0133H67.3001V43.8268C67.3001 45.9754 67.5713 48.0557 68.1476 49.9997C68.6899 51.9777 69.6051 53.7511 70.7915 55.2176C72.0118 56.7523 73.605 57.946 75.5371 58.8327C77.4693 59.7535 79.8421 60.1969 82.5539 60.1969C85.164 60.1969 87.469 59.7535 89.4011 58.935C91.2994 58.0824 92.8925 56.8887 94.1467 55.3882C95.4009 53.9217 96.3161 52.1823 96.9263 50.2043C97.5025 48.2262 97.8076 46.0777 97.8076 43.8268V30.833H101.197L93.401 22L85.9097 30.833Z",
              fill: `url(#${fillId})`
            }
          ),
          /* @__PURE__ */ jsx56(
            "path",
            {
              d: "M162.711 26.5129C154.619 23.2682 142.338 18.8695 138.545 18.176C141.558 14.1008 145.355 10.6687 149.712 8.08089C156.541 4.03067 168.005 0.530772 172.049 7.35094C173.356 9.55191 174.724 17.5298 176.659 22.9953C176.441 23.093 176.224 23.2093 176.014 23.334C175.486 23.6438 174.993 24.0086 174.541 24.4221C172.326 22.3095 169.644 18.9407 167.809 18.0498C163.896 11.4536 170.146 21.1613 163.317 26.7547C163.118 26.6764 162.916 26.593 162.711 26.5129Z",
              fill: "#FF2946"
            }
          ),
          /* @__PURE__ */ jsx56(
            "path",
            {
              d: "M178.719 22.4017C179.983 22.5353 180.499 22.9314 181.947 23.6894C182.693 24.0801 183.587 25.3517 183.587 25.3517C184.157 26.3133 183.264 26.9675 184.284 28.6867C184.354 30.3928 183.525 31.2257 182.366 31.9135C181.316 32.5368 180.167 33.0781 179.034 33.4074C179.002 33.3611 178.973 33.317 178.945 33.2714C178.762 32.9623 180.458 24.1527 179.901 23.2135C179.649 22.7882 179.114 22.6568 178.6 22.4795C178.635 22.461 178.662 22.4382 178.698 22.4142L178.719 22.4017Z",
              fill: "#D9D9D9"
            }
          ),
          /* @__PURE__ */ jsx56(
            "path",
            {
              d: "M176.659 22.9967C176.688 22.9801 176.718 22.965 176.748 22.9515C177.373 22.6721 177.966 22.8555 178.57 22.4973L178.6 22.4795C179.114 22.6568 179.649 22.7895 179.902 23.2133C180.458 24.1527 178.761 32.9625 178.946 33.2713C178.973 33.317 179.002 33.3611 179.034 33.4074C176.787 34.0606 174.6 33.8698 173.37 31.7959C171.968 29.4315 172.242 26.5523 174.541 24.4221C174.993 24.0085 175.486 23.6438 176.014 23.334C176.224 23.2093 176.441 23.093 176.659 22.9967Z",
              fill: "#EBEBEB"
            }
          ),
          /* @__PURE__ */ jsx56(
            "path",
            {
              d: "M163.317 26.7547C170.146 21.1613 163.896 11.4536 167.81 18.0496C168.078 21.3466 168.654 25.2137 167.825 28.6614C166.651 28.1291 165.1 27.4747 163.317 26.7547Z",
              fill: "#E82E52"
            }
          ),
          /* @__PURE__ */ jsx56(
            "path",
            {
              d: "M167.825 28.6614C166.651 28.1291 165.1 27.4747 163.317 26.7547C163.118 26.6764 162.916 26.593 162.711 26.5128L162.934 27.0564C164.216 30.0844 166.366 33.868 161.154 37.001C163.972 38.2359 166.187 38.8982 167.286 38.2461C168.089 37.7676 171.19 31.6913 170.143 29.9291C170.023 29.7276 169.174 29.2755 167.825 28.6614Z",
              fill: "#D9D9D9"
            }
          ),
          /* @__PURE__ */ jsx56(
            "path",
            {
              d: "M138.546 18.1758C142.338 18.8708 154.619 23.2682 162.711 26.5128L162.934 27.0551C164.216 30.0844 166.366 33.868 161.154 37.001C155.291 34.4301 146.829 29.3742 140.461 28.5006C138.548 28.2375 135.625 28.3273 134.733 26.8233C133.692 25.0682 135.791 21.2026 136.39 18.8575C136.724 18.6581 137.089 18.3471 137.448 18.1334C137.589 18.051 137.97 18.0733 138.546 18.1758Z",
              fill: "#EBEBEB"
            }
          ),
          /* @__PURE__ */ jsx56("defs", { children: /* @__PURE__ */ jsxs27(
            "linearGradient",
            {
              id: fillId,
              x1: "67.3001",
              y1: "41.0983",
              x2: "101.197",
              y2: "41.0983",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx56("stop", { stopColor: "#00BFEC" }),
                /* @__PURE__ */ jsx56("stop", { offset: "1", stopColor: "#00C587" })
              ]
            }
          ) })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs27(
    "svg",
    __spreadProps(__spreadValues({}, props), {
      className: cn("fill-foreground dark:fill-primary", className),
      viewBox: "77.95 85.01 637.8 85.08",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "UTURN",
      children: [
        /* @__PURE__ */ jsxs27("g", { children: [
          /* @__PURE__ */ jsx56("path", { d: "M600.168,170.071h-24.793s0-44.959,0-59.383c0-17.597,6.926-25.664,26.35-25.664,4.132,0,21.52,0,21.52,0v19.49s-23.077,0-23.077,0v65.557Z" }),
          /* @__PURE__ */ jsx56("path", { d: "M464.226,150.587h-21.251v-46.085h21.251s0-19.455,0-19.455h-63.754s0,19.455,0,19.455h17.745c0,13.926,0,30.779,0,38.593,0,19.508,8.819,27,27.68,27,4.728,0,18.329,0,18.329,0v-19.508Z" }),
          /* @__PURE__ */ jsx56("path", { d: "M365.06,85.026v65.539h-14.87c-12.233,0-13.571-5.315-13.571-14.299,0-14.033,0-51.241,0-51.241h-24.811s0,33.487,0,47.839c0,27.534,6.659,37.208,37.987,37.208,13.284,0,25.785,0,38.536,0v-85.047s-23.27,0-23.27,0Z" }),
          /* @__PURE__ */ jsx56("path", { d: "M534.353,85.026v65.539h-14.87c-12.233,0-13.571-5.315-13.571-14.299,0-14.033,0-51.241,0-51.241h-24.811s0,33.487,0,47.839c0,27.534,6.659,37.208,37.987,37.208,13.284,0,25.785,0,38.536,0v-85.047s-23.27,0-23.27,0Z" }),
          /* @__PURE__ */ jsx56("path", { d: "M661.075,170.073v-65.539h16.288c12.233,0,13.571,5.315,13.571,14.299,0,14.033,0,51.241,0,51.241h24.811s0-33.487,0-47.839c0-27.534-6.659-37.208-37.987-37.208-13.284,0-27.202,0-39.953,0v85.047s23.27,0,23.27,0Z" })
        ] }),
        /* @__PURE__ */ jsxs27("g", { children: [
          /* @__PURE__ */ jsx56("path", { d: "M200.553,85.012h-37.563v42.535h42.52v42.535h42.52v-37.218c0-31.399-15.82-47.852-47.476-47.852Z" }),
          /* @__PURE__ */ jsx56("path", { d: "M200.407,85.012h-37.417v42.535h42.52v42.535h42.52v-37.431c0-31.668-15.966-47.64-47.622-47.64Z" }),
          /* @__PURE__ */ jsx56("path", { d: "M125.572,170.083h37.417v-42.535h-42.52v-42.535h-42.52v37.431c0,31.668,15.966,47.64,47.622,47.64Z" })
        ] })
      ]
    })
  );
}

// src/components/uturn-ui/pagination/pagination.utils.ts
var calculateSiblingRange = (currentPage, totalPages, firstPage, lastPage, siblings) => {
  const first = firstPage + 1;
  const last = lastPage - 1;
  const threshold = Math.ceil(siblings / 2);
  const count2 = siblings - 2;
  if (totalPages <= siblings) {
    return {
      first,
      last,
      start: first,
      end: last
    };
  }
  if (currentPage < first + threshold) {
    return {
      first,
      last,
      start: first,
      end: firstPage + count2
    };
  }
  if (currentPage > last - threshold) {
    return {
      first,
      last,
      start: lastPage - count2,
      end: last
    };
  }
  return {
    first,
    last,
    start: currentPage - threshold + 2,
    // Account for first page and ellipsis.
    end: currentPage + threshold - 2
    // Account for last page and ellipsis.
  };
};
var range = (start, end, step = 1) => {
  const result = [];
  if (step === 0) {
    return result;
  }
  if (start < end) {
    for (let i = start; i <= end; i += step) {
      result.push(i);
    }
  } else {
    for (let i = start; i >= end; i -= Math.abs(step)) {
      result.push(i);
    }
  }
  return result;
};

// src/components/uturn-ui/pagination/pagination.tsx
import { jsx as jsx57, jsxs as jsxs28 } from "react/jsx-runtime";
var PaginationCompact = ({
  className,
  page: requestedPage,
  setPage: setCurrentPage,
  totalPages,
  pageLimit: siblings = 5,
  paginationBackendSource = "java"
}) => {
  if (totalPages < 1 || siblings < 3) {
    return null;
  }
  const pageOffset = paginationBackendSource === "java" ? 0 : 1;
  const firstPage = pageOffset;
  const lastPage = totalPages - (1 - pageOffset);
  const currentPage = Math.max(firstPage, Math.min(lastPage, requestedPage));
  const getPageNumber = (page) => {
    return pageOffset === 0 ? page + 1 : page;
  };
  const Page = ({ page }) => {
    const isCurrent = currentPage === page;
    const pageNumber = getPageNumber(page);
    return /* @__PURE__ */ jsx57(
      PaginationItem,
      {
        "aria-current": isCurrent && "page",
        "aria-label": `Page ${pageNumber}`,
        "aria-disabled": isCurrent,
        tabIndex: isCurrent ? -1 : void 0,
        className: isCurrent ? "pointer-events-none" : void 0,
        onClick: isCurrent ? void 0 : () => setCurrentPage(page),
        children: /* @__PURE__ */ jsx57(PaginationLink, { isActive: isCurrent, children: pageNumber })
      },
      `pagination-${page}`
    );
  };
  const Navigation = ({ page, step }) => {
    const isCurrent = currentPage === page;
    const isPrevious = step === -1;
    const pageNumber = getPageNumber(page);
    return /* @__PURE__ */ jsx57(
      PaginationItem,
      {
        "aria-label": `Page ${pageNumber}`,
        "aria-disabled": isCurrent,
        tabIndex: isCurrent ? -1 : void 0,
        className: isCurrent ? "pointer-events-none opacity-50" : void 0,
        onClick: isCurrent ? void 0 : () => setCurrentPage(currentPage + step),
        children: isPrevious ? /* @__PURE__ */ jsx57(PaginationPrevious, {}) : /* @__PURE__ */ jsx57(PaginationNext, {})
      },
      `navigation-${isPrevious ? "previous" : "next"}`
    );
  };
  const Ellipsis = ({ page, label }) => {
    return /* @__PURE__ */ jsx57(
      PaginationItem,
      {
        onClick: () => setCurrentPage(page),
        children: /* @__PURE__ */ jsx57(PaginationEllipsis, {})
      },
      `ellipsis-${label}`
    );
  };
  const {
    first: siblingFirst,
    last: siblingLast,
    start: siblingStart,
    end: siblingEnd
  } = calculateSiblingRange(
    currentPage,
    totalPages,
    firstPage,
    lastPage,
    siblings
  );
  const showLeftEllipsis = siblingStart > siblingFirst;
  const showRightEllipsis = siblingEnd < siblingLast;
  return /* @__PURE__ */ jsx57(Pagination, { className, children: /* @__PURE__ */ jsxs28(PaginationContent, { children: [
    /* @__PURE__ */ jsx57(Navigation, { page: firstPage, step: -1 }),
    /* @__PURE__ */ jsx57(Page, { page: firstPage }),
    showLeftEllipsis && /* @__PURE__ */ jsx57(Ellipsis, { page: siblingStart - 1, label: "left" }),
    siblingStart <= siblingEnd && range(siblingStart, siblingEnd).map((page) => /* @__PURE__ */ jsx57(Page, { page }, `page-${page}`)),
    showRightEllipsis && /* @__PURE__ */ jsx57(Ellipsis, { page: siblingEnd + 1, label: "right" }),
    totalPages > 1 && /* @__PURE__ */ jsx57(Page, { page: lastPage }),
    /* @__PURE__ */ jsx57(Navigation, { page: lastPage, step: 1 })
  ] }) });
};
PaginationCompact.displayName = "Pagination";

// src/components/uturn-ui/select/combobox.tsx
import { Check as Check4, ChevronDown as ChevronDown4, XIcon } from "lucide-react";
import {
  forwardRef as forwardRef33,
  useCallback as useCallback3,
  useEffect as useEffect4,
  useMemo as useMemo2,
  useState as useState8
} from "react";
import { useTranslation as useTranslation4 } from "react-i18next";

// src/components/uturn-ui/select/combobox.utils.ts
var findOption = (options, value) => {
  if (value === void 0 || value === "" || value === 0) {
    return void 0;
  }
  let result = options.find((option) => option.value === value);
  if (result === void 0) {
    result = options.filter((option) => option.secondaryValue !== void 0).find((option) => {
      var _a;
      return ((_a = option.secondaryValue) == null ? void 0 : _a.toString()) === value.toString();
    });
  }
  return result;
};
var defaultFilterFn = (label, search, keywords) => {
  if (keywords && keywords.length > 0 && keywords.some(
    (keyword) => keyword.toLowerCase().includes(search.toLowerCase())
  )) {
    return 1;
  }
  return label.toLowerCase().includes(search.toLowerCase()) ? 1 : 0;
};

// src/components/uturn-ui/select/utils.ts
var NO_GROUP = "no-group";
function arrayGroupBy(array, keyGetter, defaultGroup) {
  const map = /* @__PURE__ */ new Map();
  array.forEach((item) => {
    var _a;
    const key = (_a = keyGetter(item)) != null ? _a : defaultGroup;
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return Array.from(map.entries());
}
var removeDuplicates = (arr) => {
  return Array.from(new Set(arr));
};
var removeDuplicatesByKey = (arr, key) => {
  const seen = /* @__PURE__ */ new Set();
  return arr.filter((item) => {
    const val = item[key];
    if (seen.has(val)) {
      return false;
    }
    seen.add(val);
    return true;
  });
};

// src/components/uturn-ui/select/combobox.tsx
import { Fragment as Fragment3, jsx as jsx58, jsxs as jsxs29 } from "react/jsx-runtime";
var ComboboxTrigger = ({
  ref,
  className,
  variant,
  selected,
  disabled,
  open,
  onReset,
  "aria-invalid": ariaInvalid,
  children
}) => {
  const placeholderStyle = () => {
    if (selected) {
      return void 0;
    }
    if (variant !== "default" && variant !== "destructive") {
      return "text-muted-foreground";
    }
    return "font-extralight italic";
  };
  return /* @__PURE__ */ jsx58(PopoverTrigger, { disabled, asChild: true, children: /* @__PURE__ */ jsxs29(
    Button,
    {
      ref,
      variant,
      role: "combobox",
      "aria-expanded": open,
      "aria-invalid": ariaInvalid,
      className: cn(
        "w-full justify-between [.theme-uturn_&]:rounded-md",
        placeholderStyle(),
        disabled && "opacity-50 cursor-not-allowed",
        ariaInvalid && "border-destructive focus:ring-destructive focus-visible:ring-destructive",
        className
      ),
      children: [
        /* @__PURE__ */ jsx58("p", { className: "truncate", children }),
        !disabled && /* @__PURE__ */ jsxs29("span", { className: "flex items-center space-x-3", children: [
          selected && onReset && /* @__PURE__ */ jsxs29(Fragment3, { children: [
            /* @__PURE__ */ jsx58(
              XIcon,
              {
                className: "size-4 shrink-0 opacity-50 transition-all duration-200 hover:opacity-100",
                onClick: (event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  onReset();
                }
              }
            ),
            /* @__PURE__ */ jsx58(Separator3, { className: "h-4 shrink-0", orientation: "vertical" })
          ] }),
          /* @__PURE__ */ jsx58(
            ChevronDown4,
            {
              className: cn(
                "size-4 shrink-0 opacity-50 transition-all duration-200 hover:opacity-100",
                open && "transform rotate-180"
              )
            }
          )
        ] })
      ]
    }
  ) });
};
var ComboboxContent = ({
  className,
  disabled,
  align,
  emptyMessage,
  placeholder,
  filter,
  children
}) => {
  const attachWheelGuard = useCallback3((node) => {
    if (!node) {
      return;
    }
    const stopWheelPropagation = (event) => event.stopPropagation();
    node.addEventListener("wheel", stopWheelPropagation, { passive: true });
    return () => node.removeEventListener("wheel", stopWheelPropagation);
  }, []);
  if (disabled) {
    return null;
  }
  return /* @__PURE__ */ jsx58(
    PopoverContent,
    {
      align,
      className: cn("w-[var(--radix-popover-trigger-width)] p-0", className),
      children: /* @__PURE__ */ jsxs29(Command, { filter, children: [
        /* @__PURE__ */ jsx58(CommandInput, { placeholder, className: "h-9" }),
        /* @__PURE__ */ jsxs29(CommandList, { ref: attachWheelGuard, children: [
          /* @__PURE__ */ jsx58(CommandEmpty, { children: emptyMessage }),
          children
        ] })
      ] })
    }
  );
};
var ComboboxGroup = ({ group, children }) => {
  if (group === NO_GROUP) {
    return /* @__PURE__ */ jsx58(CommandGroup, { className: "h-[300px] overflow-y-scroll", children });
  }
  return /* @__PURE__ */ jsxs29(Fragment3, { children: [
    /* @__PURE__ */ jsx58(
      CommandGroup,
      {
        heading: group,
        className: "h-full overflow-auto",
        children
      }
    ),
    /* @__PURE__ */ jsx58(CommandSeparator, {})
  ] });
};
var ComboboxItem = ({
  option,
  selected,
  onSelect,
  align
}) => {
  const isSelected = selected ? option.value === selected.value : false;
  const opacityClass = isSelected ? "opacity-75" : "opacity-0";
  const CheckSymbol = ({ side }) => {
    if (align !== side) {
      return null;
    }
    const marginClass = align === "end" ? "ml-auto" : "mr-2";
    return /* @__PURE__ */ jsx58(Check4, { className: cn(marginClass, "size-4", opacityClass) });
  };
  return /* @__PURE__ */ jsxs29(
    CommandItem,
    {
      value: option.label,
      onSelect,
      disabled: option == null ? void 0 : option.disabled,
      keywords: option == null ? void 0 : option.keywords,
      children: [
        /* @__PURE__ */ jsx58(CheckSymbol, { side: "start" }),
        option.label,
        /* @__PURE__ */ jsx58(CheckSymbol, { side: "end" })
      ]
    }
  );
};
var debug = false;
var Combobox = forwardRef33(
  function Combobox2({
    options = [],
    value,
    defaultValue,
    onChange,
    onReset,
    variant = "outline",
    className,
    placeholder: placeholderProp,
    emptyMessage: emptyMessageProp,
    searchPlaceholder: searchPlaceholderProp,
    searchClassName,
    disabled = false,
    nullable = false,
    align = "start",
    alignCheck = "start",
    closeOnSelect = true,
    filter = defaultFilterFn,
    "aria-invalid": ariaInvalid
  }, ref) {
    const { t } = useTranslation4();
    const placeholder = placeholderProp != null ? placeholderProp : t("general.select-input.placeholder", "Select an option");
    const emptyMessage = emptyMessageProp != null ? emptyMessageProp : t("general.select-input.no-results", "No results found.");
    const searchPlaceholder = searchPlaceholderProp != null ? searchPlaceholderProp : t("general.select-input.search-placeholder", "Type to search");
    const initialSelected = useMemo2(
      () => findOption(options, defaultValue != null ? defaultValue : value),
      [options, defaultValue, value]
    );
    const [open, setOpen] = useState8(false);
    const [selected, setSelected] = useState8(initialSelected);
    useEffect4(() => {
      setSelected(initialSelected);
    }, [initialSelected]);
    const input = selected ? selected.label : placeholder;
    const handleReset = () => {
      setSelected(void 0);
      onChange(void 0);
      if (onReset) {
        onReset();
      }
      if (closeOnSelect) {
        setOpen(false);
      }
    };
    const handleSelect = (option) => {
      setSelected(option);
      onChange(option.value);
      if (option.onSelect) {
        option.onSelect();
      }
      if (closeOnSelect) {
        setOpen(false);
      }
    };
    return /* @__PURE__ */ jsxs29(Popover, { open, onOpenChange: setOpen, children: [
      /* @__PURE__ */ jsx58(
        ComboboxTrigger,
        {
          ref,
          className,
          variant,
          selected: !!selected,
          disabled,
          open,
          onReset: nullable ? handleReset : void 0,
          "aria-invalid": ariaInvalid,
          children: input
        }
      ),
      /* @__PURE__ */ jsx58(
        ComboboxContent,
        {
          align,
          className: searchClassName,
          disabled,
          filter,
          placeholder: searchPlaceholder,
          emptyMessage,
          children: arrayGroupBy(options, (option) => option.group, NO_GROUP).map(
            ([group, groupOptions]) => /* @__PURE__ */ jsx58(ComboboxGroup, { group, children: groupOptions == null ? void 0 : groupOptions.map((option) => /* @__PURE__ */ jsx58(
              ComboboxItem,
              {
                option,
                selected,
                onSelect: () => handleSelect(option),
                align: alignCheck
              },
              `combobox-item-${option.value.toString()}`
            )) }, `combobox-group-${group}`)
          )
        }
      )
    ] });
  }
);
Combobox.displayName = "Combobox";

// src/components/uturn-ui/select/multi-select.tsx
import { useTranslation as useTranslation5 } from "react-i18next";
import {
  Check as Check5,
  ChevronDown as ChevronDown5,
  ListCollapse,
  ListTree,
  XIcon as XIcon2
} from "lucide-react";
import {
  createContext as createContext6,
  forwardRef as forwardRef34,
  useContext as useContext6,
  useState as useState10
} from "react";

// src/components/uturn-ui/select/multi-select.typeguards.ts
function isString(value) {
  return typeof value === "string";
}
function isNumber(value) {
  return typeof value === "number";
}
function isBoolean(value) {
  return typeof value === "boolean";
}
function isObject2(value) {
  return typeof value === "object";
}
function isOptionValue(option) {
  return isString(option) || isNumber(option);
}
function isArrayOf(guard, values) {
  return !!values && Array.isArray(values) && values.every(guard);
}
function isOption(option) {
  return !!option && isObject2(option) && (!("disabled" in option) || isBoolean(option.disabled)) && (!("parents" in option) || isArrayOf(isOptionValue, option.parents)) && "value" in option && isOptionValue(option.value) && "label" in option && isString(option.label);
}
function isGroupOptions(option) {
  return !!option && isObject2(option) && (!("value" in option) || isOptionValue(option.value)) && "name" in option && isString(option.name) && "options" in option && isArrayOf(isOption, option.options);
}
function isRequiredOption(option) {
  return !!option && isObject2(option) && "disabled" in option && isBoolean(option.disabled) && "parents" in option && isArrayOf(isOptionValue, option.parents) && "value" in option && isOptionValue(option.value) && "label" in option && isString(option.label);
}
function isRequiredGroupOptions(option) {
  return !!option && isObject2(option) && "value" in option && isOptionValue(option.value) && "name" in option && isString(option.name) && "options" in option && isArrayOf(isRequiredOption, option.options);
}

// src/components/uturn-ui/select/multi-select.utils.ts
import { useCallback as useCallback4, useMemo as useMemo3, useState as useState9 } from "react";
var doNothing = () => {
};
var slugify = (word) => {
  if (typeof word === "number") {
    return word;
  }
  if (word === NO_GROUP) {
    return word;
  }
  return word.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().replace(/[^a-z0-9\s-]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
};
var parseOptionTypes = (optionTypes) => {
  const options = [];
  const optionsGroupless = [];
  const groups = [];
  const optionValueParentGroups = /* @__PURE__ */ new Map();
  optionTypes.forEach((optionType) => {
    var _a, _b, _c;
    if (isGroupOptions(optionType)) {
      const groupSlug = slugify((_a = optionType.value) != null ? _a : optionType.name);
      const groupOptions = optionType.options.map((option) => {
        var _a2, _b2;
        const groupSlugs = [groupSlug];
        if (optionValueParentGroups.has(option.value)) {
          groupSlugs.push(...(_a2 = optionValueParentGroups.get(option.value)) != null ? _a2 : []);
        }
        optionValueParentGroups.set(option.value, groupSlugs);
        return __spreadProps(__spreadValues({}, option), {
          disabled: (_b2 = option.disabled) != null ? _b2 : false,
          parents: groupSlugs
        });
      });
      groups.push(__spreadProps(__spreadValues({}, optionType), {
        value: groupSlug,
        options: groupOptions
      }));
      options.push(...groupOptions);
    } else {
      options.push(__spreadProps(__spreadValues({}, optionType), {
        disabled: (_b = optionType.disabled) != null ? _b : false,
        parents: []
      }));
      optionsGroupless.push(__spreadProps(__spreadValues({}, optionType), {
        disabled: (_c = optionType.disabled) != null ? _c : false,
        parents: []
      }));
    }
  });
  const groupsSelectable = groups.length > 0;
  if (optionsGroupless.length > 0) {
    groups.push({
      name: NO_GROUP,
      value: NO_GROUP,
      options: optionsGroupless
    });
  }
  return {
    options: removeDuplicatesByKey(
      options.map((option) => {
        var _a;
        if (optionValueParentGroups.has(option.value)) {
          return __spreadProps(__spreadValues({}, option), {
            parents: (_a = optionValueParentGroups.get(option.value)) != null ? _a : []
          });
        }
        return option;
      }),
      "value"
    ),
    groups: groups.map((group) => __spreadProps(__spreadValues({}, group), {
      options: group.options.map((option) => {
        var _a;
        if (optionValueParentGroups.has(option.value)) {
          return __spreadProps(__spreadValues({}, option), {
            parents: (_a = optionValueParentGroups.get(option.value)) != null ? _a : []
          });
        }
        return option;
      })
    })),
    groupsSelectable
  };
};
var parseOptions = (options, selected) => {
  const disabledOptions = options.filter((option) => option.disabled);
  const enabledOptions = !disabledOptions.length ? options : options.filter((option) => !option.disabled);
  const disabledOptionsOn = disabledOptions.filter(
    (option) => selected.includes(option.value)
  );
  const disabledOptionsOff = disabledOptions.filter(
    (option) => !selected.includes(option.value)
  );
  const selectAllSize = options.length - disabledOptionsOff.length;
  return {
    enabledOptions,
    disabledOptionsOn,
    disabledOptionsOff,
    selectAllSize
  };
};
var parseGroupOptions = (groups, selected, groupsSelectable) => {
  if (!groupsSelectable) {
    return {
      initialGroupsSelected: {},
      expandableGroups: []
    };
  }
  const initialGroupsSelected = groups.reduce(
    (acc, group) => {
      acc[group.value] = group.options.reduce(
        (groupCountInfo, option) => {
          const newGroupCountInfo = __spreadValues({}, groupCountInfo);
          newGroupCountInfo.total += 1;
          if (selected.includes(option.value)) {
            newGroupCountInfo.selected += 1;
            if (option.disabled) {
              newGroupCountInfo.disabledOn += 1;
            } else {
              newGroupCountInfo.enabled += 1;
            }
          } else if (option.disabled) {
            newGroupCountInfo.disabledOff += 1;
          } else {
            newGroupCountInfo.enabled += 1;
          }
          newGroupCountInfo.allSize = newGroupCountInfo.total - newGroupCountInfo.disabledOff;
          return newGroupCountInfo;
        },
        {
          total: 0,
          selected: 0,
          enabled: 0,
          disabledOff: 0,
          disabledOn: 0,
          allSize: 0
        }
      );
      return acc;
    },
    {}
  );
  const expandableGroups = groups.filter(
    (group) => group.name !== NO_GROUP && group.options.length > 0
  );
  return { initialGroupsSelected, expandableGroups };
};
var getSelectedOptionTypes = (options, selected, groupsSelectable, groups = [], groupsSelected = {}) => {
  if (!groupsSelectable) {
    return options.filter((option) => selected.includes(option.value));
  }
  const selectedGroups = groups.filter(
    (group) => group.name !== NO_GROUP && group.options.length > 0 && groupsSelected[group.value] && groupsSelected[group.value].selected === groupsSelected[group.value].allSize
  );
  const selectedOptionTypes = [
    ...selectedGroups,
    ...options.filter((option) => {
      if (!selected.includes(option.value)) {
        return false;
      }
      if (!option.parents.length) {
        return true;
      }
      if (selectedGroups.some((group) => option.parents.includes(group.value))) {
        return false;
      }
      return true;
    })
  ];
  return selectedOptionTypes;
};
var getCheckboxClassName = (checked, variant) => {
  switch (variant) {
    case "outline":
      switch (checked) {
        case true:
          return [
            "data-[state=checked]:bg-transparent",
            "data-[state=checked]:border-black",
            "data-[state=checked]:text-foreground",
            "bg-transparent",
            "border-black",
            "text-foreground",
            "dark:border-white"
          ].join(" ");
        case false:
          return [
            "data-[state=unchecked]:bg-transparent",
            "data-[state=unchecked]:border-black",
            "bg-transparent",
            "border-black",
            "dark:border-white"
          ].join(" ");
        default:
          return [
            "data-[state=indeterminate]:bg-transparent",
            "data-[state=indeterminate]:border-back",
            "data-[state=indeterminate]:border-dotted",
            "data-[state=indeterminate]:text-foreground",
            "data-[state=indeterminate]:text-muted-foreground",
            "bg-transparent",
            "border-back",
            "border-dotted",
            "text-foreground",
            "text-muted-foreground",
            "dark:border-white"
          ].join(" ");
      }
    case "secondary":
      switch (checked) {
        case true:
          return [
            "data-[state=checked]:bg-secondary",
            "data-[state=checked]:border-secondary",
            "data-[state=checked]:text-secondary-foreground",
            "bg-secondary",
            "border-secondary",
            "text-secondary-foreground"
          ].join(" ");
        case false:
          return [
            "data-[state=unchecked]:bg-transparent",
            "data-[state=indeterminate]:border-back",
            "data-[state=indeterminate]:border-dotted",
            "bg-transparent",
            "border-back",
            "border-dotted"
          ].join(" ");
        default:
          return [
            "data-[state=indeterminate]:bg-transparent",
            "data-[state=indeterminate]:border-back",
            "data-[state=indeterminate]:border-dotted",
            "data-[state=indeterminate]:text-foreground",
            "data-[state=indeterminate]:text-muted-foreground",
            "bg-transparent",
            "border-back",
            "border-dotted",
            "text-foreground",
            "text-muted-foreground"
          ].join(" ");
      }
    case "destructive":
      switch (checked) {
        case true:
          return [
            "data-[state=checked]:bg-destructive",
            "data-[state=checked]:border-destructive",
            "data-[state=checked]:text-destructive-foreground",
            "bg-destructive",
            "border-destructive",
            "text-destructive-foreground"
          ].join(" ");
        case false:
          return [
            "data-[state=unchecked]:bg-transparent",
            "data-[state=unchecked]:border-destructive",
            "bg-transparent",
            "border-destructive"
          ].join(" ");
        default:
          return [
            "data-[state=indeterminate]:bg-transparent",
            "data-[state=indeterminate]:border-destructive",
            "data-[state=indeterminate]:text-destructive",
            "bg-transparent",
            "border-destructive",
            "text-destructive"
          ].join(" ");
      }
    default:
      return checked === "indeterminate" ? "text-primary" : "";
  }
};
var useMultiSelect = (optionTypes = [], selected = [], onChange = doNothing, setOpen = doNothing, alignCheck = "start") => {
  const { options, groups, groupsSelectable } = useMemo3(
    () => parseOptionTypes(optionTypes),
    [optionTypes]
  );
  if (groupsSelectable && alignCheck === "end") {
    throw new Error(
      "Invalid prop combination: groupsSelectable + alignCheck=end"
    );
  }
  const {
    enabledOptions,
    disabledOptionsOn,
    disabledOptionsOff,
    selectAllSize
  } = useMemo3(() => parseOptions(options, selected), [options, selected]);
  const { initialGroupsSelected, expandableGroups } = useMemo3(
    () => parseGroupOptions(groups, selected, groupsSelectable),
    [groups, selected, groupsSelectable]
  );
  const selectedOptionTypes = useMemo3(
    () => getSelectedOptionTypes(
      options,
      selected,
      groupsSelectable,
      groups,
      initialGroupsSelected
    ),
    [options, selected, groupsSelectable, groups, initialGroupsSelected]
  );
  const [groupsSelected, setGroupsSelected] = useState9(initialGroupsSelected);
  const [selectAll, setSelectAll] = useState9(selected.length === selectAllSize);
  const [collapseAllGroups, setCollapseAllGroups] = useState9(true);
  const [expandedGroups, setExpandedGroups] = useState9([]);
  const handleUnselect = useCallback4(
    (selectedOption) => {
      onChange(selected.filter((value) => value !== selectedOption.value));
      setSelectAll(false);
      if (selectedOption.parents.length) {
        const newGroupsSelected = __spreadValues({}, groupsSelected);
        selectedOption.parents.forEach((parent) => {
          newGroupsSelected[parent].selected -= 1;
        });
        setGroupsSelected(newGroupsSelected);
      }
    },
    [selected, groupsSelected, onChange]
  );
  const handleToggleSelect = useCallback4(
    (toggledOption) => {
      if (selected.includes(toggledOption.value)) {
        handleUnselect(toggledOption);
      } else {
        const newSelected = [...selected, toggledOption.value];
        onChange(removeDuplicates(newSelected));
        if (newSelected.length === selectAllSize) {
          setSelectAll(true);
        }
        if (toggledOption.parents.length) {
          const newGroupsSelected = __spreadValues({}, groupsSelected);
          toggledOption.parents.forEach((parent) => {
            newGroupsSelected[parent].selected += 1;
          });
          setGroupsSelected(newGroupsSelected);
        }
      }
      setOpen(true);
    },
    [
      selected,
      groupsSelected,
      selectAllSize,
      setOpen,
      onChange,
      handleUnselect
    ]
  );
  const handleUnselectGroup = useCallback4(
    (selectedGroup) => {
      const newGroupsSelected = __spreadValues({}, groupsSelected);
      let newSelected = [...selected];
      selectedGroup.options.forEach((option) => {
        if (option.disabled) {
          return;
        }
        if (newSelected.includes(option.value)) {
          newSelected = newSelected.filter((value) => value !== option.value);
          if (option.parents && option.parents.length > 1) {
            option.parents.filter((parent) => parent !== selectedGroup.value).forEach((parent) => {
              var _a, _b;
              newGroupsSelected[parent].selected = (_b = (_a = groups.find((group) => group.value === parent)) == null ? void 0 : _a.options.filter(
                (groupOption) => newSelected.includes(groupOption.value)
              ).length) != null ? _b : 0;
            });
          }
        }
      });
      onChange(newSelected);
      if (selectAll) {
        setSelectAll(false);
      }
      newGroupsSelected[selectedGroup.value].selected = newGroupsSelected[selectedGroup.value].disabledOn;
      setGroupsSelected(newGroupsSelected);
    },
    [selected, groups, groupsSelected, onChange, selectAll]
  );
  const handleToggleSelectGroup = useCallback4(
    (toggledGroup) => {
      if (toggledGroup.name === NO_GROUP) {
        return;
      }
      const selectAllInGroup = groupsSelected[toggledGroup.value].selected !== groupsSelected[toggledGroup.value].allSize;
      if (selectAllInGroup) {
        const newGroupsSelected = __spreadValues({}, groupsSelected);
        let newSelected = [...selected];
        toggledGroup.options.forEach((option) => {
          if (option.disabled) {
            return;
          }
          if (!newSelected.includes(option.value)) {
            newSelected = [...newSelected, option.value];
            if (option.parents && option.parents.length > 1) {
              option.parents.filter((parent) => parent !== toggledGroup.value).forEach((parent) => {
                newGroupsSelected[parent].selected += 1;
              });
            }
          }
        });
        onChange(newSelected);
        if (newSelected.length === selectAllSize) {
          setSelectAll(true);
        }
        newGroupsSelected[toggledGroup.value].selected = newGroupsSelected[toggledGroup.value].disabledOn + newGroupsSelected[toggledGroup.value].enabled;
        setGroupsSelected(newGroupsSelected);
      } else {
        handleUnselectGroup(toggledGroup);
      }
      setOpen(true);
    },
    [
      selected,
      groupsSelected,
      selectAllSize,
      setOpen,
      onChange,
      handleUnselectGroup
    ]
  );
  const handleUnselectAll = useCallback4(() => {
    onChange(disabledOptionsOn.map((option) => option.value));
    setSelectAll(false);
    if (groupsSelectable) {
      const newGroupsSelected = __spreadValues({}, groupsSelected);
      Object.entries(groupsSelected).forEach((groupSelected) => {
        const [group, _] = groupSelected;
        newGroupsSelected[group].selected = newGroupsSelected[group].disabledOn;
      });
      setGroupsSelected(newGroupsSelected);
    }
  }, [onChange, groupsSelected, groupsSelectable, disabledOptionsOn]);
  const handleToggleSelectAll = useCallback4(() => {
    if (selectAll) {
      handleUnselectAll();
    } else {
      onChange([
        ...disabledOptionsOn.map((option) => option.value),
        ...enabledOptions.map((option) => option.value)
      ]);
      setSelectAll(true);
      if (groupsSelectable) {
        const newGroupsSelected = __spreadValues({}, groupsSelected);
        Object.entries(groupsSelected).forEach((groupSelected) => {
          const [group, _] = groupSelected;
          newGroupsSelected[group].selected = newGroupsSelected[group].disabledOn + newGroupsSelected[group].enabled;
        });
        setGroupsSelected(newGroupsSelected);
      }
    }
    setOpen(true);
  }, [
    enabledOptions,
    disabledOptionsOn,
    selectAll,
    groupsSelectable,
    groupsSelected,
    setOpen,
    onChange,
    handleUnselectAll
  ]);
  const handleToggleExpandGroup = useCallback4(
    (toggledGroup) => {
      let newExpandedGroups = [...expandedGroups];
      if (expandedGroups.includes(toggledGroup.value)) {
        newExpandedGroups = newExpandedGroups.filter(
          (value) => value !== toggledGroup.value
        );
      } else {
        newExpandedGroups.push(toggledGroup.value);
      }
      setExpandedGroups(newExpandedGroups);
      setCollapseAllGroups(newExpandedGroups.length === 0);
    },
    [expandedGroups]
  );
  const handleToggleExpandAllGroups = useCallback4(() => {
    if (collapseAllGroups) {
      setExpandedGroups(expandableGroups.map((group) => group.value));
      setCollapseAllGroups(false);
    } else {
      setExpandedGroups([]);
      setCollapseAllGroups(true);
    }
  }, [collapseAllGroups, expandableGroups]);
  const getGroupCheckedState = useCallback4(
    (group) => {
      if (group.name === NO_GROUP || !group.options || group.options.length === 0) {
        return false;
      }
      if (groupsSelected[group.value].selected === groupsSelected[group.value].allSize) {
        return true;
      }
      if (groupsSelected[group.value].selected === 0) {
        return false;
      }
      return "indeterminate";
    },
    [groupsSelected]
  );
  return {
    selectedOptionTypes,
    selectAll,
    selectAllSize,
    disabledOptionsOff,
    handleUnselect,
    handleUnselectAll,
    handleToggleSelect,
    handleToggleSelectAll,
    groups,
    groupsSelectable,
    collapseAllGroups,
    expandedGroups,
    handleToggleExpandGroup,
    handleToggleExpandAllGroups,
    getGroupCheckedState,
    handleUnselectGroup,
    handleToggleSelectGroup
  };
};
var selectedOptionTypesAsString = (groupsSelectable, selectedOptionTypes = []) => {
  if (!groupsSelectable) {
    return selectedOptionTypes.filter(isRequiredOption).map((option) => option.label).join(", ");
  }
  return selectedOptionTypes.map(
    (option) => isRequiredGroupOptions(option) ? option.name : option.label
  ).join(", ");
};
var multiSelectValueAsString = (optionTypes = [], selected = []) => {
  const { options, groups, groupsSelectable } = parseOptionTypes(optionTypes);
  const { initialGroupsSelected: groupsSelected } = parseGroupOptions(
    groups,
    selected,
    groupsSelectable
  );
  const selectedOptionTypes = getSelectedOptionTypes(
    options,
    selected,
    groupsSelectable,
    groups,
    groupsSelected
  );
  return selectedOptionTypesAsString(groupsSelectable, selectedOptionTypes);
};

// src/components/uturn-ui/select/multi-select.tsx
import { Fragment as Fragment4, jsx as jsx59, jsxs as jsxs30 } from "react/jsx-runtime";
var MultiSelectContext = createContext6(null);
var useMultiSelectContext = () => {
  const context = useContext6(MultiSelectContext);
  if (context == null) {
    throw new Error(
      "useMultiSelectContext must be used within a MultiSelectContext"
    );
  }
  return context;
};
var MultiSelectBadge = ({
  label,
  disabled = false,
  onUnselect
}) => {
  const { variant, maxItemLength } = useMultiSelectContext();
  const handleUnselect = () => {
    if (!disabled) {
      onUnselect();
    }
  };
  const truncated = maxItemLength && label.length > maxItemLength ? `${label.slice(0, maxItemLength)}...` : label;
  const badge = /* @__PURE__ */ jsxs30(Badge, { variant: disabled ? "secondary" : variant, onClick: handleUnselect, children: [
    truncated,
    !disabled && /* @__PURE__ */ jsx59(
      "div",
      {
        role: "button",
        tabIndex: 0,
        "aria-pressed": "false",
        className: cn(
          "ring-offset-background ml-1 rounded-full outline-none",
          "focus:ring-ring focus:ring-2 focus:ring-offset-2"
        ),
        onKeyDown: (event) => {
          if (event.key === "Enter") {
            handleUnselect();
          }
        },
        onMouseDown: (event) => {
          event.preventDefault();
          event.stopPropagation();
        },
        onClick: handleUnselect,
        children: /* @__PURE__ */ jsx59(XIcon2, { className: "size-4 shrink-0" })
      }
    )
  ] });
  if (truncated === label) {
    return badge;
  }
  return /* @__PURE__ */ jsxs30(Tooltip, { children: [
    /* @__PURE__ */ jsx59(TooltipTrigger, { className: "inline-flex", asChild: true, children: badge }),
    /* @__PURE__ */ jsx59(TooltipContent, { side: "bottom", align: "start", children: label })
  ] });
};
var MultiSelectTrigger = ({ ref }) => {
  const {
    open,
    selectedOptionTypes,
    selectAllSize,
    selectAllEnabled,
    groupsSelectable,
    disabled,
    maxDisplay,
    className,
    placeholder,
    beyondMaxDisplayLabel,
    closeTooltip,
    openTooltip,
    handleUnselect,
    handleUnselectGroup,
    badgesDisabled,
    handleUnselectAll,
    clearAllLabel,
    selected
  } = useMultiSelectContext();
  if (badgesDisabled) {
    return /* @__PURE__ */ jsx59(PopoverTrigger, { disabled, asChild: true, children: /* @__PURE__ */ jsx59(
      Button,
      {
        ref,
        variant: "outline",
        role: "combobox",
        "aria-expanded": open,
        className: cn(
          "w-full h-12 rounded-md border border-input [.theme-uturn_&]:rounded-md [.theme-uturn_&]:border-foreground",
          disabled && "opacity-75 cursor-not-allowed",
          className
        ),
        disabled,
        name: "selectButton",
        children: selectedOptionTypesAsString(groupsSelectable, selectedOptionTypes)
      }
    ) });
  }
  const selectedCollapsed = maxDisplay && selectedOptionTypes.length > maxDisplay ? selectedOptionTypes.length - maxDisplay : 0;
  const CollapseOptions = () => {
    return /* @__PURE__ */ jsxs30(Fragment4, { children: [
      selectedOptionTypes.slice(0, maxDisplay).map(
        (option) => isRequiredGroupOptions(option) ? /* @__PURE__ */ jsx59(
          MultiSelectBadge,
          {
            label: `${option.name} (${option.options.length})`,
            onUnselect: () => handleUnselectGroup(option)
          },
          option.name
        ) : /* @__PURE__ */ jsx59(
          MultiSelectBadge,
          {
            label: option.label,
            disabled: disabled || option.disabled,
            onUnselect: () => handleUnselect(option)
          },
          option.value
        )
      ),
      /* @__PURE__ */ jsxs30(Tooltip, { children: [
        /* @__PURE__ */ jsx59(TooltipTrigger, { className: "inline-flex", asChild: true, children: /* @__PURE__ */ jsxs30(
          "p",
          {
            className: cn(
              "text-muted-foreground text-xs leading-4",
              "py-0.5 px-0.5 my-auto",
              "rounded-md bg-secondary text-secondary-foreground"
            ),
            children: [
              "+",
              selectedCollapsed,
              " ",
              beyondMaxDisplayLabel
            ]
          }
        ) }),
        /* @__PURE__ */ jsx59(
          TooltipContent,
          {
            side: "bottom",
            align: "start",
            className: "flex flex-col items-start gap-1",
            children: selectedOptionTypes.slice(maxDisplay, selectAllSize - 1).map(
              (option) => isGroupOptions(option) ? /* @__PURE__ */ jsx59("p", { children: option.name }, option.name) : /* @__PURE__ */ jsx59("p", { children: option.label }, option.value)
            )
          }
        )
      ] })
    ] });
  };
  const ExpandOptions = () => {
    return selectedOptionTypes.map(
      (option) => isGroupOptions(option) ? /* @__PURE__ */ jsx59(
        MultiSelectBadge,
        {
          label: `${option.name} (${option.options.length})`,
          onUnselect: () => handleUnselectGroup(option)
        },
        option.name
      ) : /* @__PURE__ */ jsx59(
        MultiSelectBadge,
        {
          label: option.label,
          disabled: disabled || option.disabled,
          onUnselect: () => handleUnselect(option)
        },
        option.value
      )
    );
  };
  return /* @__PURE__ */ jsx59(PopoverTrigger, { disabled, asChild: true, children: /* @__PURE__ */ jsx59(
    Button,
    {
      ref,
      variant: "outline",
      role: "combobox",
      "aria-expanded": open,
      className: cn(
        "w-full justify-between",
        "transition-all [&[data-state=open]>svg]:rotate-180",
        "h-auto min-h-12 rounded-md border border-input [.theme-uturn_&]:rounded-md [.theme-uturn_&]:border-foreground",
        disabled && "opacity-75 cursor-not-allowed",
        className
      ),
      disabled,
      name: "selectButton",
      children: /* @__PURE__ */ jsxs30(TooltipProvider, { delayDuration: 300, children: [
        /* @__PURE__ */ jsxs30("div", { className: "flex flex-wrap gap-2", children: [
          !selectedOptionTypes.length && placeholder && /* @__PURE__ */ jsx59("p", { className: "text-muted-foreground truncate", children: placeholder }),
          selectedCollapsed > 0 ? /* @__PURE__ */ jsx59(CollapseOptions, {}) : /* @__PURE__ */ jsx59(ExpandOptions, {})
        ] }),
        !disabled && /* @__PURE__ */ jsxs30("span", { className: "flex items-center space-x-3", children: [
          selectAllEnabled && selected.length > 0 && /* @__PURE__ */ jsxs30(Tooltip, { children: [
            /* @__PURE__ */ jsx59(TooltipTrigger, { className: "inline-flex", asChild: true, children: /* @__PURE__ */ jsxs30("span", { children: [
              /* @__PURE__ */ jsx59(
                XIcon2,
                {
                  className: "size-4 shrink-0 opacity-50 hover:opacity-100 cursor-pointer",
                  onClick: (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    handleUnselectAll();
                  }
                }
              ),
              /* @__PURE__ */ jsx59(
                Separator3,
                {
                  className: "h-4 shrink-0 ml-2",
                  orientation: "vertical"
                }
              )
            ] }) }),
            /* @__PURE__ */ jsx59(TooltipContent, { side: "bottom", align: "start", children: clearAllLabel })
          ] }),
          /* @__PURE__ */ jsxs30(Tooltip, { children: [
            /* @__PURE__ */ jsx59(TooltipTrigger, { className: "inline-flex", asChild: true, children: /* @__PURE__ */ jsx59(
              ChevronDown5,
              {
                className: cn(
                  "size-4 shrink-0 opacity-50 transition-all duration-200 hover:opacity-100",
                  open && "transform rotate-180"
                )
              }
            ) }),
            /* @__PURE__ */ jsx59(TooltipContent, { side: "bottom", align: "start", children: open ? closeTooltip : openTooltip })
          ] })
        ] })
      ] })
    }
  ) });
};
var MultiSelectContent = ({ children }) => {
  const {
    emptyMessage,
    searchPlaceholder: placeholder,
    searchClassName: className,
    hideSearch,
    align,
    searchRef,
    searchValue,
    searchOnValueChange,
    searchOnSelect,
    filter
  } = useMultiSelectContext();
  return /* @__PURE__ */ jsx59(
    PopoverContent,
    {
      align,
      className: cn("w-[var(--radix-popover-trigger-width)] p-0", className),
      children: /* @__PURE__ */ jsxs30(Command, { filter, children: [
        !hideSearch && /* @__PURE__ */ jsx59(
          CommandInput,
          {
            placeholder,
            ref: searchRef,
            value: searchValue,
            onValueChange: searchOnValueChange,
            onSelect: searchOnSelect
          }
        ),
        /* @__PURE__ */ jsxs30(CommandList, { children: [
          /* @__PURE__ */ jsx59(CommandEmpty, { children: emptyMessage }),
          children
        ] })
      ] })
    }
  );
};
var MultiSelectHeader = () => {
  const {
    selected,
    selectAll,
    selectAllEnabled,
    disabledOptionsOff,
    selectAllLabel,
    clearAllLabel,
    variant,
    hideSelectedOptions,
    handleToggleSelectAll,
    groupsSelectable,
    expandAllTooltip,
    collapseAllTooltip,
    collapseAllGroups,
    handleToggleExpandAllGroups
  } = useMultiSelectContext();
  if (!selectAllEnabled && !groupsSelectable) {
    return null;
  }
  let label = selectAllLabel;
  let checked = false;
  if (selectAll) {
    checked = true;
    label = clearAllLabel;
  } else if (selected.length === 0) {
    checked = false;
  } else {
    checked = "indeterminate";
  }
  const showSeparator = !(hideSelectedOptions && selectAll && disabledOptionsOff.length === 0);
  return /* @__PURE__ */ jsxs30(CommandGroup, { children: [
    /* @__PURE__ */ jsxs30("div", { className: "flex items-center justify-between", children: [
      selectAllEnabled && /* @__PURE__ */ jsxs30(
        CommandItem,
        {
          onSelect: handleToggleSelectAll,
          className: "flex-1 cursor-pointer",
          children: [
            /* @__PURE__ */ jsx59(
              Checkbox,
              {
                className: cn(
                  "outline-background mr-2",
                  getCheckboxClassName(checked, variant)
                ),
                checked
              }
            ),
            "(",
            label,
            ")"
          ]
        }
      ),
      groupsSelectable && /* @__PURE__ */ jsxs30(
        CommandItem,
        {
          onSelect: handleToggleExpandAllGroups,
          className: cn(
            "w-8",
            // 'w-32',
            "flex-none justify-end cursor-pointer"
          ),
          children: [
            /* @__PURE__ */ jsx59(
              "span",
              {
                className: cn(
                  "opacity-0 shrink-0 grow-1 text-right text-nowrap",
                  "transition-all duration-300",
                  "hover:text-right hover:opacity-50 hover:ease-in-out hover:-translate-x-4"
                ),
                children: collapseAllGroups ? expandAllTooltip : collapseAllTooltip
              }
            ),
            collapseAllGroups ? /* @__PURE__ */ jsx59(ListTree, { className: "size-4 shrink-0 opacity-50 hover:opacity-100" }) : /* @__PURE__ */ jsx59(ListCollapse, { className: "size-4 shrink-0 opacity-50 hover:opacity-100" })
          ]
        }
      )
    ] }),
    showSeparator && /* @__PURE__ */ jsx59(CommandSeparator, { className: "mt-1" })
  ] });
};
var MultiSelectFooter = () => {
  const {
    selectAll,
    selectAllEnabled,
    selectAllLabel,
    clearAllLabel,
    closeTooltip,
    setOpen,
    handleToggleSelectAll
  } = useMultiSelectContext();
  if (clearAllLabel !== "") {
    return null;
  }
  return /* @__PURE__ */ jsxs30(Fragment4, { children: [
    /* @__PURE__ */ jsx59(CommandSeparator, {}),
    /* @__PURE__ */ jsx59(CommandGroup, { children: /* @__PURE__ */ jsxs30("div", { className: "flex items-center justify-between", children: [
      selectAllEnabled && /* @__PURE__ */ jsxs30(Fragment4, { children: [
        /* @__PURE__ */ jsx59(
          CommandItem,
          {
            onSelect: handleToggleSelectAll,
            className: "flex-1 justify-center cursor-pointer",
            children: selectAll ? clearAllLabel : selectAllLabel
          }
        ),
        /* @__PURE__ */ jsx59(
          Separator3,
          {
            orientation: "vertical",
            className: "flex min-h-6 h-full"
          }
        )
      ] }),
      /* @__PURE__ */ jsx59(
        CommandItem,
        {
          onSelect: () => setOpen(false),
          className: "flex-1 justify-center cursor-pointer max-w-full",
          children: closeTooltip
        }
      )
    ] }) })
  ] });
};
var MultiSelectGroup = ({ children, group }) => {
  const {
    variant,
    getGroupCheckedState,
    handleToggleSelectGroup,
    expandedGroups,
    handleToggleExpandGroup
  } = useMultiSelectContext();
  if (group.name === NO_GROUP) {
    return /* @__PURE__ */ jsx59(CommandGroup, { children });
  }
  const checked = getGroupCheckedState(group);
  const disabled = group.options.length === 0;
  return /* @__PURE__ */ jsxs30(CommandGroup, { children: [
    /* @__PURE__ */ jsxs30("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ jsxs30(
        CommandItem,
        {
          onSelect: () => handleToggleSelectGroup(group),
          disabled,
          className: "flex-1 cursor-pointer",
          children: [
            /* @__PURE__ */ jsx59(
              Checkbox,
              {
                className: cn("mr-2", getCheckboxClassName(checked, variant)),
                checked,
                disabled
              }
            ),
            group.name
          ]
        }
      ),
      group.options.length > 0 && /* @__PURE__ */ jsx59(
        CommandItem,
        {
          onSelect: () => handleToggleExpandGroup(group),
          className: "cursor-pointer",
          children: /* @__PURE__ */ jsx59(
            ChevronDown5,
            {
              className: cn(
                "size-4 shrink-0 opacity-50 hover:opacity-100",
                "transition-all duration-200",
                expandedGroups.includes(group.value) && "transform -rotate-180"
              )
            }
          )
        }
      )
    ] }),
    children
  ] });
};
var MultiSelectOption = ({
  option,
  parentGroup
}) => {
  const {
    selected,
    variant,
    hideDisabledOptions,
    hideSelectedOptions,
    maxCount,
    alignCheck,
    handleToggleSelect
  } = useMultiSelectContext();
  if (hideDisabledOptions && option.disabled) {
    return null;
  }
  const checked = selected.includes(option.value);
  if (hideSelectedOptions && checked) {
    return null;
  }
  const CheckSymbol = ({
    side,
    disabled: disabled2
  }) => {
    if (alignCheck !== side) {
      return null;
    }
    if (side === "start") {
      return /* @__PURE__ */ jsx59(
        Checkbox,
        {
          className: cn("mr-2", getCheckboxClassName(checked, variant)),
          checked,
          disabled: disabled2
        }
      );
    }
    return /* @__PURE__ */ jsx59(
      Check5,
      {
        className: cn("ml-auto size-4", checked ? "opacity-75" : "opacity-0")
      }
    );
  };
  const disabled = (option == null ? void 0 : option.disabled) || !checked && maxCount !== void 0 && selected.length >= maxCount;
  return /* @__PURE__ */ jsxs30(
    CommandItem,
    {
      onSelect: () => handleToggleSelect(option),
      disabled,
      children: [
        parentGroup.name !== NO_GROUP && /* @__PURE__ */ jsx59("span", { className: "ml-4" }),
        /* @__PURE__ */ jsx59(CheckSymbol, { disabled, side: "start" }),
        option.label,
        /* @__PURE__ */ jsx59(CheckSymbol, { disabled, side: "end" })
      ]
    }
  );
};
var MultiSelect = forwardRef34(
  function MultiSelect2({
    options: optionTypes,
    selected = [],
    onChange,
    open: providedOpen,
    setOpen: providedSetOpen,
    // Configuration
    disabled = false,
    hideDisabledOptions = true,
    hideSelectedOptions = false,
    hideSearch = false,
    maxDisplay,
    maxItemLength,
    maxCount,
    selectAllEnabled = false,
    badgesDisabled = false,
    modal = false,
    // Styles
    className,
    searchClassName,
    variant = "default",
    align = "center",
    alignCheck = "start",
    // Labels
    placeholder: placeholderProp,
    emptyMessage: emptyMessageProp,
    searchPlaceholder: searchPlaceholderProp,
    selectAllLabel: selectAllLabelProp,
    clearAllLabel: clearAllLabelProp,
    beyondMaxDisplayLabel: beyondMaxDisplayLabelProp,
    expandAllTooltip: expandAllTooltipProp,
    collapseAllTooltip: collapseAllTooltipProp,
    closeTooltip: closeTooltipProp,
    openTooltip: openTooltipProp,
    // Searching
    searchRef,
    searchValue,
    searchOnValueChange,
    searchOnSelect,
    filter = (label, search) => label.toLowerCase().includes(search.toLowerCase()) ? 1 : 0
  }, ref) {
    const { t } = useTranslation5();
    const placeholder = placeholderProp != null ? placeholderProp : t("general.select-input.placeholder", "Select an option");
    const emptyMessage = emptyMessageProp != null ? emptyMessageProp : t("general.select-input.no-results", "No results found.");
    const searchPlaceholder = searchPlaceholderProp != null ? searchPlaceholderProp : t("general.select-input.search-placeholder", "Type to search");
    const selectAllLabel = selectAllLabelProp != null ? selectAllLabelProp : t("general.select-input.select-all", "Select all");
    const clearAllLabel = clearAllLabelProp != null ? clearAllLabelProp : t("general.select-input.clear-all", "Clear all");
    const beyondMaxDisplayLabel = beyondMaxDisplayLabelProp != null ? beyondMaxDisplayLabelProp : t("general.select-input.more", "more");
    const expandAllTooltip = expandAllTooltipProp != null ? expandAllTooltipProp : t("general.select-input.expand-all", "Expand All");
    const collapseAllTooltip = collapseAllTooltipProp != null ? collapseAllTooltipProp : t("general.select-input.collapse-all", "Collapse All");
    const closeTooltip = closeTooltipProp != null ? closeTooltipProp : t("general.select-input.close", "Close");
    const openTooltip = openTooltipProp != null ? openTooltipProp : t("general.select-input.open", "Open");
    const [open, setOpen] = useState10(false);
    const {
      selectedOptionTypes,
      selectAll,
      selectAllSize,
      disabledOptionsOff,
      handleUnselect,
      handleUnselectAll,
      handleToggleSelect,
      handleToggleSelectAll,
      groups,
      groupsSelectable,
      collapseAllGroups,
      expandedGroups,
      handleToggleExpandGroup,
      handleToggleExpandAllGroups,
      handleUnselectGroup,
      handleToggleSelectGroup,
      getGroupCheckedState
    } = useMultiSelect(
      optionTypes,
      selected,
      onChange,
      providedSetOpen != null ? providedSetOpen : setOpen,
      alignCheck
    );
    return /* @__PURE__ */ jsx59(
      MultiSelectContext,
      {
        value: {
          open: providedOpen != null ? providedOpen : open,
          setOpen: providedSetOpen != null ? providedSetOpen : setOpen,
          selected,
          selectedOptionTypes,
          selectAll,
          selectAllSize,
          disabledOptionsOff,
          handleUnselect,
          handleUnselectAll,
          handleToggleSelect,
          handleToggleSelectAll,
          // Configuration
          disabled,
          hideDisabledOptions,
          hideSelectedOptions,
          hideSearch,
          maxDisplay,
          maxItemLength,
          maxCount,
          selectAllEnabled,
          badgesDisabled,
          // Styles
          className,
          searchClassName,
          variant,
          align,
          alignCheck,
          // Labels
          placeholder,
          emptyMessage,
          searchPlaceholder,
          selectAllLabel,
          clearAllLabel,
          beyondMaxDisplayLabel,
          expandAllTooltip,
          collapseAllTooltip,
          closeTooltip,
          openTooltip,
          // Searching
          searchRef,
          searchValue,
          searchOnValueChange,
          searchOnSelect,
          filter,
          // Groups
          groupsSelectable,
          collapseAllGroups,
          expandedGroups,
          handleToggleExpandGroup,
          handleToggleExpandAllGroups,
          handleUnselectGroup,
          handleToggleSelectGroup,
          getGroupCheckedState
        },
        children: /* @__PURE__ */ jsxs30(
          Popover,
          {
            open: providedOpen != null ? providedOpen : open,
            onOpenChange: providedSetOpen != null ? providedSetOpen : setOpen,
            modal,
            children: [
              /* @__PURE__ */ jsx59(MultiSelectTrigger, { ref }),
              /* @__PURE__ */ jsxs30(MultiSelectContent, { children: [
                /* @__PURE__ */ jsx59(MultiSelectHeader, {}),
                groups.map((group) => /* @__PURE__ */ jsx59(
                  MultiSelectGroup,
                  {
                    group,
                    children: (group.name === NO_GROUP || expandedGroups.includes(group.value)) && group.options.map((option) => /* @__PURE__ */ jsx59(
                      MultiSelectOption,
                      {
                        option,
                        parentGroup: group
                      },
                      `multi-select-option-${group.value}-${option.value}`
                    ))
                  },
                  `multi-select-group-${group.value}`
                )),
                /* @__PURE__ */ jsx59(MultiSelectFooter, {})
              ] })
            ]
          }
        )
      }
    );
  }
);
MultiSelect.displayName = "MultiSelect";

// src/components/uturn-ui/select/multi-select-badge.tsx
import { jsxs as jsxs31 } from "react/jsx-runtime";
function MultiSelectBadge2({
  label,
  removeValue,
  removeIcon,
  disableRemoveValue
}) {
  return /* @__PURE__ */ jsxs31(
    Badge,
    {
      className: "mr-2 flex items-center gap-1",
      onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (disableRemoveValue) {
          return;
        }
        removeValue();
      },
      children: [
        label,
        !disableRemoveValue && removeIcon
      ]
    }
  );
}

// src/components/uturn-ui/stars/ratings.tsx
import { faStar as faStar2 } from "@fortawesome/pro-solid-svg-icons";
import { useState as useState11 } from "react";
import { twMerge as twMerge4 } from "tailwind-merge";

// src/components/uturn-ui/stars/stars.tsx
import { faStar } from "@fortawesome/pro-solid-svg-icons";
import { cva as cva11 } from "class-variance-authority";
import { jsx as jsx60 } from "react/jsx-runtime";
var starVariants = cva11(
  "flex-shrink-0 stroke-foreground text-background [stroke-width:32px]",
  {
    variants: {
      size: {
        default: "h-5 w-5",
        xs: "h-3 w-3",
        sm: "h-4 w-4",
        lg: "h-7 w-7"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
);
function Stars({ rating, size, className }) {
  return /* @__PURE__ */ jsx60("div", { className: cn("flex items-center", className), children: [0, 1, 2, 3, 4].map((index) => /* @__PURE__ */ jsx60(
    Icon,
    {
      icon: faStar,
      className: cn(
        starVariants({
          size,
          className: rating > index && "text-primary"
        })
      ),
      "aria-hidden": "true"
    },
    index
  )) });
}

// src/components/uturn-ui/stars/ratings.tsx
import { jsx as jsx61, jsxs as jsxs32 } from "react/jsx-runtime";
function Ratings(_a) {
  var _b = _a, { value, disabled = false } = _b, props = __objRest(_b, ["value", "disabled"]);
  const [rating, setRating] = useState11(Number(value));
  const [hover, setHover] = useState11(void 0);
  if (disabled) {
    return /* @__PURE__ */ jsx61(Stars, { rating: value });
  }
  return /* @__PURE__ */ jsx61("div", __spreadProps(__spreadValues({ className: "flex items-center" }, props), { children: [0, 1, 2, 3, 4].map((index) => {
    return /* @__PURE__ */ jsxs32("label", { children: [
      /* @__PURE__ */ jsx61(
        "input",
        {
          type: "radio",
          name: "rating",
          value: index + 1,
          className: "hidden",
          onClick: () => setRating(index + 1)
        }
      ),
      /* @__PURE__ */ jsx61(
        Icon,
        {
          icon: faStar2,
          "aria-hidden": "true",
          onMouseEnter: () => setHover(index + 1),
          onMouseLeave: () => setHover(void 0),
          className: twMerge4(
            "h-5 w-5 flex-shrink-0 text-muted-foreground/30",
            index < (hover != null ? hover : rating) && "text-primary"
          )
        }
      )
    ] }, `label-${index}`);
  }) }));
}

// src/components/index.ts
__reExport(components_exports, uturn_ui_exports);

// src/index.ts
__reExport(index_exports, components_exports);

// src/hooks/use-seasonal-logo.ts
import { DatesUtils } from "@uturn/utilities/browser";
import { useMemo as useMemo4 } from "react";
function useSeasonalLogo() {
  return useMemo4(() => {
    const variant = DatesUtils.getSeasonalVariant();
    const isSeasonal = variant !== "default";
    return { variant, isSeasonal };
  }, []);
}
export {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  AgGridReact,
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger,
  AutoComplete,
  Avatar,
  AvatarFallback,
  AvatarImage,
  AverageLine,
  Badge,
  BrandLoader,
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Calendar,
  Callout,
  CalloutIcon,
  CalloutTitle,
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  Chart,
  ChartCustomTooltip,
  Checkbox,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  Combobox,
  Command,
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
  CommandShortcut,
  CopyToClipboard,
  DATETIME_HINT,
  DATE_HINT,
  DatePicker,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
  Dropzone,
  DropzoneContent,
  DropzoneEmptyState,
  EmptyState,
  Form,
  FormCheckboxGroupItem,
  FormControl,
  FormDescription,
  FormField,
  FormFieldReadOnly,
  FormItem,
  FormLabel,
  FormMessage,
  FormRadioGroupHorizontalItem,
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
  Icon,
  Input,
  InputAddon,
  Label2 as Label,
  LicenseManager,
  Logo,
  ModeToggle,
  money_cell_default as MoneyCell,
  MultiSelect,
  MultiSelectBadge2 as MultiSelectBadge,
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuIndicator,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  NavigationMenuViewport,
  Pagination,
  PaginationCompact,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
  Popover,
  PopoverAnchor,
  PopoverContent,
  PopoverTrigger,
  Progress,
  RadioGroup2 as RadioGroup,
  RadioGroupItem,
  Ratings,
  ScrollArea,
  ScrollBar,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
  Separator3 as Separator,
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetOverlay,
  SheetPortal,
  SheetTitle,
  SheetTrigger,
  Skeleton,
  Sonner,
  Stars,
  Status,
  StatusIndicator,
  StatusLabel,
  Switch,
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Textarea,
  ThemeProvider,
  Toast,
  ToastAction,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  Toaster2 as Toaster,
  Toggle,
  ToggleGroup,
  ToggleGroupItem,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  agColIdSchema,
  agFilterModelSchema,
  agSortModelItemSchema,
  badgeVariants,
  buttonVariants,
  cn,
  cva3 as cva,
  debug,
  defaultInitials,
  format,
  getRandomColor,
  isDateFilterModel,
  isRequiredGroupOptions as isGroupOptions,
  isIMultiFilterModel,
  isNumberFilterModel,
  isRequiredOption as isOption,
  isSetFilterModel,
  isTextFilterModel,
  multiSelectValueAsString,
  navigationMenuTriggerStyle,
  reducer,
  selectedOptionTypesAsString,
  sonner,
  tabTriggerActiveClass,
  toast,
  toggleVariants,
  useFormField,
  useMultiSelect,
  useSeasonalLogo,
  useTheme,
  useToast
};
//# sourceMappingURL=index.js.map